var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLatestContributionsBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1220,
    height: 770,
    viewBox: "0 0 1220 770",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_307_174109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160 132L168 140H242L250 132L258 140H332L340 132L348 140H422L430 132L438 140H512L520 132L528 140H602L610 132L618 140H692L700 132L708 140H782L790 132L798 140H872L880 132L888 140H962L970 132L978 140H1052L1060 132L1068 140H1080V152L1088 160L1080 168V242L1088 250L1080 258V332L1088 340L1080 348V422L1088 430L1080 438V512L1088 520L1080 528V602L1088 610L1080 618V630H1068L1060 638L1052 630H978L970 638L962 630H888L880 638L872 630H798L790 638L782 630H708L700 638L692 630H618L610 638L602 630H528L520 638L512 630H438L430 638L422 630H348L340 638L332 630H258L250 638L242 630H168L160 638L152 630H140L140 618L132 610L140 602L140 528L132 520L140 512L140 438L132 430L140 422L140 348L132 340L140 332L140 258L132 250L140 242L140 168L132 160L140 152L140 140H152L160 132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 132L168 140H242L250 132L258 140H332L340 132L348 140H422L430 132L438 140H512L520 132L528 140H602L610 132L618 140H692L700 132L708 140H782L790 132L798 140H872L880 132L888 140H962L970 132L978 140H1052L1060 132L1068 140H1080V152L1088 160L1080 168V242L1088 250L1080 258V332L1088 340L1080 348V422L1088 430L1080 438V512L1088 520L1080 528V602L1088 610L1080 618V630H1068L1060 638L1052 630H978L970 638L962 630H888L880 638L872 630H798L790 638L782 630H708L700 638L692 630H618L610 638L602 630H528L520 638L512 630H438L430 638L422 630H348L340 638L332 630H258L250 638L242 630H168L160 638L152 630H140L140 618L132 610L140 602L140 528L132 520L140 512L140 438L132 430L140 422L140 348L132 340L140 332L140 258L132 250L140 242L140 168L132 160L140 152L140 140H152L160 132Z",
    stroke: "#3A4682",
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1192 703L1190 700",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.5 701C1193.94 701 1193.38 700.718 1193 700L1196 700C1195.63 700.718 1195.06 701 1194.5 701Z",
    fill: "#3A4682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1192 697L1190 700",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.5 699C1193.94 699 1193.37 699.282 1193 700L1196 700C1195.62 699.282 1195.06 699 1194.5 699Z",
    fill: "#3A4682"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1219 700L1190 700",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 615.23L1089.39 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 612.615L1189.96 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 615.387C1169.45 615.387 1170.54 614.184 1170.54 612.929C1170.54 612.607 1170.51 612.257 1170.42 611.932C1170.52 612.375 1170.42 612.746 1170.38 612.929C1170.23 613.818 1169.29 614.132 1168.35 614.132C1167.42 614.132 1167.26 615.387 1168.35 615.387Z",
    fill: "#3A4682"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 611.36C1170.61 612.04 1170.43 612.671 1170.38 612.929C1170.23 613.818 1169.29 614.132 1168.35 614.132C1167.42 614.132 1167.26 615.387 1168.35 615.387C1169.45 615.387 1170.54 614.184 1170.54 612.929C1170.54 611.958 1170.23 610.732 1169.03 610.732C1168.67 610.732 1168.2 610.628 1166.64 611.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 613.87L1126.14 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 611.046C1194.33 611.046 1193.7 610.751 1193.29 610L1196.62 610C1196.2 610.751 1195.58 611.046 1194.95 611.046Z",
    fill: "#3A4682"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 611.046C1137.07 611.046 1136.45 610.751 1136.03 610L1139.36 610C1138.95 610.751 1138.32 611.046 1137.7 611.046Z",
    fill: "#3A4682"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 611.046C1128.12 611.046 1127.49 610.751 1127.08 610L1130.41 610C1129.99 610.751 1129.37 611.046 1128.74 611.046Z",
    fill: "#3A4682"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 611.046C1122.91 611.046 1122.29 610.751 1121.87 610L1125.2 610C1124.79 610.751 1124.16 611.046 1123.54 611.046Z",
    fill: "#3A4682"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 612.51C1096.5 612.511 1095.17 611.802 1094.29 610L1101.37 610C1100.48 611.802 1099.15 612.51 1097.83 612.51Z",
    fill: "#3A4682"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 612.929L1126.14 614.707L1126.14 613.134L1126.14 611.151L1127.49 612.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 612.929L1126.14 614.707L1126.14 613.134L1126.14 611.151L1124.79 612.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 614.934L1094.6 615.23L1092.1 612.72L1092.39 614.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 611.046C1111.98 611.046 1111.36 610.751 1110.94 610L1114.27 610C1113.86 610.751 1113.23 611.046 1112.61 611.046Z",
    fill: "#3A4682"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 616.59L1158.52 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 614.812L1158.52 616.59L1158.52 615.017L1158.52 613.033L1159.87 614.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 611.883L1163.36 614.236L1166.5 611.883C1165.58 612.472 1165.22 612.86 1163.36 612.86C1161.5 612.86 1160.86 612.3 1160.18 611.883Z",
    fill: "#3A4682"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 611.778L1166.5 611.883M1166.5 611.883L1163.36 614.236L1160.18 611.883C1160.86 612.3 1161.5 612.86 1163.36 612.86C1165.22 612.86 1165.58 612.472 1166.5 611.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 610C1158.74 610.384 1159.39 611.297 1160.18 611.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 616.59L1154.77 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 614.812L1154.77 616.59L1154.77 615.017L1154.77 613.033L1153.42 614.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 611.883L1149.93 614.236L1146.79 611.883C1147.71 612.472 1148.07 612.86 1149.93 612.86C1151.79 612.86 1152.43 612.3 1153.1 611.883Z",
    fill: "#3A4682"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 611.778L1146.79 611.883M1146.79 611.883L1149.93 614.236L1153.1 611.883C1152.43 612.3 1151.79 612.86 1149.93 612.86C1148.07 612.86 1147.71 612.472 1146.79 611.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 610C1154.54 610.384 1153.9 611.297 1153.1 611.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 611.569C1162.47 611.569 1161.54 611.127 1160.91 610L1165.91 610C1165.28 611.127 1164.35 611.569 1163.41 611.569Z",
    fill: "#3A4682"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 604.77L1089.39 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 607.385L1189.96 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 604.613C1169.45 604.613 1170.54 605.816 1170.54 607.071C1170.54 607.393 1170.51 607.743 1170.42 608.068C1170.52 607.625 1170.42 607.254 1170.38 607.071C1170.23 606.182 1169.29 605.868 1168.35 605.868C1167.42 605.868 1167.26 604.613 1168.35 604.613Z",
    fill: "#3A4682"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 608.64C1170.61 607.96 1170.43 607.329 1170.38 607.071C1170.23 606.182 1169.29 605.868 1168.35 605.868C1167.42 605.868 1167.26 604.613 1168.35 604.613C1169.45 604.613 1170.54 605.816 1170.54 607.071C1170.54 608.042 1170.23 609.268 1169.03 609.268C1168.67 609.268 1168.2 609.372 1166.64 608.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 606.13L1126.14 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 608.954C1194.33 608.954 1193.7 609.249 1193.29 610L1196.62 610C1196.2 609.249 1195.58 608.954 1194.95 608.954Z",
    fill: "#3A4682"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 608.954C1137.07 608.954 1136.45 609.249 1136.03 610L1139.36 610C1138.95 609.249 1138.32 608.954 1137.7 608.954Z",
    fill: "#3A4682"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 608.954C1128.12 608.954 1127.49 609.249 1127.08 610L1130.41 610C1129.99 609.249 1129.37 608.954 1128.74 608.954Z",
    fill: "#3A4682"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 608.954C1122.91 608.954 1122.29 609.249 1121.87 610L1125.2 610C1124.79 609.249 1124.16 608.954 1123.54 608.954Z",
    fill: "#3A4682"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 607.49C1096.5 607.489 1095.17 608.198 1094.29 610L1101.37 610C1100.48 608.198 1099.15 607.49 1097.83 607.49Z",
    fill: "#3A4682"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 607.071L1126.14 605.293L1126.14 606.866L1126.14 608.849L1127.49 607.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 607.071L1126.14 605.293L1126.14 606.866L1126.14 608.849L1124.79 607.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 605.066L1094.6 604.77L1092.1 607.28L1092.39 605.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 608.954C1111.98 608.954 1111.36 609.249 1110.94 610L1114.27 610C1113.86 609.249 1113.23 608.954 1112.61 608.954Z",
    fill: "#3A4682"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 603.41L1158.52 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 605.188L1158.52 603.41L1158.52 604.983L1158.52 606.967L1159.87 605.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 608.117L1163.36 605.764L1166.5 608.117C1165.58 607.528 1165.22 607.14 1163.36 607.14C1161.5 607.14 1160.86 607.7 1160.18 608.117Z",
    fill: "#3A4682"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 608.222L1166.5 608.117M1166.5 608.117L1163.36 605.764L1160.18 608.117C1160.86 607.7 1161.5 607.14 1163.36 607.14C1165.22 607.14 1165.58 607.528 1166.5 608.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 610C1158.74 609.616 1159.39 608.703 1160.18 608.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 603.41L1154.77 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 605.188L1154.77 603.41L1154.77 604.983L1154.77 606.967L1153.42 605.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 608.117L1149.93 605.764L1146.79 608.117C1147.71 607.528 1148.07 607.14 1149.93 607.14C1151.79 607.14 1152.43 607.7 1153.1 608.117Z",
    fill: "#3A4682"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 608.222L1146.79 608.117M1146.79 608.117L1149.93 605.764L1153.1 608.117C1152.43 607.7 1151.79 607.14 1149.93 607.14C1148.07 607.14 1147.71 607.528 1146.79 608.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 610C1154.54 609.616 1153.9 608.703 1153.1 608.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 608.431C1162.47 608.431 1161.54 608.873 1160.91 610L1165.91 610C1165.28 608.873 1164.35 608.431 1163.41 608.431Z",
    fill: "#3A4682"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.88 610L1218.95 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.39 610L1087.73 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 525.23L1089.39 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 522.615L1189.96 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 525.387C1169.45 525.387 1170.54 524.184 1170.54 522.929C1170.54 522.607 1170.51 522.257 1170.42 521.932C1170.52 522.375 1170.42 522.746 1170.38 522.929C1170.23 523.818 1169.29 524.132 1168.35 524.132C1167.42 524.132 1167.26 525.387 1168.35 525.387Z",
    fill: "#3A4682"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 521.36C1170.61 522.04 1170.43 522.671 1170.38 522.929C1170.23 523.818 1169.29 524.132 1168.35 524.132C1167.42 524.132 1167.26 525.387 1168.35 525.387C1169.45 525.387 1170.54 524.184 1170.54 522.929C1170.54 521.958 1170.23 520.732 1169.03 520.732C1168.67 520.732 1168.2 520.628 1166.64 521.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 523.87L1126.14 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 521.046C1194.33 521.046 1193.7 520.751 1193.29 520L1196.62 520C1196.2 520.751 1195.58 521.046 1194.95 521.046Z",
    fill: "#3A4682"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 521.046C1137.07 521.046 1136.45 520.751 1136.03 520L1139.36 520C1138.95 520.751 1138.32 521.046 1137.7 521.046Z",
    fill: "#3A4682"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 521.046C1128.12 521.046 1127.49 520.751 1127.08 520L1130.41 520C1129.99 520.751 1129.37 521.046 1128.74 521.046Z",
    fill: "#3A4682"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 521.046C1122.91 521.046 1122.29 520.751 1121.87 520L1125.2 520C1124.79 520.751 1124.16 521.046 1123.54 521.046Z",
    fill: "#3A4682"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 522.51C1096.5 522.511 1095.17 521.802 1094.29 520L1101.37 520C1100.48 521.802 1099.15 522.51 1097.83 522.51Z",
    fill: "#3A4682"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 522.929L1126.14 524.707L1126.14 523.134L1126.14 521.151L1127.49 522.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 522.929L1126.14 524.707L1126.14 523.134L1126.14 521.151L1124.79 522.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 524.934L1094.6 525.23L1092.1 522.72L1092.39 524.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 521.046C1111.98 521.046 1111.36 520.751 1110.94 520L1114.27 520C1113.86 520.751 1113.23 521.046 1112.61 521.046Z",
    fill: "#3A4682"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 526.59L1158.52 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 524.812L1158.52 526.59L1158.52 525.017L1158.52 523.033L1159.87 524.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 521.883L1163.36 524.236L1166.5 521.883C1165.58 522.472 1165.22 522.86 1163.36 522.86C1161.5 522.86 1160.86 522.3 1160.18 521.883Z",
    fill: "#3A4682"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 521.778L1166.5 521.883M1166.5 521.883L1163.36 524.236L1160.18 521.883C1160.86 522.3 1161.5 522.86 1163.36 522.86C1165.22 522.86 1165.58 522.472 1166.5 521.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 520C1158.74 520.384 1159.39 521.297 1160.18 521.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 526.59L1154.77 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 524.812L1154.77 526.59L1154.77 525.017L1154.77 523.033L1153.42 524.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 521.883L1149.93 524.236L1146.79 521.883C1147.71 522.472 1148.07 522.86 1149.93 522.86C1151.79 522.86 1152.43 522.3 1153.1 521.883Z",
    fill: "#3A4682"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 521.778L1146.79 521.883M1146.79 521.883L1149.93 524.236L1153.1 521.883C1152.43 522.3 1151.79 522.86 1149.93 522.86C1148.07 522.86 1147.71 522.472 1146.79 521.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 520C1154.54 520.384 1153.9 521.297 1153.1 521.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 521.569C1162.47 521.569 1161.54 521.127 1160.91 520L1165.91 520C1165.28 521.127 1164.35 521.569 1163.41 521.569Z",
    fill: "#3A4682"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 514.77L1089.39 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 517.385L1189.96 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 514.613C1169.45 514.613 1170.54 515.816 1170.54 517.071C1170.54 517.393 1170.51 517.743 1170.42 518.068C1170.52 517.625 1170.42 517.254 1170.38 517.071C1170.23 516.182 1169.29 515.868 1168.35 515.868C1167.42 515.868 1167.26 514.613 1168.35 514.613Z",
    fill: "#3A4682"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 518.64C1170.61 517.96 1170.43 517.329 1170.38 517.071C1170.23 516.182 1169.29 515.868 1168.35 515.868C1167.42 515.868 1167.26 514.613 1168.35 514.613C1169.45 514.613 1170.54 515.816 1170.54 517.071C1170.54 518.042 1170.23 519.268 1169.03 519.268C1168.67 519.268 1168.2 519.372 1166.64 518.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 516.13L1126.14 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 518.954C1194.33 518.954 1193.7 519.249 1193.29 520L1196.62 520C1196.2 519.249 1195.58 518.954 1194.95 518.954Z",
    fill: "#3A4682"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 518.954C1137.07 518.954 1136.45 519.249 1136.03 520L1139.36 520C1138.95 519.249 1138.32 518.954 1137.7 518.954Z",
    fill: "#3A4682"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 518.954C1128.12 518.954 1127.49 519.249 1127.08 520L1130.41 520C1129.99 519.249 1129.37 518.954 1128.74 518.954Z",
    fill: "#3A4682"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 518.954C1122.91 518.954 1122.29 519.249 1121.87 520L1125.2 520C1124.79 519.249 1124.16 518.954 1123.54 518.954Z",
    fill: "#3A4682"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 517.49C1096.5 517.489 1095.17 518.198 1094.29 520L1101.37 520C1100.48 518.198 1099.15 517.49 1097.83 517.49Z",
    fill: "#3A4682"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 517.071L1126.14 515.293L1126.14 516.866L1126.14 518.849L1127.49 517.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 517.071L1126.14 515.293L1126.14 516.866L1126.14 518.849L1124.79 517.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 515.066L1094.6 514.77L1092.1 517.28L1092.39 515.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 518.954C1111.98 518.954 1111.36 519.249 1110.94 520L1114.27 520C1113.86 519.249 1113.23 518.954 1112.61 518.954Z",
    fill: "#3A4682"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 513.41L1158.52 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 515.188L1158.52 513.41L1158.52 514.983L1158.52 516.967L1159.87 515.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 518.117L1163.36 515.764L1166.5 518.117C1165.58 517.528 1165.22 517.14 1163.36 517.14C1161.5 517.14 1160.86 517.7 1160.18 518.117Z",
    fill: "#3A4682"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 518.222L1166.5 518.117M1166.5 518.117L1163.36 515.764L1160.18 518.117C1160.86 517.7 1161.5 517.14 1163.36 517.14C1165.22 517.14 1165.58 517.528 1166.5 518.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 520C1158.74 519.616 1159.39 518.703 1160.18 518.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 513.41L1154.77 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 515.188L1154.77 513.41L1154.77 514.983L1154.77 516.967L1153.42 515.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 518.117L1149.93 515.764L1146.79 518.117C1147.71 517.528 1148.07 517.14 1149.93 517.14C1151.79 517.14 1152.43 517.7 1153.1 518.117Z",
    fill: "#3A4682"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 518.222L1146.79 518.117M1146.79 518.117L1149.93 515.764L1153.1 518.117C1152.43 517.7 1151.79 517.14 1149.93 517.14C1148.07 517.14 1147.71 517.528 1146.79 518.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 520C1154.54 519.616 1153.9 518.703 1153.1 518.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 518.431C1162.47 518.431 1161.54 518.873 1160.91 520L1165.91 520C1165.28 518.873 1164.35 518.431 1163.41 518.431Z",
    fill: "#3A4682"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.88 520L1218.95 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.39 520L1087.73 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 435.23L1089.39 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 432.615L1189.96 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 435.387C1169.45 435.387 1170.54 434.184 1170.54 432.929C1170.54 432.607 1170.51 432.257 1170.42 431.932C1170.52 432.375 1170.42 432.746 1170.38 432.929C1170.23 433.818 1169.29 434.132 1168.35 434.132C1167.42 434.132 1167.26 435.387 1168.35 435.387Z",
    fill: "#3A4682"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 431.36C1170.61 432.04 1170.43 432.671 1170.38 432.929C1170.23 433.818 1169.29 434.132 1168.35 434.132C1167.42 434.132 1167.26 435.387 1168.35 435.387C1169.45 435.387 1170.54 434.184 1170.54 432.929C1170.54 431.958 1170.23 430.732 1169.03 430.732C1168.67 430.732 1168.2 430.628 1166.64 431.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 433.87L1126.14 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 431.046C1194.33 431.046 1193.7 430.751 1193.29 430L1196.62 430C1196.2 430.751 1195.58 431.046 1194.95 431.046Z",
    fill: "#3A4682"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 431.046C1137.07 431.046 1136.45 430.751 1136.03 430L1139.36 430C1138.95 430.751 1138.32 431.046 1137.7 431.046Z",
    fill: "#3A4682"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 431.046C1128.12 431.046 1127.49 430.751 1127.08 430L1130.41 430C1129.99 430.751 1129.37 431.046 1128.74 431.046Z",
    fill: "#3A4682"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 431.046C1122.91 431.046 1122.29 430.751 1121.87 430L1125.2 430C1124.79 430.751 1124.16 431.046 1123.54 431.046Z",
    fill: "#3A4682"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 432.51C1096.5 432.511 1095.17 431.802 1094.29 430L1101.37 430C1100.48 431.802 1099.15 432.51 1097.83 432.51Z",
    fill: "#3A4682"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 432.929L1126.14 434.707L1126.14 433.134L1126.14 431.151L1127.49 432.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 432.929L1126.14 434.707L1126.14 433.134L1126.14 431.151L1124.79 432.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 434.934L1094.6 435.23L1092.1 432.72L1092.39 434.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 431.046C1111.98 431.046 1111.36 430.751 1110.94 430L1114.27 430C1113.86 430.751 1113.23 431.046 1112.61 431.046Z",
    fill: "#3A4682"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 436.59L1158.52 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 434.812L1158.52 436.59L1158.52 435.017L1158.52 433.033L1159.87 434.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 431.883L1163.36 434.236L1166.5 431.883C1165.58 432.472 1165.22 432.86 1163.36 432.86C1161.5 432.86 1160.86 432.3 1160.18 431.883Z",
    fill: "#3A4682"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 431.778L1166.5 431.883M1166.5 431.883L1163.36 434.236L1160.18 431.883C1160.86 432.3 1161.5 432.86 1163.36 432.86C1165.22 432.86 1165.58 432.472 1166.5 431.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 430C1158.74 430.384 1159.39 431.297 1160.18 431.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 436.59L1154.77 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 434.812L1154.77 436.59L1154.77 435.017L1154.77 433.033L1153.42 434.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 431.883L1149.93 434.236L1146.79 431.883C1147.71 432.472 1148.07 432.86 1149.93 432.86C1151.79 432.86 1152.43 432.3 1153.1 431.883Z",
    fill: "#3A4682"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 431.778L1146.79 431.883M1146.79 431.883L1149.93 434.236L1153.1 431.883C1152.43 432.3 1151.79 432.86 1149.93 432.86C1148.07 432.86 1147.71 432.472 1146.79 431.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 430C1154.54 430.384 1153.9 431.297 1153.1 431.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 431.569C1162.47 431.569 1161.54 431.127 1160.91 430L1165.91 430C1165.28 431.127 1164.35 431.569 1163.41 431.569Z",
    fill: "#3A4682"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 424.77L1089.39 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 427.385L1189.96 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 424.613C1169.45 424.613 1170.54 425.816 1170.54 427.071C1170.54 427.393 1170.51 427.743 1170.42 428.068C1170.52 427.625 1170.42 427.254 1170.38 427.071C1170.23 426.182 1169.29 425.868 1168.35 425.868C1167.42 425.868 1167.26 424.613 1168.35 424.613Z",
    fill: "#3A4682"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 428.64C1170.61 427.96 1170.43 427.329 1170.38 427.071C1170.23 426.182 1169.29 425.868 1168.35 425.868C1167.42 425.868 1167.26 424.613 1168.35 424.613C1169.45 424.613 1170.54 425.816 1170.54 427.071C1170.54 428.042 1170.23 429.268 1169.03 429.268C1168.67 429.268 1168.2 429.372 1166.64 428.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 426.13L1126.14 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 428.954C1194.33 428.954 1193.7 429.249 1193.29 430L1196.62 430C1196.2 429.249 1195.58 428.954 1194.95 428.954Z",
    fill: "#3A4682"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 428.954C1137.07 428.954 1136.45 429.249 1136.03 430L1139.36 430C1138.95 429.249 1138.32 428.954 1137.7 428.954Z",
    fill: "#3A4682"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 428.954C1128.12 428.954 1127.49 429.249 1127.08 430L1130.41 430C1129.99 429.249 1129.37 428.954 1128.74 428.954Z",
    fill: "#3A4682"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 428.954C1122.91 428.954 1122.29 429.249 1121.87 430L1125.2 430C1124.79 429.249 1124.16 428.954 1123.54 428.954Z",
    fill: "#3A4682"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 427.49C1096.5 427.489 1095.17 428.198 1094.29 430L1101.37 430C1100.48 428.198 1099.15 427.49 1097.83 427.49Z",
    fill: "#3A4682"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 427.071L1126.14 425.293L1126.14 426.866L1126.14 428.849L1127.49 427.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 427.071L1126.14 425.293L1126.14 426.866L1126.14 428.849L1124.79 427.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 425.066L1094.6 424.77L1092.1 427.28L1092.39 425.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 428.954C1111.98 428.954 1111.36 429.249 1110.94 430L1114.27 430C1113.86 429.249 1113.23 428.954 1112.61 428.954Z",
    fill: "#3A4682"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 423.41L1158.52 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 425.188L1158.52 423.41L1158.52 424.983L1158.52 426.967L1159.87 425.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 428.117L1163.36 425.764L1166.5 428.117C1165.58 427.528 1165.22 427.14 1163.36 427.14C1161.5 427.14 1160.86 427.7 1160.18 428.117Z",
    fill: "#3A4682"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 428.222L1166.5 428.117M1166.5 428.117L1163.36 425.764L1160.18 428.117C1160.86 427.7 1161.5 427.14 1163.36 427.14C1165.22 427.14 1165.58 427.528 1166.5 428.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 430C1158.74 429.616 1159.39 428.703 1160.18 428.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 423.41L1154.77 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 425.188L1154.77 423.41L1154.77 424.983L1154.77 426.967L1153.42 425.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 428.117L1149.93 425.764L1146.79 428.117C1147.71 427.528 1148.07 427.14 1149.93 427.14C1151.79 427.14 1152.43 427.7 1153.1 428.117Z",
    fill: "#3A4682"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 428.222L1146.79 428.117M1146.79 428.117L1149.93 425.764L1153.1 428.117C1152.43 427.7 1151.79 427.14 1149.93 427.14C1148.07 427.14 1147.71 427.528 1146.79 428.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 430C1154.54 429.616 1153.9 428.703 1153.1 428.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 428.431C1162.47 428.431 1161.54 428.873 1160.91 430L1165.91 430C1165.28 428.873 1164.35 428.431 1163.41 428.431Z",
    fill: "#3A4682"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.88 430L1218.95 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.39 430L1087.73 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 345.23L1089.39 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 342.615L1189.96 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 345.387C1169.45 345.387 1170.54 344.184 1170.54 342.929C1170.54 342.607 1170.51 342.257 1170.42 341.932C1170.52 342.375 1170.42 342.746 1170.38 342.929C1170.23 343.818 1169.29 344.132 1168.35 344.132C1167.42 344.132 1167.26 345.387 1168.35 345.387Z",
    fill: "#3A4682"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 341.36C1170.61 342.04 1170.43 342.671 1170.38 342.929C1170.23 343.818 1169.29 344.132 1168.35 344.132C1167.42 344.132 1167.26 345.387 1168.35 345.387C1169.45 345.387 1170.54 344.184 1170.54 342.929C1170.54 341.958 1170.23 340.732 1169.03 340.732C1168.67 340.732 1168.2 340.628 1166.64 341.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 343.87L1126.14 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 341.046C1194.33 341.046 1193.7 340.751 1193.29 340L1196.62 340C1196.2 340.751 1195.58 341.046 1194.95 341.046Z",
    fill: "#3A4682"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 341.046C1137.07 341.046 1136.45 340.751 1136.03 340L1139.36 340C1138.95 340.751 1138.32 341.046 1137.7 341.046Z",
    fill: "#3A4682"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 341.046C1128.12 341.046 1127.49 340.751 1127.08 340L1130.41 340C1129.99 340.751 1129.37 341.046 1128.74 341.046Z",
    fill: "#3A4682"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 341.046C1122.91 341.046 1122.29 340.751 1121.87 340L1125.2 340C1124.79 340.751 1124.16 341.046 1123.54 341.046Z",
    fill: "#3A4682"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 342.51C1096.5 342.511 1095.17 341.802 1094.29 340L1101.37 340C1100.48 341.802 1099.15 342.51 1097.83 342.51Z",
    fill: "#3A4682"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 342.929L1126.14 344.707L1126.14 343.134L1126.14 341.151L1127.49 342.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 342.929L1126.14 344.707L1126.14 343.134L1126.14 341.151L1124.79 342.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 344.934L1094.6 345.23L1092.1 342.72L1092.39 344.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 341.046C1111.98 341.046 1111.36 340.751 1110.94 340L1114.27 340C1113.86 340.751 1113.23 341.046 1112.61 341.046Z",
    fill: "#3A4682"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 346.59L1158.52 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 344.812L1158.52 346.59L1158.52 345.017L1158.52 343.033L1159.87 344.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 341.883L1163.36 344.236L1166.5 341.883C1165.58 342.472 1165.22 342.86 1163.36 342.86C1161.5 342.86 1160.86 342.3 1160.18 341.883Z",
    fill: "#3A4682"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 341.778L1166.5 341.883M1166.5 341.883L1163.36 344.236L1160.18 341.883C1160.86 342.3 1161.5 342.86 1163.36 342.86C1165.22 342.86 1165.58 342.472 1166.5 341.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 340C1158.74 340.384 1159.39 341.297 1160.18 341.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 346.59L1154.77 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 344.812L1154.77 346.59L1154.77 345.017L1154.77 343.033L1153.42 344.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 341.883L1149.93 344.236L1146.79 341.883C1147.71 342.472 1148.07 342.86 1149.93 342.86C1151.79 342.86 1152.43 342.3 1153.1 341.883Z",
    fill: "#3A4682"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 341.778L1146.79 341.883M1146.79 341.883L1149.93 344.236L1153.1 341.883C1152.43 342.3 1151.79 342.86 1149.93 342.86C1148.07 342.86 1147.71 342.472 1146.79 341.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 340C1154.54 340.384 1153.9 341.297 1153.1 341.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 341.569C1162.47 341.569 1161.54 341.127 1160.91 340L1165.91 340C1165.28 341.127 1164.35 341.569 1163.41 341.569Z",
    fill: "#3A4682"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 334.77L1089.39 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 337.385L1189.96 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 334.613C1169.45 334.613 1170.54 335.816 1170.54 337.071C1170.54 337.393 1170.51 337.743 1170.42 338.068C1170.52 337.625 1170.42 337.254 1170.38 337.071C1170.23 336.182 1169.29 335.868 1168.35 335.868C1167.42 335.868 1167.26 334.613 1168.35 334.613Z",
    fill: "#3A4682"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 338.64C1170.61 337.96 1170.43 337.329 1170.38 337.071C1170.23 336.182 1169.29 335.868 1168.35 335.868C1167.42 335.868 1167.26 334.613 1168.35 334.613C1169.45 334.613 1170.54 335.816 1170.54 337.071C1170.54 338.042 1170.23 339.268 1169.03 339.268C1168.67 339.268 1168.2 339.372 1166.64 338.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 336.13L1126.14 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 338.954C1194.33 338.954 1193.7 339.249 1193.29 340L1196.62 340C1196.2 339.249 1195.58 338.954 1194.95 338.954Z",
    fill: "#3A4682"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 338.954C1137.07 338.954 1136.45 339.249 1136.03 340L1139.36 340C1138.95 339.249 1138.32 338.954 1137.7 338.954Z",
    fill: "#3A4682"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 338.954C1128.12 338.954 1127.49 339.249 1127.08 340L1130.41 340C1129.99 339.249 1129.37 338.954 1128.74 338.954Z",
    fill: "#3A4682"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 338.954C1122.91 338.954 1122.29 339.249 1121.87 340L1125.2 340C1124.79 339.249 1124.16 338.954 1123.54 338.954Z",
    fill: "#3A4682"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 337.49C1096.5 337.489 1095.17 338.198 1094.29 340L1101.37 340C1100.48 338.198 1099.15 337.49 1097.83 337.49Z",
    fill: "#3A4682"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 337.071L1126.14 335.293L1126.14 336.866L1126.14 338.849L1127.49 337.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 337.071L1126.14 335.293L1126.14 336.866L1126.14 338.849L1124.79 337.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 335.066L1094.6 334.77L1092.1 337.28L1092.39 335.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 338.954C1111.98 338.954 1111.36 339.249 1110.94 340L1114.27 340C1113.86 339.249 1113.23 338.954 1112.61 338.954Z",
    fill: "#3A4682"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 333.41L1158.52 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 335.188L1158.52 333.41L1158.52 334.983L1158.52 336.967L1159.87 335.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 338.117L1163.36 335.764L1166.5 338.117C1165.58 337.528 1165.22 337.14 1163.36 337.14C1161.5 337.14 1160.86 337.7 1160.18 338.117Z",
    fill: "#3A4682"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 338.222L1166.5 338.117M1166.5 338.117L1163.36 335.764L1160.18 338.117C1160.86 337.7 1161.5 337.14 1163.36 337.14C1165.22 337.14 1165.58 337.528 1166.5 338.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 340C1158.74 339.616 1159.39 338.703 1160.18 338.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 333.41L1154.77 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 335.188L1154.77 333.41L1154.77 334.983L1154.77 336.967L1153.42 335.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 338.117L1149.93 335.764L1146.79 338.117C1147.71 337.528 1148.07 337.14 1149.93 337.14C1151.79 337.14 1152.43 337.7 1153.1 338.117Z",
    fill: "#3A4682"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 338.222L1146.79 338.117M1146.79 338.117L1149.93 335.764L1153.1 338.117C1152.43 337.7 1151.79 337.14 1149.93 337.14C1148.07 337.14 1147.71 337.528 1146.79 338.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 340C1154.54 339.616 1153.9 338.703 1153.1 338.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 338.431C1162.47 338.431 1161.54 338.873 1160.91 340L1165.91 340C1165.28 338.873 1164.35 338.431 1163.41 338.431Z",
    fill: "#3A4682"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.88 340L1218.95 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.39 340L1087.73 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 255.23L1089.39 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 252.615L1189.96 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 255.387C1169.45 255.387 1170.54 254.184 1170.54 252.929C1170.54 252.607 1170.51 252.257 1170.42 251.932C1170.52 252.375 1170.42 252.746 1170.38 252.929C1170.23 253.818 1169.29 254.132 1168.35 254.132C1167.42 254.132 1167.26 255.387 1168.35 255.387Z",
    fill: "#3A4682"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 251.36C1170.61 252.04 1170.43 252.671 1170.38 252.929C1170.23 253.818 1169.29 254.132 1168.35 254.132C1167.42 254.132 1167.26 255.387 1168.35 255.387C1169.45 255.387 1170.54 254.184 1170.54 252.929C1170.54 251.958 1170.23 250.732 1169.03 250.732C1168.67 250.732 1168.2 250.628 1166.64 251.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 253.87L1126.14 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 251.046C1194.33 251.046 1193.7 250.751 1193.29 250L1196.62 250C1196.2 250.751 1195.58 251.046 1194.95 251.046Z",
    fill: "#3A4682"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 251.046C1137.07 251.046 1136.45 250.751 1136.03 250L1139.36 250C1138.95 250.751 1138.32 251.046 1137.7 251.046Z",
    fill: "#3A4682"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 251.046C1128.12 251.046 1127.49 250.751 1127.08 250L1130.41 250C1129.99 250.751 1129.37 251.046 1128.74 251.046Z",
    fill: "#3A4682"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 251.046C1122.91 251.046 1122.29 250.751 1121.87 250L1125.2 250C1124.79 250.751 1124.16 251.046 1123.54 251.046Z",
    fill: "#3A4682"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 252.51C1096.5 252.511 1095.17 251.802 1094.29 250L1101.37 250C1100.48 251.802 1099.15 252.51 1097.83 252.51Z",
    fill: "#3A4682"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 252.929L1126.14 254.707L1126.14 253.134L1126.14 251.151L1127.49 252.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 252.929L1126.14 254.707L1126.14 253.134L1126.14 251.151L1124.79 252.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 254.934L1094.6 255.23L1092.1 252.72L1092.39 254.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 251.046C1111.98 251.046 1111.36 250.751 1110.94 250L1114.27 250C1113.86 250.751 1113.23 251.046 1112.61 251.046Z",
    fill: "#3A4682"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 256.59L1158.52 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 254.812L1158.52 256.59L1158.52 255.017L1158.52 253.033L1159.87 254.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 251.883L1163.36 254.236L1166.5 251.883C1165.58 252.472 1165.22 252.86 1163.36 252.86C1161.5 252.86 1160.86 252.3 1160.18 251.883Z",
    fill: "#3A4682"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 251.778L1166.5 251.883M1166.5 251.883L1163.36 254.236L1160.18 251.883C1160.86 252.3 1161.5 252.86 1163.36 252.86C1165.22 252.86 1165.58 252.472 1166.5 251.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 250C1158.74 250.384 1159.39 251.297 1160.18 251.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 256.59L1154.77 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 254.812L1154.77 256.59L1154.77 255.017L1154.77 253.033L1153.42 254.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 251.883L1149.93 254.236L1146.79 251.883C1147.71 252.472 1148.07 252.86 1149.93 252.86C1151.79 252.86 1152.43 252.3 1153.1 251.883Z",
    fill: "#3A4682"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 251.778L1146.79 251.883M1146.79 251.883L1149.93 254.236L1153.1 251.883C1152.43 252.3 1151.79 252.86 1149.93 252.86C1148.07 252.86 1147.71 252.472 1146.79 251.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 250C1154.54 250.384 1153.9 251.297 1153.1 251.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 251.569C1162.47 251.569 1161.54 251.127 1160.91 250L1165.91 250C1165.28 251.127 1164.35 251.569 1163.41 251.569Z",
    fill: "#3A4682"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 244.77L1089.39 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 247.385L1189.96 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 244.613C1169.45 244.613 1170.54 245.816 1170.54 247.071C1170.54 247.393 1170.51 247.743 1170.42 248.068C1170.52 247.625 1170.42 247.254 1170.38 247.071C1170.23 246.182 1169.29 245.868 1168.35 245.868C1167.42 245.868 1167.26 244.613 1168.35 244.613Z",
    fill: "#3A4682"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 248.64C1170.61 247.96 1170.43 247.329 1170.38 247.071C1170.23 246.182 1169.29 245.868 1168.35 245.868C1167.42 245.868 1167.26 244.613 1168.35 244.613C1169.45 244.613 1170.54 245.816 1170.54 247.071C1170.54 248.042 1170.23 249.268 1169.03 249.268C1168.67 249.268 1168.2 249.372 1166.64 248.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 246.13L1126.14 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 248.954C1194.33 248.954 1193.7 249.249 1193.29 250L1196.62 250C1196.2 249.249 1195.58 248.954 1194.95 248.954Z",
    fill: "#3A4682"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 248.954C1137.07 248.954 1136.45 249.249 1136.03 250L1139.36 250C1138.95 249.249 1138.32 248.954 1137.7 248.954Z",
    fill: "#3A4682"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 248.954C1128.12 248.954 1127.49 249.249 1127.08 250L1130.41 250C1129.99 249.249 1129.37 248.954 1128.74 248.954Z",
    fill: "#3A4682"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 248.954C1122.91 248.954 1122.29 249.249 1121.87 250L1125.2 250C1124.79 249.249 1124.16 248.954 1123.54 248.954Z",
    fill: "#3A4682"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 247.49C1096.5 247.489 1095.17 248.198 1094.29 250L1101.37 250C1100.48 248.198 1099.15 247.49 1097.83 247.49Z",
    fill: "#3A4682"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 247.071L1126.14 245.293L1126.14 246.866L1126.14 248.849L1127.49 247.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 247.071L1126.14 245.293L1126.14 246.866L1126.14 248.849L1124.79 247.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 245.066L1094.6 244.77L1092.1 247.28L1092.39 245.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 248.954C1111.98 248.954 1111.36 249.249 1110.94 250L1114.27 250C1113.86 249.249 1113.23 248.954 1112.61 248.954Z",
    fill: "#3A4682"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 243.41L1158.52 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 245.188L1158.52 243.41L1158.52 244.983L1158.52 246.967L1159.87 245.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 248.117L1163.36 245.764L1166.5 248.117C1165.58 247.528 1165.22 247.14 1163.36 247.14C1161.5 247.14 1160.86 247.7 1160.18 248.117Z",
    fill: "#3A4682"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 248.222L1166.5 248.117M1166.5 248.117L1163.36 245.764L1160.18 248.117C1160.86 247.7 1161.5 247.14 1163.36 247.14C1165.22 247.14 1165.58 247.528 1166.5 248.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 250C1158.74 249.616 1159.39 248.703 1160.18 248.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 243.41L1154.77 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 245.188L1154.77 243.41L1154.77 244.983L1154.77 246.967L1153.42 245.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 248.117L1149.93 245.764L1146.79 248.117C1147.71 247.528 1148.07 247.14 1149.93 247.14C1151.79 247.14 1152.43 247.7 1153.1 248.117Z",
    fill: "#3A4682"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 248.222L1146.79 248.117M1146.79 248.117L1149.93 245.764L1153.1 248.117C1152.43 247.7 1151.79 247.14 1149.93 247.14C1148.07 247.14 1147.71 247.528 1146.79 248.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 250C1154.54 249.616 1153.9 248.703 1153.1 248.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 248.431C1162.47 248.431 1161.54 248.873 1160.91 250L1165.91 250C1165.28 248.873 1164.35 248.431 1163.41 248.431Z",
    fill: "#3A4682"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.88 250L1218.95 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.39 250L1087.73 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 165.23L1089.39 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 162.615L1189.96 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 165.387C1169.45 165.387 1170.54 164.184 1170.54 162.929C1170.54 162.607 1170.51 162.257 1170.42 161.932C1170.52 162.375 1170.42 162.746 1170.38 162.929C1170.23 163.818 1169.29 164.132 1168.35 164.132C1167.42 164.132 1167.26 165.387 1168.35 165.387Z",
    fill: "#3A4682"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 161.36C1170.61 162.04 1170.43 162.671 1170.38 162.929C1170.23 163.818 1169.29 164.132 1168.35 164.132C1167.42 164.132 1167.26 165.387 1168.35 165.387C1169.45 165.387 1170.54 164.184 1170.54 162.929C1170.54 161.958 1170.23 160.732 1169.03 160.732C1168.67 160.732 1168.2 160.628 1166.64 161.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 163.87L1126.14 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 161.046C1194.33 161.046 1193.7 160.751 1193.29 160L1196.62 160C1196.2 160.751 1195.58 161.046 1194.95 161.046Z",
    fill: "#3A4682"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 161.046C1137.07 161.046 1136.45 160.751 1136.03 160L1139.36 160C1138.95 160.751 1138.32 161.046 1137.7 161.046Z",
    fill: "#3A4682"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 161.046C1128.12 161.046 1127.49 160.751 1127.08 160L1130.41 160C1129.99 160.751 1129.37 161.046 1128.74 161.046Z",
    fill: "#3A4682"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 161.046C1122.91 161.046 1122.29 160.751 1121.87 160L1125.2 160C1124.79 160.751 1124.16 161.046 1123.54 161.046Z",
    fill: "#3A4682"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 162.51C1096.5 162.511 1095.17 161.802 1094.29 160L1101.37 160C1100.48 161.802 1099.15 162.51 1097.83 162.51Z",
    fill: "#3A4682"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 162.929L1126.14 164.707L1126.14 163.134L1126.14 161.151L1127.49 162.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 162.929L1126.14 164.707L1126.14 163.134L1126.14 161.151L1124.79 162.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 164.934L1094.6 165.23L1092.1 162.72L1092.39 164.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 161.046C1111.98 161.046 1111.36 160.751 1110.94 160L1114.27 160C1113.86 160.751 1113.23 161.046 1112.61 161.046Z",
    fill: "#3A4682"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 166.59L1158.52 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 164.812L1158.52 166.59L1158.52 165.017L1158.52 163.033L1159.87 164.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 161.883L1163.36 164.236L1166.5 161.883C1165.58 162.472 1165.22 162.86 1163.36 162.86C1161.5 162.86 1160.86 162.3 1160.18 161.883Z",
    fill: "#3A4682"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 161.778L1166.5 161.883M1166.5 161.883L1163.36 164.236L1160.18 161.883C1160.86 162.3 1161.5 162.86 1163.36 162.86C1165.22 162.86 1165.58 162.472 1166.5 161.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 160C1158.74 160.384 1159.39 161.297 1160.18 161.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 166.59L1154.77 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 164.812L1154.77 166.59L1154.77 165.017L1154.77 163.033L1153.42 164.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 161.883L1149.93 164.236L1146.79 161.883C1147.71 162.472 1148.07 162.86 1149.93 162.86C1151.79 162.86 1152.43 162.3 1153.1 161.883Z",
    fill: "#3A4682"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 161.778L1146.79 161.883M1146.79 161.883L1149.93 164.236L1153.1 161.883C1152.43 162.3 1151.79 162.86 1149.93 162.86C1148.07 162.86 1147.71 162.472 1146.79 161.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 160C1154.54 160.384 1153.9 161.297 1153.1 161.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 161.569C1162.47 161.569 1161.54 161.127 1160.91 160L1165.91 160C1165.28 161.127 1164.35 161.569 1163.41 161.569Z",
    fill: "#3A4682"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.6 154.77L1089.39 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.93 157.385L1189.96 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.35 154.613C1169.45 154.613 1170.54 155.816 1170.54 157.071C1170.54 157.393 1170.51 157.743 1170.42 158.068C1170.52 157.625 1170.42 157.254 1170.38 157.071C1170.23 156.182 1169.29 155.868 1168.35 155.868C1167.42 155.868 1167.26 154.613 1168.35 154.613Z",
    fill: "#3A4682"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.18 158.64C1170.61 157.96 1170.43 157.329 1170.38 157.071C1170.23 156.182 1169.29 155.868 1168.35 155.868C1167.42 155.868 1167.26 154.613 1168.35 154.613C1169.45 154.613 1170.54 155.816 1170.54 157.071C1170.54 158.042 1170.23 159.268 1169.03 159.268C1168.67 159.268 1168.2 159.372 1166.64 158.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.14 156.13L1126.14 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.95 158.954C1194.33 158.954 1193.7 159.249 1193.29 160L1196.62 160C1196.2 159.249 1195.58 158.954 1194.95 158.954Z",
    fill: "#3A4682"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.7 158.954C1137.07 158.954 1136.45 159.249 1136.03 160L1139.36 160C1138.95 159.249 1138.32 158.954 1137.7 158.954Z",
    fill: "#3A4682"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.74 158.954C1128.12 158.954 1127.49 159.249 1127.08 160L1130.41 160C1129.99 159.249 1129.37 158.954 1128.74 158.954Z",
    fill: "#3A4682"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.54 158.954C1122.91 158.954 1122.29 159.249 1121.87 160L1125.2 160C1124.79 159.249 1124.16 158.954 1123.54 158.954Z",
    fill: "#3A4682"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.83 157.49C1096.5 157.489 1095.17 158.198 1094.29 160L1101.37 160C1100.48 158.198 1099.15 157.49 1097.83 157.49Z",
    fill: "#3A4682"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.49 157.071L1126.14 155.293L1126.14 156.866L1126.14 158.849L1127.49 157.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.79 157.071L1126.14 155.293L1126.14 156.866L1126.14 158.849L1124.79 157.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.39 155.066L1094.6 154.77L1092.1 157.28L1092.39 155.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.61 158.954C1111.98 158.954 1111.36 159.249 1110.94 160L1114.27 160C1113.86 159.249 1113.23 158.954 1112.61 158.954Z",
    fill: "#3A4682"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 153.41L1158.52 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.87 155.188L1158.52 153.41L1158.52 154.983L1158.52 156.967L1159.87 155.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.18 158.117L1163.36 155.764L1166.5 158.117C1165.58 157.528 1165.22 157.14 1163.36 157.14C1161.5 157.14 1160.86 157.7 1160.18 158.117Z",
    fill: "#3A4682"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.64 158.222L1166.5 158.117M1166.5 158.117L1163.36 155.764L1160.18 158.117C1160.86 157.7 1161.5 157.14 1163.36 157.14C1165.22 157.14 1165.58 157.528 1166.5 158.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.52 160C1158.74 159.616 1159.39 158.703 1160.18 158.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 153.41L1154.77 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.42 155.188L1154.77 153.41L1154.77 154.983L1154.77 156.967L1153.42 155.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M1153.1 158.117L1149.93 155.764L1146.79 158.117C1147.71 157.528 1148.07 157.14 1149.93 157.14C1151.79 157.14 1152.43 157.7 1153.1 158.117Z",
    fill: "#3A4682"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.65 158.222L1146.79 158.117M1146.79 158.117L1149.93 155.764L1153.1 158.117C1152.43 157.7 1151.79 157.14 1149.93 157.14C1148.07 157.14 1147.71 157.528 1146.79 158.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.77 160C1154.54 159.616 1153.9 158.703 1153.1 158.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.41 158.431C1162.47 158.431 1161.54 158.873 1160.91 160L1165.91 160C1165.28 158.873 1164.35 158.431 1163.41 158.431Z",
    fill: "#3A4682"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.88 160L1218.95 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.39 160L1087.73 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M1080 140L1080 152L1088 160L1080 168L1080 242L1088 250L1080 258L1080 332L1088 340L1080 348L1080 422L1088 430L1080 438L1080 512L1088 520L1080 528L1080 602L1088 610L1080 618L1080 630",
    stroke: "#3A4682",
    strokeLinecap: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M1192 73L1190 70",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.5 71C1193.94 71 1193.38 70.718 1193 70L1196 70C1195.63 70.718 1195.06 71 1194.5 71Z",
    fill: "#3A4682"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M1192 67L1190 70",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.5 69C1193.94 69 1193.37 69.282 1193 70L1196 70C1195.62 69.282 1195.06 69 1194.5 69Z",
    fill: "#3A4682"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M1219 70L1190 70",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.12 46.2208C1164.21 45.1276 1166.5 45.2375 1167.76 46.4928C1168.08 46.815 1168.4 47.1996 1168.63 47.6135C1168.29 47.0713 1167.82 46.7996 1167.6 46.649C1166.56 45.916 1165.31 46.5391 1164.37 47.4761C1163.43 48.4131 1162.02 47.3139 1163.12 46.2208Z",
    fill: "#3A4682"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.96 48.4264C1168.72 47.3142 1167.91 46.8613 1167.6 46.649C1166.56 45.916 1165.31 46.5391 1164.37 47.4761C1163.43 48.4131 1162.02 47.3139 1163.12 46.2208C1164.21 45.1276 1166.5 45.2375 1167.76 46.4928C1168.73 47.4637 1169.64 49.002 1168.45 50.1992C1168.08 50.5636 1167.72 51.1367 1165.01 51.5476",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.07 54.8561L1158.66 61.4465",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.21 55.281L1152.07 54.8561L1153.65 56.4293L1155.63 58.4128L1155.21 55.281Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.45 57.8978L1159.27 52.3687L1164.76 51.5826C1163.25 51.9142 1162.5 51.8881 1160.65 53.7458C1158.79 55.6034 1158.7 56.8074 1158.45 57.8978Z",
    fill: "#3A4682"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.01 51.5476L1164.76 51.5826M1164.76 51.5826L1159.27 52.3687L1158.45 57.8978C1158.7 56.8074 1158.79 55.6034 1160.65 53.7458C1162.5 51.8881 1163.25 51.9142 1164.76 51.5826Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.66 61.4466C1158.51 60.8374 1158.24 59.2749 1158.45 57.8979",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.33 58.6041L1154.92 65.1946",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.75 61.7359L1148.33 58.6041L1149.9 60.1773L1151.88 62.1609L1148.75 61.7359Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.37 64.9773L1145.84 65.7989L1145.05 71.2925C1145.39 69.7827 1145.36 69.0336 1147.22 67.1759C1149.08 65.3182 1150.28 65.2335 1151.37 64.9773Z",
    fill: "#3A4682"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.02 71.5366L1145.05 71.2925M1145.05 71.2925L1145.84 65.7989L1151.37 64.9773C1150.28 65.2335 1149.08 65.3182 1147.22 67.1759C1145.36 69.0336 1145.39 69.7827 1145.05 71.2925Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.92 65.1945C1154.31 65.0365 1152.75 64.7719 1151.37 64.9773",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.99 54.9844C1161.05 55.9214 1160.56 57.3009 1161.06 59.0522L1166.06 54.0549C1164.31 53.553 1162.93 54.0474 1161.99 54.9844Z",
    fill: "#3A4682"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.89 56.9955C1174.98 55.9023 1174.87 53.6061 1173.62 52.3508C1173.29 52.0287 1172.91 51.7128 1172.5 51.4783C1173.04 51.8219 1173.31 52.2922 1173.46 52.507C1174.19 53.5523 1173.57 54.8032 1172.63 55.7401C1171.7 56.6771 1172.8 58.0886 1173.89 56.9955Z",
    fill: "#3A4682"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.68 51.1461C1172.79 51.3938 1173.25 52.2042 1173.46 52.507C1174.19 53.5523 1173.57 54.8032 1172.63 55.7401C1171.7 56.6771 1172.8 58.0886 1173.89 56.9955C1174.98 55.9023 1174.87 53.6061 1173.62 52.3508C1172.65 51.38 1171.11 50.4663 1169.91 51.6636C1169.55 52.028 1168.97 52.3919 1168.56 55.1042",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.25 68.0367L1158.66 61.4463",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.83 64.905L1165.25 68.0367L1163.68 66.4636L1161.7 64.48L1164.83 64.905Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.21 61.6636L1167.74 60.842L1168.53 55.3484C1168.2 56.8582 1168.22 57.6073 1166.36 59.465C1164.51 61.3227 1163.3 61.4074 1162.21 61.6636Z",
    fill: "#3A4682"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.56 55.1042L1168.53 55.3484M1168.53 55.3484L1167.74 60.842L1162.21 61.6636C1163.3 61.4074 1164.51 61.3227 1166.36 59.465C1168.22 57.6073 1168.2 56.8582 1168.53 55.3484Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.66 61.4464C1159.27 61.6044 1160.84 61.869 1162.21 61.6636",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.51 71.7848L1154.92 65.1944",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.37 71.3598L1161.51 71.7848L1159.93 70.2116L1157.95 68.228L1158.37 71.3598Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.13 68.7431L1154.31 74.2721L1148.82 75.0583C1150.33 74.7266 1151.08 74.7528 1152.93 72.8951C1154.79 71.0374 1154.88 69.8335 1155.13 68.7431Z",
    fill: "#3A4682"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.57 75.0932L1148.82 75.0583M1148.82 75.0583L1154.31 74.2721L1155.13 68.7431C1154.88 69.8335 1154.79 71.0374 1152.93 72.8951C1151.08 74.7528 1150.33 74.7266 1148.82 75.0583Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.92 65.1943C1155.07 65.8034 1155.34 67.366 1155.13 68.743",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.13 58.1224C1164.19 59.0593 1162.81 59.5538 1161.06 59.0518L1166.06 54.0546C1166.56 55.8058 1166.06 57.1854 1165.13 58.1224Z",
    fill: "#3A4682"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.54 25.421L1191.03 28.9803",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.59 29.4738L1191.03 28.98",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.23 24.2368C1193.77 24.6981 1193.53 25.3774 1193.77 26.2397L1196.24 23.7791C1195.37 23.532 1194.69 23.7754 1194.23 24.2368Z",
    fill: "#3A4682"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.78 25.7821C1195.32 26.2434 1194.64 26.4869 1193.77 26.2397L1196.24 23.7792C1196.49 24.6414 1196.24 25.3207 1195.78 25.7821Z",
    fill: "#3A4682"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.23 81.235C1136.77 81.6958 1136.52 82.3741 1136.77 83.2352L1139.23 80.778C1138.37 80.5312 1137.69 80.7743 1137.23 81.235Z",
    fill: "#3A4682"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.77 82.7779C1138.31 83.2386 1137.63 83.4817 1136.77 83.2349L1139.23 80.7778C1139.48 81.6388 1139.23 82.3172 1138.77 82.7779Z",
    fill: "#3A4682"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.23 107.235C1110.77 107.696 1110.52 108.374 1110.77 109.235L1113.23 106.778C1112.37 106.531 1111.69 106.774 1111.23 107.235Z",
    fill: "#3A4682"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.77 108.778C1112.31 109.239 1111.63 109.482 1110.77 109.235L1113.23 106.778C1113.48 107.639 1113.23 108.317 1112.77 108.778Z",
    fill: "#3A4682"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.8 130.66C1084.86 131.603 1084.42 133.049 1085.07 134.958L1090.1 129.929C1088.19 129.277 1086.74 129.717 1085.8 130.66Z",
    fill: "#3A4682"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.36 134.227C1088.42 135.17 1086.98 135.61 1085.07 134.958L1090.1 129.929C1090.75 131.838 1090.31 133.284 1089.36 134.227Z",
    fill: "#3A4682"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.77 91.774L1125.51 94.5066",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.61 91.9304C1126.17 92.3714 1125.93 93.0207 1126.17 93.845L1128.53 91.493C1127.7 91.2567 1127.05 91.4894 1126.61 91.9304Z",
    fill: "#3A4682"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.93 95.6055C1122.49 96.0465 1122.25 96.6958 1122.49 97.52L1124.84 95.168C1124.02 94.9318 1123.37 95.1645 1122.93 95.6055Z",
    fill: "#3A4682"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.39 91.4832L1122.18 91.1832L1123.29 92.2939L1124.69 93.6943L1124.39 91.4832Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.48 93.3941L1122.18 91.1831L1123.29 92.2938L1124.69 93.6941L1122.48 93.3941Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.25 97.2389L1125.51 94.5063",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.09 93.4075C1127.65 93.8485 1127 94.0812 1126.17 93.845L1128.53 91.493C1128.76 92.3172 1128.53 92.9665 1128.09 93.4075Z",
    fill: "#3A4682"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.41 97.0824C1123.96 97.5234 1123.31 97.7561 1122.49 97.5199L1124.84 95.1679C1125.08 95.9921 1124.85 96.6414 1124.41 97.0824Z",
    fill: "#3A4682"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.54 95.6188L1128.84 97.8298L1127.72 96.7192L1126.32 95.3188L1128.54 95.6188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.62 97.5297L1128.84 97.8297L1127.72 96.7191L1126.32 95.3187L1126.62 97.5297Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M1086 134.007L1219 1.00648",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M1089 138.006L1082 138.006",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M1087 139.506L1089 138.006H1085L1087 139.506Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M1082 131.007L1082 138.007",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.5 133.007L1082 131.007L1082 135.007L1080.5 133.007Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M1082 138.007L1080 140.007",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.84 68.8495C1148.15 69.5405 1147.79 70.558 1148.16 71.8495L1151.84 68.164C1150.55 67.7938 1149.53 68.1585 1148.84 68.8495Z",
    fill: "#3A4682"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.16 71.1637C1150.47 71.8547 1149.45 72.2194 1148.16 71.8492L1151.84 68.1637C1152.21 69.4552 1151.85 70.4727 1151.16 71.1637Z",
    fill: "#3A4682"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 615.23L130.606 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 612.615L30.0443 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 615.387C50.5525 615.387 49.4595 614.184 49.4595 612.929C49.4595 612.607 49.4939 612.257 49.5835 611.932C49.4842 612.375 49.5835 612.746 49.6156 612.929C49.7718 613.818 50.7087 614.132 51.6456 614.132C52.5825 614.132 52.7387 615.387 51.6456 615.387Z",
    fill: "#3A4682"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 611.36C49.3916 612.04 49.5704 612.671 49.6156 612.929C49.7718 613.818 50.7087 614.132 51.6456 614.132C52.5825 614.132 52.7387 615.387 51.6456 615.387C50.5525 615.387 49.4595 614.184 49.4595 612.929C49.4595 611.958 49.7718 610.732 50.9689 610.732C51.3333 610.732 51.8018 610.628 53.3633 611.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 613.87L93.8584 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 611.046C25.6719 611.046 26.2965 610.751 26.7129 610L23.3816 610C23.7981 610.751 24.4227 611.046 25.0473 611.046Z",
    fill: "#3A4682"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 611.046C82.9277 611.046 83.5523 610.751 83.9687 610L80.6375 610C81.0539 610.751 81.6785 611.046 82.3031 611.046Z",
    fill: "#3A4682"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 611.046C91.8809 611.046 92.5055 610.751 92.9219 610L89.5906 610C90.007 610.751 90.6316 611.046 91.2563 611.046Z",
    fill: "#3A4682"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 611.046C97.0859 611.046 97.7105 610.751 98.127 610L94.7957 610C95.2121 610.751 95.8367 611.046 96.4613 611.046Z",
    fill: "#3A4682"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 612.51C123.502 612.511 124.829 611.802 125.714 610L118.635 610C119.52 611.802 120.847 612.51 122.174 612.51Z",
    fill: "#3A4682"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 612.929L93.8589 614.707L93.8589 613.134L93.8589 611.151L92.5056 612.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 612.929L93.8584 614.707L93.8584 613.134L93.8584 611.151L95.2117 612.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 614.934L125.401 615.23L127.9 612.72L127.605 614.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 611.046C108.017 611.046 108.641 610.751 109.058 610L105.726 610C106.143 610.751 106.767 611.046 107.392 611.046Z",
    fill: "#3A4682"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 616.59L61.4829 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 614.812L61.4829 616.59L61.4829 615.017L61.4829 613.033L60.1296 614.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 611.883L56.6423 614.236L53.5026 611.883C54.4233 612.472 54.7847 612.86 56.6423 612.86C58.4998 612.86 59.1441 612.3 59.8174 611.883Z",
    fill: "#3A4682"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 611.778L53.5026 611.883M53.5026 611.883L56.6423 614.236L59.8174 611.883C59.1441 612.3 58.4998 612.86 56.6423 612.86C54.7847 612.86 54.4233 612.472 53.5026 611.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 610C61.2574 610.384 60.6085 611.297 59.8173 611.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 616.59L65.2305 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 614.812L65.2305 616.59L65.2305 615.017L65.2305 613.033L66.5838 614.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 611.883L70.0711 614.236L73.2108 611.883C72.2901 612.472 71.9286 612.86 70.0711 612.86C68.2135 612.86 67.5692 612.3 66.896 611.883Z",
    fill: "#3A4682"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 611.778L73.2108 611.883M73.2108 611.883L70.0711 614.236L66.896 611.883C67.5692 612.3 68.2135 612.86 70.0711 612.86C71.9286 612.86 72.2901 612.472 73.2108 611.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 610C65.456 610.384 66.1049 611.297 66.8961 611.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 611.569C57.5273 611.569 58.4643 611.127 59.0889 610L54.092 610C54.7166 611.127 55.6535 611.569 56.5904 611.569Z",
    fill: "#3A4682"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 604.77L130.606 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 607.385L30.0443 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 604.613C50.5525 604.613 49.4595 605.816 49.4595 607.071C49.4595 607.393 49.4939 607.743 49.5836 608.068C49.4842 607.625 49.5835 607.254 49.6156 607.071C49.7718 606.182 50.7087 605.868 51.6456 605.868C52.5825 605.868 52.7387 604.613 51.6456 604.613Z",
    fill: "#3A4682"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 608.64C49.3916 607.96 49.5704 607.329 49.6156 607.071C49.7718 606.182 50.7087 605.868 51.6456 605.868C52.5825 605.868 52.7387 604.613 51.6456 604.613C50.5525 604.613 49.4595 605.816 49.4595 607.071C49.4595 608.042 49.7718 609.268 50.9689 609.268C51.3333 609.268 51.8018 609.372 53.3633 608.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 606.13L93.8584 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 608.954C25.6719 608.954 26.2965 609.249 26.7129 610L23.3816 610C23.7981 609.249 24.4227 608.954 25.0473 608.954Z",
    fill: "#3A4682"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 608.954C82.9277 608.954 83.5523 609.249 83.9688 610L80.6375 610C81.0539 609.249 81.6785 608.954 82.3031 608.954Z",
    fill: "#3A4682"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 608.954C91.8809 608.954 92.5055 609.249 92.9219 610L89.5906 610C90.007 609.249 90.6316 608.954 91.2563 608.954Z",
    fill: "#3A4682"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 608.954C97.0859 608.954 97.7105 609.249 98.127 610L94.7957 610C95.2121 609.249 95.8367 608.954 96.4613 608.954Z",
    fill: "#3A4682"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 607.49C123.502 607.489 124.829 608.198 125.714 610L118.635 610C119.52 608.198 120.847 607.49 122.174 607.49Z",
    fill: "#3A4682"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 607.071L93.8589 605.293L93.8589 606.866L93.8589 608.849L92.5056 607.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 607.071L93.8584 605.293L93.8584 606.866L93.8584 608.849L95.2117 607.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 605.066L125.401 604.77L127.9 607.28L127.605 605.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 608.954C108.017 608.954 108.641 609.249 109.058 610L105.726 610C106.143 609.249 106.767 608.954 107.392 608.954Z",
    fill: "#3A4682"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 603.41L61.4829 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 605.188L61.4829 603.41L61.4829 604.983L61.4829 606.967L60.1296 605.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 608.117L56.6423 605.764L53.5026 608.117C54.4233 607.528 54.7847 607.14 56.6423 607.14C58.4998 607.14 59.1441 607.7 59.8174 608.117Z",
    fill: "#3A4682"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 608.222L53.5026 608.117M53.5026 608.117L56.6423 605.764L59.8174 608.117C59.1441 607.7 58.4998 607.14 56.6423 607.14C54.7847 607.14 54.4233 607.528 53.5026 608.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 610C61.2574 609.616 60.6085 608.703 59.8173 608.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 603.41L65.2305 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 605.188L65.2305 603.41L65.2305 604.983L65.2305 606.967L66.5838 605.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 608.117L70.0711 605.764L73.2108 608.117C72.2901 607.528 71.9286 607.14 70.0711 607.14C68.2135 607.14 67.5692 607.7 66.896 608.117Z",
    fill: "#3A4682"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 608.222L73.2108 608.117M73.2108 608.117L70.0711 605.764L66.896 608.117C67.5692 607.7 68.2135 607.14 70.0711 607.14C71.9286 607.14 72.2901 607.528 73.2108 608.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 610C65.456 609.616 66.1049 608.703 66.8961 608.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 608.431C57.5273 608.431 58.4643 608.873 59.0889 610L54.092 610C54.7166 608.873 55.6535 608.431 56.5904 608.431Z",
    fill: "#3A4682"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M122.122 610L1.052 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 610L132.272 610",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 525.23L130.606 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 522.615L30.0443 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 525.387C50.5525 525.387 49.4595 524.184 49.4595 522.929C49.4595 522.607 49.4939 522.257 49.5835 521.932C49.4842 522.375 49.5835 522.746 49.6156 522.929C49.7718 523.818 50.7087 524.132 51.6456 524.132C52.5825 524.132 52.7387 525.387 51.6456 525.387Z",
    fill: "#3A4682"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 521.36C49.3916 522.04 49.5704 522.671 49.6156 522.929C49.7718 523.818 50.7087 524.132 51.6456 524.132C52.5825 524.132 52.7387 525.387 51.6456 525.387C50.5525 525.387 49.4595 524.184 49.4595 522.929C49.4595 521.958 49.7718 520.732 50.9689 520.732C51.3333 520.732 51.8018 520.628 53.3633 521.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 523.87L93.8584 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 521.046C25.6719 521.046 26.2965 520.751 26.7129 520L23.3816 520C23.7981 520.751 24.4227 521.046 25.0473 521.046Z",
    fill: "#3A4682"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 521.046C82.9277 521.046 83.5523 520.751 83.9687 520L80.6375 520C81.0539 520.751 81.6785 521.046 82.3031 521.046Z",
    fill: "#3A4682"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 521.046C91.8809 521.046 92.5055 520.751 92.9219 520L89.5906 520C90.007 520.751 90.6316 521.046 91.2563 521.046Z",
    fill: "#3A4682"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 521.046C97.0859 521.046 97.7105 520.751 98.127 520L94.7957 520C95.2121 520.751 95.8367 521.046 96.4613 521.046Z",
    fill: "#3A4682"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 522.51C123.502 522.511 124.829 521.802 125.714 520L118.635 520C119.52 521.802 120.847 522.51 122.174 522.51Z",
    fill: "#3A4682"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 522.929L93.8589 524.707L93.8589 523.134L93.8589 521.151L92.5056 522.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 522.929L93.8584 524.707L93.8584 523.134L93.8584 521.151L95.2117 522.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 524.934L125.401 525.23L127.9 522.72L127.605 524.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 521.046C108.017 521.046 108.641 520.751 109.058 520L105.726 520C106.143 520.751 106.767 521.046 107.392 521.046Z",
    fill: "#3A4682"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 526.59L61.4829 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 524.812L61.4829 526.59L61.4829 525.017L61.4829 523.033L60.1296 524.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 521.883L56.6423 524.236L53.5026 521.883C54.4233 522.472 54.7847 522.86 56.6423 522.86C58.4998 522.86 59.1441 522.3 59.8174 521.883Z",
    fill: "#3A4682"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 521.778L53.5026 521.883M53.5026 521.883L56.6423 524.236L59.8174 521.883C59.1441 522.3 58.4998 522.86 56.6423 522.86C54.7847 522.86 54.4233 522.472 53.5026 521.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 520C61.2574 520.384 60.6085 521.297 59.8173 521.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 526.59L65.2305 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 524.812L65.2305 526.59L65.2305 525.017L65.2305 523.033L66.5838 524.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 521.883L70.0711 524.236L73.2108 521.883C72.2901 522.472 71.9286 522.86 70.0711 522.86C68.2135 522.86 67.5692 522.3 66.896 521.883Z",
    fill: "#3A4682"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 521.778L73.2108 521.883M73.2108 521.883L70.0711 524.236L66.896 521.883C67.5692 522.3 68.2135 522.86 70.0711 522.86C71.9286 522.86 72.2901 522.472 73.2108 521.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 520C65.456 520.384 66.1049 521.297 66.8961 521.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 521.569C57.5273 521.569 58.4643 521.127 59.0889 520L54.092 520C54.7166 521.127 55.6535 521.569 56.5904 521.569Z",
    fill: "#3A4682"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 514.77L130.606 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 517.385L30.0443 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 514.613C50.5525 514.613 49.4595 515.816 49.4595 517.071C49.4595 517.393 49.4939 517.743 49.5836 518.068C49.4842 517.625 49.5835 517.254 49.6156 517.071C49.7718 516.182 50.7087 515.868 51.6456 515.868C52.5825 515.868 52.7387 514.613 51.6456 514.613Z",
    fill: "#3A4682"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 518.64C49.3916 517.96 49.5704 517.329 49.6156 517.071C49.7718 516.182 50.7087 515.868 51.6456 515.868C52.5825 515.868 52.7387 514.613 51.6456 514.613C50.5525 514.613 49.4595 515.816 49.4595 517.071C49.4595 518.042 49.7718 519.268 50.9689 519.268C51.3333 519.268 51.8018 519.372 53.3633 518.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 516.13L93.8584 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 518.954C25.6719 518.954 26.2965 519.249 26.7129 520L23.3816 520C23.7981 519.249 24.4227 518.954 25.0473 518.954Z",
    fill: "#3A4682"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 518.954C82.9277 518.954 83.5523 519.249 83.9688 520L80.6375 520C81.0539 519.249 81.6785 518.954 82.3031 518.954Z",
    fill: "#3A4682"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 518.954C91.8809 518.954 92.5055 519.249 92.9219 520L89.5906 520C90.007 519.249 90.6316 518.954 91.2563 518.954Z",
    fill: "#3A4682"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 518.954C97.0859 518.954 97.7105 519.249 98.127 520L94.7957 520C95.2121 519.249 95.8367 518.954 96.4613 518.954Z",
    fill: "#3A4682"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 517.49C123.502 517.489 124.829 518.198 125.714 520L118.635 520C119.52 518.198 120.847 517.49 122.174 517.49Z",
    fill: "#3A4682"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 517.071L93.8589 515.293L93.8589 516.866L93.8589 518.849L92.5056 517.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 517.071L93.8584 515.293L93.8584 516.866L93.8584 518.849L95.2117 517.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 515.066L125.401 514.77L127.9 517.28L127.605 515.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 518.954C108.017 518.954 108.641 519.249 109.058 520L105.726 520C106.143 519.249 106.767 518.954 107.392 518.954Z",
    fill: "#3A4682"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 513.41L61.4829 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 515.188L61.4829 513.41L61.4829 514.983L61.4829 516.967L60.1296 515.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 518.117L56.6423 515.764L53.5026 518.117C54.4233 517.528 54.7847 517.14 56.6423 517.14C58.4998 517.14 59.1441 517.7 59.8174 518.117Z",
    fill: "#3A4682"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 518.222L53.5026 518.117M53.5026 518.117L56.6423 515.764L59.8174 518.117C59.1441 517.7 58.4998 517.14 56.6423 517.14C54.7847 517.14 54.4233 517.528 53.5026 518.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 520C61.2574 519.616 60.6085 518.703 59.8173 518.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 513.41L65.2305 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 515.188L65.2305 513.41L65.2305 514.983L65.2305 516.967L66.5838 515.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 518.117L70.0711 515.764L73.2108 518.117C72.2901 517.528 71.9286 517.14 70.0711 517.14C68.2135 517.14 67.5692 517.7 66.896 518.117Z",
    fill: "#3A4682"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 518.222L73.2108 518.117M73.2108 518.117L70.0711 515.764L66.896 518.117C67.5692 517.7 68.2135 517.14 70.0711 517.14C71.9286 517.14 72.2901 517.528 73.2108 518.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 520C65.456 519.616 66.1049 518.703 66.8961 518.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 518.431C57.5273 518.431 58.4643 518.873 59.0889 520L54.092 520C54.7166 518.873 55.6535 518.431 56.5904 518.431Z",
    fill: "#3A4682"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M122.122 520L1.052 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 520L132.272 520",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 435.23L130.606 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 432.615L30.0443 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 435.387C50.5525 435.387 49.4595 434.184 49.4595 432.929C49.4595 432.607 49.4939 432.257 49.5835 431.932C49.4842 432.375 49.5835 432.746 49.6156 432.929C49.7718 433.818 50.7087 434.132 51.6456 434.132C52.5825 434.132 52.7387 435.387 51.6456 435.387Z",
    fill: "#3A4682"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 431.36C49.3916 432.04 49.5704 432.671 49.6156 432.929C49.7718 433.818 50.7087 434.132 51.6456 434.132C52.5825 434.132 52.7387 435.387 51.6456 435.387C50.5525 435.387 49.4595 434.184 49.4595 432.929C49.4595 431.958 49.7718 430.732 50.9689 430.732C51.3333 430.732 51.8018 430.628 53.3633 431.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 433.87L93.8584 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 431.046C25.6719 431.046 26.2965 430.751 26.7129 430L23.3816 430C23.7981 430.751 24.4227 431.046 25.0473 431.046Z",
    fill: "#3A4682"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 431.046C82.9277 431.046 83.5523 430.751 83.9687 430L80.6375 430C81.0539 430.751 81.6785 431.046 82.3031 431.046Z",
    fill: "#3A4682"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 431.046C91.8809 431.046 92.5055 430.751 92.9219 430L89.5906 430C90.007 430.751 90.6316 431.046 91.2563 431.046Z",
    fill: "#3A4682"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 431.046C97.0859 431.046 97.7105 430.751 98.127 430L94.7957 430C95.2121 430.751 95.8367 431.046 96.4613 431.046Z",
    fill: "#3A4682"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 432.51C123.502 432.511 124.829 431.802 125.714 430L118.635 430C119.52 431.802 120.847 432.51 122.174 432.51Z",
    fill: "#3A4682"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 432.929L93.8589 434.707L93.8589 433.134L93.8589 431.151L92.5056 432.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 432.929L93.8584 434.707L93.8584 433.134L93.8584 431.151L95.2117 432.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 434.934L125.401 435.23L127.9 432.72L127.605 434.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 431.046C108.017 431.046 108.641 430.751 109.058 430L105.726 430C106.143 430.751 106.767 431.046 107.392 431.046Z",
    fill: "#3A4682"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 436.59L61.4829 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 434.812L61.4829 436.59L61.4829 435.017L61.4829 433.033L60.1296 434.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 431.883L56.6423 434.236L53.5026 431.883C54.4233 432.472 54.7847 432.86 56.6423 432.86C58.4998 432.86 59.1441 432.3 59.8174 431.883Z",
    fill: "#3A4682"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 431.778L53.5026 431.883M53.5026 431.883L56.6423 434.236L59.8174 431.883C59.1441 432.3 58.4998 432.86 56.6423 432.86C54.7847 432.86 54.4233 432.472 53.5026 431.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 430C61.2574 430.384 60.6085 431.297 59.8173 431.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 436.59L65.2305 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 434.812L65.2305 436.59L65.2305 435.017L65.2305 433.033L66.5838 434.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 431.883L70.0711 434.236L73.2108 431.883C72.2901 432.472 71.9286 432.86 70.0711 432.86C68.2135 432.86 67.5692 432.3 66.896 431.883Z",
    fill: "#3A4682"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 431.778L73.2108 431.883M73.2108 431.883L70.0711 434.236L66.896 431.883C67.5692 432.3 68.2135 432.86 70.0711 432.86C71.9286 432.86 72.2901 432.472 73.2108 431.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 430C65.456 430.384 66.1049 431.297 66.8961 431.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 431.569C57.5273 431.569 58.4643 431.127 59.0889 430L54.092 430C54.7166 431.127 55.6535 431.569 56.5904 431.569Z",
    fill: "#3A4682"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 424.77L130.606 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 427.385L30.0443 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 424.613C50.5525 424.613 49.4595 425.816 49.4595 427.071C49.4595 427.393 49.4939 427.743 49.5836 428.068C49.4842 427.625 49.5835 427.254 49.6156 427.071C49.7718 426.182 50.7087 425.868 51.6456 425.868C52.5825 425.868 52.7387 424.613 51.6456 424.613Z",
    fill: "#3A4682"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 428.64C49.3916 427.96 49.5704 427.329 49.6156 427.071C49.7718 426.182 50.7087 425.868 51.6456 425.868C52.5825 425.868 52.7387 424.613 51.6456 424.613C50.5525 424.613 49.4595 425.816 49.4595 427.071C49.4595 428.042 49.7718 429.268 50.9689 429.268C51.3333 429.268 51.8018 429.372 53.3633 428.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 426.13L93.8584 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 428.954C25.6719 428.954 26.2965 429.249 26.7129 430L23.3816 430C23.7981 429.249 24.4227 428.954 25.0473 428.954Z",
    fill: "#3A4682"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 428.954C82.9277 428.954 83.5523 429.249 83.9688 430L80.6375 430C81.0539 429.249 81.6785 428.954 82.3031 428.954Z",
    fill: "#3A4682"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 428.954C91.8809 428.954 92.5055 429.249 92.9219 430L89.5906 430C90.007 429.249 90.6316 428.954 91.2563 428.954Z",
    fill: "#3A4682"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 428.954C97.0859 428.954 97.7105 429.249 98.127 430L94.7957 430C95.2121 429.249 95.8367 428.954 96.4613 428.954Z",
    fill: "#3A4682"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 427.49C123.502 427.489 124.829 428.198 125.714 430L118.635 430C119.52 428.198 120.847 427.49 122.174 427.49Z",
    fill: "#3A4682"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 427.071L93.8589 425.293L93.8589 426.866L93.8589 428.849L92.5056 427.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 427.071L93.8584 425.293L93.8584 426.866L93.8584 428.849L95.2117 427.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 425.066L125.401 424.77L127.9 427.28L127.605 425.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 428.954C108.017 428.954 108.641 429.249 109.058 430L105.726 430C106.143 429.249 106.767 428.954 107.392 428.954Z",
    fill: "#3A4682"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 423.41L61.4829 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 425.188L61.4829 423.41L61.4829 424.983L61.4829 426.967L60.1296 425.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 428.117L56.6423 425.764L53.5026 428.117C54.4233 427.528 54.7847 427.14 56.6423 427.14C58.4998 427.14 59.1441 427.7 59.8174 428.117Z",
    fill: "#3A4682"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 428.222L53.5026 428.117M53.5026 428.117L56.6423 425.764L59.8174 428.117C59.1441 427.7 58.4998 427.14 56.6423 427.14C54.7847 427.14 54.4233 427.528 53.5026 428.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 430C61.2574 429.616 60.6085 428.703 59.8173 428.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 423.41L65.2305 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 425.188L65.2305 423.41L65.2305 424.983L65.2305 426.967L66.5838 425.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 428.117L70.0711 425.764L73.2108 428.117C72.2901 427.528 71.9286 427.14 70.0711 427.14C68.2135 427.14 67.5692 427.7 66.896 428.117Z",
    fill: "#3A4682"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 428.222L73.2108 428.117M73.2108 428.117L70.0711 425.764L66.896 428.117C67.5692 427.7 68.2135 427.14 70.0711 427.14C71.9286 427.14 72.2901 427.528 73.2108 428.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 430C65.456 429.616 66.1049 428.703 66.8961 428.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 428.431C57.5273 428.431 58.4643 428.873 59.0889 430L54.092 430C54.7166 428.873 55.6535 428.431 56.5904 428.431Z",
    fill: "#3A4682"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M122.122 430L1.052 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 430L132.272 430",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 345.23L130.606 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 342.615L30.0443 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 345.387C50.5525 345.387 49.4595 344.184 49.4595 342.929C49.4595 342.607 49.4939 342.257 49.5835 341.932C49.4842 342.375 49.5835 342.746 49.6156 342.929C49.7718 343.818 50.7087 344.132 51.6456 344.132C52.5825 344.132 52.7387 345.387 51.6456 345.387Z",
    fill: "#3A4682"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 341.36C49.3916 342.04 49.5704 342.671 49.6156 342.929C49.7718 343.818 50.7087 344.132 51.6456 344.132C52.5825 344.132 52.7387 345.387 51.6456 345.387C50.5525 345.387 49.4595 344.184 49.4595 342.929C49.4595 341.958 49.7718 340.732 50.9689 340.732C51.3333 340.732 51.8018 340.628 53.3633 341.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 343.87L93.8584 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 341.046C25.6719 341.046 26.2965 340.751 26.7129 340L23.3816 340C23.7981 340.751 24.4227 341.046 25.0473 341.046Z",
    fill: "#3A4682"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 341.046C82.9277 341.046 83.5523 340.751 83.9687 340L80.6375 340C81.0539 340.751 81.6785 341.046 82.3031 341.046Z",
    fill: "#3A4682"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 341.046C91.8809 341.046 92.5055 340.751 92.9219 340L89.5906 340C90.007 340.751 90.6316 341.046 91.2563 341.046Z",
    fill: "#3A4682"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 341.046C97.0859 341.046 97.7105 340.751 98.127 340L94.7957 340C95.2121 340.751 95.8367 341.046 96.4613 341.046Z",
    fill: "#3A4682"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 342.51C123.502 342.511 124.829 341.802 125.714 340L118.635 340C119.52 341.802 120.847 342.51 122.174 342.51Z",
    fill: "#3A4682"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 342.929L93.8589 344.707L93.8589 343.134L93.8589 341.151L92.5056 342.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 342.929L93.8584 344.707L93.8584 343.134L93.8584 341.151L95.2117 342.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 344.934L125.401 345.23L127.9 342.72L127.605 344.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 341.046C108.017 341.046 108.641 340.751 109.058 340L105.726 340C106.143 340.751 106.767 341.046 107.392 341.046Z",
    fill: "#3A4682"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 346.59L61.4829 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 344.812L61.4829 346.59L61.4829 345.017L61.4829 343.033L60.1296 344.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 341.883L56.6423 344.236L53.5026 341.883C54.4233 342.472 54.7847 342.86 56.6423 342.86C58.4998 342.86 59.1441 342.3 59.8174 341.883Z",
    fill: "#3A4682"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 341.778L53.5026 341.883M53.5026 341.883L56.6423 344.236L59.8174 341.883C59.1441 342.3 58.4998 342.86 56.6423 342.86C54.7847 342.86 54.4233 342.472 53.5026 341.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 340C61.2574 340.384 60.6085 341.297 59.8173 341.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 346.59L65.2305 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 344.812L65.2305 346.59L65.2305 345.017L65.2305 343.033L66.5838 344.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 341.883L70.0711 344.236L73.2108 341.883C72.2901 342.472 71.9286 342.86 70.0711 342.86C68.2135 342.86 67.5692 342.3 66.896 341.883Z",
    fill: "#3A4682"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 341.778L73.2108 341.883M73.2108 341.883L70.0711 344.236L66.896 341.883C67.5692 342.3 68.2135 342.86 70.0711 342.86C71.9286 342.86 72.2901 342.472 73.2108 341.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 340C65.456 340.384 66.1049 341.297 66.8961 341.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 341.569C57.5273 341.569 58.4643 341.127 59.0889 340L54.092 340C54.7166 341.127 55.6535 341.569 56.5904 341.569Z",
    fill: "#3A4682"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 334.77L130.606 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 337.385L30.0443 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 334.613C50.5525 334.613 49.4595 335.816 49.4595 337.071C49.4595 337.393 49.4939 337.743 49.5836 338.068C49.4842 337.625 49.5835 337.254 49.6156 337.071C49.7718 336.182 50.7087 335.868 51.6456 335.868C52.5825 335.868 52.7387 334.613 51.6456 334.613Z",
    fill: "#3A4682"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 338.64C49.3916 337.96 49.5704 337.329 49.6156 337.071C49.7718 336.182 50.7087 335.868 51.6456 335.868C52.5825 335.868 52.7387 334.613 51.6456 334.613C50.5525 334.613 49.4595 335.816 49.4595 337.071C49.4595 338.042 49.7718 339.268 50.9689 339.268C51.3333 339.268 51.8018 339.372 53.3633 338.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 336.13L93.8584 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 338.954C25.6719 338.954 26.2965 339.249 26.7129 340L23.3816 340C23.7981 339.249 24.4227 338.954 25.0473 338.954Z",
    fill: "#3A4682"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 338.954C82.9277 338.954 83.5523 339.249 83.9688 340L80.6375 340C81.0539 339.249 81.6785 338.954 82.3031 338.954Z",
    fill: "#3A4682"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 338.954C91.8809 338.954 92.5055 339.249 92.9219 340L89.5906 340C90.007 339.249 90.6316 338.954 91.2563 338.954Z",
    fill: "#3A4682"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 338.954C97.0859 338.954 97.7105 339.249 98.127 340L94.7957 340C95.2121 339.249 95.8367 338.954 96.4613 338.954Z",
    fill: "#3A4682"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 337.49C123.502 337.489 124.829 338.198 125.714 340L118.635 340C119.52 338.198 120.847 337.49 122.174 337.49Z",
    fill: "#3A4682"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 337.071L93.8589 335.293L93.8589 336.866L93.8589 338.849L92.5056 337.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 337.071L93.8584 335.293L93.8584 336.866L93.8584 338.849L95.2117 337.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 335.066L125.401 334.77L127.9 337.28L127.605 335.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 338.954C108.017 338.954 108.641 339.249 109.058 340L105.726 340C106.143 339.249 106.767 338.954 107.392 338.954Z",
    fill: "#3A4682"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 333.41L61.4829 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 335.188L61.4829 333.41L61.4829 334.983L61.4829 336.967L60.1296 335.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 338.117L56.6423 335.764L53.5026 338.117C54.4233 337.528 54.7847 337.14 56.6423 337.14C58.4998 337.14 59.1441 337.7 59.8174 338.117Z",
    fill: "#3A4682"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 338.222L53.5026 338.117M53.5026 338.117L56.6423 335.764L59.8174 338.117C59.1441 337.7 58.4998 337.14 56.6423 337.14C54.7847 337.14 54.4233 337.528 53.5026 338.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 340C61.2574 339.616 60.6085 338.703 59.8173 338.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 333.41L65.2305 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 335.188L65.2305 333.41L65.2305 334.983L65.2305 336.967L66.5838 335.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 338.117L70.0711 335.764L73.2108 338.117C72.2901 337.528 71.9286 337.14 70.0711 337.14C68.2135 337.14 67.5692 337.7 66.896 338.117Z",
    fill: "#3A4682"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 338.222L73.2108 338.117M73.2108 338.117L70.0711 335.764L66.896 338.117C67.5692 337.7 68.2135 337.14 70.0711 337.14C71.9286 337.14 72.2901 337.528 73.2108 338.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 340C65.456 339.616 66.1049 338.703 66.8961 338.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 338.431C57.5273 338.431 58.4643 338.873 59.0889 340L54.092 340C54.7166 338.873 55.6535 338.431 56.5904 338.431Z",
    fill: "#3A4682"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M122.122 340L1.052 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 340L132.272 340",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 255.23L130.606 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 252.615L30.0443 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 255.387C50.5525 255.387 49.4595 254.184 49.4595 252.929C49.4595 252.607 49.4939 252.257 49.5835 251.932C49.4842 252.375 49.5835 252.746 49.6156 252.929C49.7718 253.818 50.7087 254.132 51.6456 254.132C52.5825 254.132 52.7387 255.387 51.6456 255.387Z",
    fill: "#3A4682"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 251.36C49.3916 252.04 49.5704 252.671 49.6156 252.929C49.7718 253.818 50.7087 254.132 51.6456 254.132C52.5825 254.132 52.7387 255.387 51.6456 255.387C50.5525 255.387 49.4595 254.184 49.4595 252.929C49.4595 251.958 49.7718 250.732 50.9689 250.732C51.3333 250.732 51.8018 250.628 53.3633 251.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 253.87L93.8584 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 251.046C25.6719 251.046 26.2965 250.751 26.7129 250L23.3816 250C23.7981 250.751 24.4227 251.046 25.0473 251.046Z",
    fill: "#3A4682"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 251.046C82.9277 251.046 83.5523 250.751 83.9687 250L80.6375 250C81.0539 250.751 81.6785 251.046 82.3031 251.046Z",
    fill: "#3A4682"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 251.046C91.8809 251.046 92.5055 250.751 92.9219 250L89.5906 250C90.007 250.751 90.6316 251.046 91.2563 251.046Z",
    fill: "#3A4682"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 251.046C97.0859 251.046 97.7105 250.751 98.127 250L94.7957 250C95.2121 250.751 95.8367 251.046 96.4613 251.046Z",
    fill: "#3A4682"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 252.51C123.502 252.511 124.829 251.802 125.714 250L118.635 250C119.52 251.802 120.847 252.51 122.174 252.51Z",
    fill: "#3A4682"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 252.929L93.8589 254.707L93.8589 253.134L93.8589 251.151L92.5056 252.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 252.929L93.8584 254.707L93.8584 253.134L93.8584 251.151L95.2117 252.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 254.934L125.401 255.23L127.9 252.72L127.605 254.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 251.046C108.017 251.046 108.641 250.751 109.058 250L105.726 250C106.143 250.751 106.767 251.046 107.392 251.046Z",
    fill: "#3A4682"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 256.59L61.4829 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 254.812L61.4829 256.59L61.4829 255.017L61.4829 253.033L60.1296 254.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 251.883L56.6423 254.236L53.5026 251.883C54.4233 252.472 54.7847 252.86 56.6423 252.86C58.4998 252.86 59.1441 252.3 59.8174 251.883Z",
    fill: "#3A4682"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 251.778L53.5026 251.883M53.5026 251.883L56.6423 254.236L59.8174 251.883C59.1441 252.3 58.4998 252.86 56.6423 252.86C54.7847 252.86 54.4233 252.472 53.5026 251.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 250C61.2574 250.384 60.6085 251.297 59.8173 251.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 256.59L65.2305 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 254.812L65.2305 256.59L65.2305 255.017L65.2305 253.033L66.5838 254.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 251.883L70.0711 254.236L73.2108 251.883C72.2901 252.472 71.9286 252.86 70.0711 252.86C68.2135 252.86 67.5692 252.3 66.896 251.883Z",
    fill: "#3A4682"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 251.778L73.2108 251.883M73.2108 251.883L70.0711 254.236L66.896 251.883C67.5692 252.3 68.2135 252.86 70.0711 252.86C71.9286 252.86 72.2901 252.472 73.2108 251.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 250C65.456 250.384 66.1049 251.297 66.8961 251.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 251.569C57.5273 251.569 58.4643 251.127 59.0889 250L54.092 250C54.7166 251.127 55.6535 251.569 56.5904 251.569Z",
    fill: "#3A4682"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 244.77L130.606 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 247.385L30.0443 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 244.613C50.5525 244.613 49.4595 245.816 49.4595 247.071C49.4595 247.393 49.4939 247.743 49.5836 248.068C49.4842 247.625 49.5835 247.254 49.6156 247.071C49.7718 246.182 50.7087 245.868 51.6456 245.868C52.5825 245.868 52.7387 244.613 51.6456 244.613Z",
    fill: "#3A4682"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 248.64C49.3916 247.96 49.5704 247.329 49.6156 247.071C49.7718 246.182 50.7087 245.868 51.6456 245.868C52.5825 245.868 52.7387 244.613 51.6456 244.613C50.5525 244.613 49.4595 245.816 49.4595 247.071C49.4595 248.042 49.7718 249.268 50.9689 249.268C51.3333 249.268 51.8018 249.372 53.3633 248.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 246.13L93.8584 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 248.954C25.6719 248.954 26.2965 249.249 26.7129 250L23.3816 250C23.7981 249.249 24.4227 248.954 25.0473 248.954Z",
    fill: "#3A4682"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 248.954C82.9277 248.954 83.5523 249.249 83.9688 250L80.6375 250C81.0539 249.249 81.6785 248.954 82.3031 248.954Z",
    fill: "#3A4682"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 248.954C91.8809 248.954 92.5055 249.249 92.9219 250L89.5906 250C90.007 249.249 90.6316 248.954 91.2563 248.954Z",
    fill: "#3A4682"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 248.954C97.0859 248.954 97.7105 249.249 98.127 250L94.7957 250C95.2121 249.249 95.8367 248.954 96.4613 248.954Z",
    fill: "#3A4682"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 247.49C123.502 247.489 124.829 248.198 125.714 250L118.635 250C119.52 248.198 120.847 247.49 122.174 247.49Z",
    fill: "#3A4682"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 247.071L93.8589 245.293L93.8589 246.866L93.8589 248.849L92.5056 247.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 247.071L93.8584 245.293L93.8584 246.866L93.8584 248.849L95.2117 247.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 245.066L125.401 244.77L127.9 247.28L127.605 245.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 248.954C108.017 248.954 108.641 249.249 109.058 250L105.726 250C106.143 249.249 106.767 248.954 107.392 248.954Z",
    fill: "#3A4682"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 243.41L61.4829 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 245.188L61.4829 243.41L61.4829 244.983L61.4829 246.967L60.1296 245.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 248.117L56.6423 245.764L53.5026 248.117C54.4233 247.528 54.7847 247.14 56.6423 247.14C58.4998 247.14 59.1441 247.7 59.8174 248.117Z",
    fill: "#3A4682"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 248.222L53.5026 248.117M53.5026 248.117L56.6423 245.764L59.8174 248.117C59.1441 247.7 58.4998 247.14 56.6423 247.14C54.7847 247.14 54.4233 247.528 53.5026 248.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 250C61.2574 249.616 60.6085 248.703 59.8173 248.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 243.41L65.2305 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 245.188L65.2305 243.41L65.2305 244.983L65.2305 246.967L66.5838 245.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 248.117L70.0711 245.764L73.2108 248.117C72.2901 247.528 71.9286 247.14 70.0711 247.14C68.2135 247.14 67.5692 247.7 66.896 248.117Z",
    fill: "#3A4682"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 248.222L73.2108 248.117M73.2108 248.117L70.0711 245.764L66.896 248.117C67.5692 247.7 68.2135 247.14 70.0711 247.14C71.9286 247.14 72.2901 247.528 73.2108 248.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 250C65.456 249.616 66.1049 248.703 66.8961 248.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 248.431C57.5273 248.431 58.4643 248.873 59.0889 250L54.092 250C54.7166 248.873 55.6535 248.431 56.5904 248.431Z",
    fill: "#3A4682"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M122.122 250L1.052 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 250L132.272 250",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 165.23L130.606 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 162.615L30.0443 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 165.387C50.5525 165.387 49.4595 164.184 49.4595 162.929C49.4595 162.607 49.4939 162.257 49.5835 161.932C49.4842 162.375 49.5835 162.746 49.6156 162.929C49.7718 163.818 50.7087 164.132 51.6456 164.132C52.5825 164.132 52.7387 165.387 51.6456 165.387Z",
    fill: "#3A4682"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 161.36C49.3916 162.04 49.5704 162.671 49.6156 162.929C49.7718 163.818 50.7087 164.132 51.6456 164.132C52.5825 164.132 52.7387 165.387 51.6456 165.387C50.5525 165.387 49.4595 164.184 49.4595 162.929C49.4595 161.958 49.7718 160.732 50.9689 160.732C51.3333 160.732 51.8018 160.628 53.3633 161.778",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 163.87L93.8584 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 161.046C25.6719 161.046 26.2965 160.751 26.7129 160L23.3816 160C23.7981 160.751 24.4227 161.046 25.0473 161.046Z",
    fill: "#3A4682"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 161.046C82.9277 161.046 83.5523 160.751 83.9687 160L80.6375 160C81.0539 160.751 81.6785 161.046 82.3031 161.046Z",
    fill: "#3A4682"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 161.046C91.8809 161.046 92.5055 160.751 92.9219 160L89.5906 160C90.007 160.751 90.6316 161.046 91.2563 161.046Z",
    fill: "#3A4682"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 161.046C97.0859 161.046 97.7105 160.751 98.127 160L94.7957 160C95.2121 160.751 95.8367 161.046 96.4613 161.046Z",
    fill: "#3A4682"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 162.51C123.502 162.511 124.829 161.802 125.714 160L118.635 160C119.52 161.802 120.847 162.51 122.174 162.51Z",
    fill: "#3A4682"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 162.929L93.8589 164.707L93.8589 163.134L93.8589 161.151L92.5056 162.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 162.929L93.8584 164.707L93.8584 163.134L93.8584 161.151L95.2117 162.929Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 164.934L125.401 165.23L127.9 162.72L127.605 164.934Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 161.046C108.017 161.046 108.641 160.751 109.058 160L105.726 160C106.143 160.751 106.767 161.046 107.392 161.046Z",
    fill: "#3A4682"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 166.59L61.4829 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 164.812L61.4829 166.59L61.4829 165.017L61.4829 163.033L60.1296 164.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 161.883L56.6423 164.236L53.5026 161.883C54.4233 162.472 54.7847 162.86 56.6423 162.86C58.4998 162.86 59.1441 162.3 59.8174 161.883Z",
    fill: "#3A4682"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 161.778L53.5026 161.883M53.5026 161.883L56.6423 164.236L59.8174 161.883C59.1441 162.3 58.4998 162.86 56.6423 162.86C54.7847 162.86 54.4233 162.472 53.5026 161.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 160C61.2574 160.384 60.6085 161.297 59.8173 161.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 166.59L65.2305 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 164.812L65.2305 166.59L65.2305 165.017L65.2305 163.033L66.5838 164.812Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 161.883L70.0711 164.236L73.2108 161.883C72.2901 162.472 71.9286 162.86 70.0711 162.86C68.2135 162.86 67.5692 162.3 66.896 161.883Z",
    fill: "#3A4682"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 161.778L73.2108 161.883M73.2108 161.883L70.0711 164.236L66.896 161.883C67.5692 162.3 68.2135 162.86 70.0711 162.86C71.9286 162.86 72.2901 162.472 73.2108 161.883Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 160C65.456 160.384 66.1049 161.297 66.8961 161.883",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 161.569C57.5273 161.569 58.4643 161.127 59.0889 160L54.092 160C54.7166 161.127 55.6535 161.569 56.5904 161.569Z",
    fill: "#3A4682"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M125.401 154.77L130.606 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0664 157.385L30.0443 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6456 154.613C50.5525 154.613 49.4595 155.816 49.4595 157.071C49.4595 157.393 49.4939 157.743 49.5836 158.068C49.4842 157.625 49.5835 157.254 49.6156 157.071C49.7718 156.182 50.7087 155.868 51.6456 155.868C52.5825 155.868 52.7387 154.613 51.6456 154.613Z",
    fill: "#3A4682"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8238 158.64C49.3916 157.96 49.5704 157.329 49.6156 157.071C49.7718 156.182 50.7087 155.868 51.6456 155.868C52.5825 155.868 52.7387 154.613 51.6456 154.613C50.5525 154.613 49.4595 155.816 49.4595 157.071C49.4595 158.042 49.7718 159.268 50.9689 159.268C51.3333 159.268 51.8018 159.372 53.3633 158.222",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8584 156.13L93.8584 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0473 158.954C25.6719 158.954 26.2965 159.249 26.7129 160L23.3816 160C23.7981 159.249 24.4227 158.954 25.0473 158.954Z",
    fill: "#3A4682"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3031 158.954C82.9277 158.954 83.5523 159.249 83.9688 160L80.6375 160C81.0539 159.249 81.6785 158.954 82.3031 158.954Z",
    fill: "#3A4682"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2563 158.954C91.8809 158.954 92.5055 159.249 92.9219 160L89.5906 160C90.007 159.249 90.6316 158.954 91.2563 158.954Z",
    fill: "#3A4682"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4613 158.954C97.0859 158.954 97.7105 159.249 98.127 160L94.7957 160C95.2121 159.249 95.8367 158.954 96.4613 158.954Z",
    fill: "#3A4682"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M122.174 157.49C123.502 157.489 124.829 158.198 125.714 160L118.635 160C119.52 158.198 120.847 157.49 122.174 157.49Z",
    fill: "#3A4682"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5056 157.071L93.8589 155.293L93.8589 156.866L93.8589 158.849L92.5056 157.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2117 157.071L93.8584 155.293L93.8584 156.866L93.8584 158.849L95.2117 157.071Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M127.605 155.066L125.401 154.77L127.9 157.28L127.605 155.066Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M107.392 158.954C108.017 158.954 108.641 159.249 109.058 160L105.726 160C106.143 159.249 106.767 158.954 107.392 158.954Z",
    fill: "#3A4682"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 153.41L61.4829 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1296 155.188L61.4829 153.41L61.4829 154.983L61.4829 156.967L60.1296 155.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8174 158.117L56.6423 155.764L53.5026 158.117C54.4233 157.528 54.7847 157.14 56.6423 157.14C58.4998 157.14 59.1441 157.7 59.8174 158.117Z",
    fill: "#3A4682"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3631 158.222L53.5026 158.117M53.5026 158.117L56.6423 155.764L59.8174 158.117C59.1441 157.7 58.4998 157.14 56.6423 157.14C54.7847 157.14 54.4233 157.528 53.5026 158.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4829 160C61.2574 159.616 60.6085 158.703 59.8173 158.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 153.41L65.2305 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5838 155.188L65.2305 153.41L65.2305 154.983L65.2305 156.967L66.5838 155.188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M66.896 158.117L70.0711 155.764L73.2108 158.117C72.2901 157.528 71.9286 157.14 70.0711 157.14C68.2135 157.14 67.5692 157.7 66.896 158.117Z",
    fill: "#3A4682"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3503 158.222L73.2108 158.117M73.2108 158.117L70.0711 155.764L66.896 158.117C67.5692 157.7 68.2135 157.14 70.0711 157.14C71.9286 157.14 72.2901 157.528 73.2108 158.117Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2305 160C65.456 159.616 66.1049 158.703 66.8961 158.117",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5904 158.431C57.5273 158.431 58.4643 158.873 59.0889 160L54.092 160C54.7166 158.873 55.6535 158.431 56.5904 158.431Z",
    fill: "#3A4682"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M122.122 160L1.052 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M130.606 160L132.272 160",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M140 140L140 152L132 160L140 168L140 242L132 250L140 258L140 332L132 340L140 348L140 422L132 430L140 438L140 512L132 520L140 528L140 602L132 610L140 618L140 630",
    stroke: "#3A4682",
    strokeLinecap: "round"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73L30 70",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 71C26.0625 71 26.625 70.718 27 70L24 70C24.375 70.718 24.9375 71 25.5 71Z",
    fill: "#3A4682"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M28 67L30 70",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 69C26.0625 69 26.625 69.282 27 70L24 70C24.375 69.282 24.9375 69 25.5 69Z",
    fill: "#3A4682"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M1 70L30 70",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M28 703L30 700",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 701C26.0625 701 26.625 700.718 27 700L24 700C24.375 700.718 24.9375 701 25.5 701Z",
    fill: "#3A4682"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M28 697L30 700",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 699C26.0625 699 26.625 699.282 27 700L24 700C24.375 699.282 24.9375 699 25.5 699Z",
    fill: "#3A4682"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M1 700L30 700",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M1147 742L1150 740",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M1149 744.5C1149 743.938 1149.28 743.375 1150 743L1150 746C1149.28 745.625 1149 745.062 1149 744.5Z",
    fill: "#3A4682"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M1153 742L1150 740",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M1151 744.5C1151 743.938 1150.72 743.375 1150 743L1150 746C1150.72 745.625 1151 745.062 1151 744.5Z",
    fill: "#3A4682"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M1150 769V740",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.77 644.599L1060 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.38 741.934L1060 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.61 718.355C1054.61 719.448 1055.82 720.541 1057.07 720.541C1057.39 720.541 1057.74 720.507 1058.07 720.417C1057.62 720.516 1057.25 720.417 1057.07 720.385C1056.18 720.229 1055.87 719.292 1055.87 718.355C1055.87 717.418 1054.61 717.262 1054.61 718.355Z",
    fill: "#3A4682"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.64 720.177C1057.96 720.609 1057.33 720.43 1057.07 720.385C1056.18 720.229 1055.87 719.292 1055.87 718.355C1055.87 717.418 1054.61 717.262 1054.61 718.355C1054.61 719.448 1055.82 720.541 1057.07 720.541C1058.04 720.541 1059.27 720.229 1059.27 719.031C1059.27 718.667 1059.37 718.199 1058.22 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.13 676.141L1060 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 744.953C1058.95 744.328 1059.25 743.703 1060 743.287L1060 746.618C1059.25 746.202 1058.95 745.577 1058.95 744.953Z",
    fill: "#3A4682"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 687.697C1058.95 687.072 1059.25 686.448 1060 686.031L1060 689.362C1059.25 688.946 1058.95 688.321 1058.95 687.697Z",
    fill: "#3A4682"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 678.744C1058.95 678.119 1059.25 677.495 1060 677.078L1060 680.41C1059.25 679.993 1058.95 679.369 1058.95 678.744Z",
    fill: "#3A4682"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 673.539C1058.95 672.914 1059.25 672.29 1060 671.873L1060 675.205C1059.25 674.788 1058.95 674.164 1058.95 673.539Z",
    fill: "#3A4682"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.49 647.826C1057.49 646.499 1058.2 645.171 1060 644.286L1060 651.365C1058.2 650.481 1057.49 649.153 1057.49 647.826Z",
    fill: "#3A4682"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.07 677.495L1055.29 676.141L1056.87 676.141L1058.85 676.141L1057.07 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.07 674.788L1055.29 676.141L1056.87 676.141L1058.85 676.141L1057.07 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.07 642.395L1054.77 644.599L1057.28 642.1L1055.07 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 662.608C1058.95 661.984 1059.25 661.359 1060 660.943L1060 664.274C1059.25 663.858 1058.95 663.233 1058.95 662.608Z",
    fill: "#3A4682"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 708.517L1060 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.19 709.87L1053.41 708.517L1054.98 708.517L1056.97 708.517L1055.19 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.12 710.183L1055.76 713.358L1058.12 716.497C1057.53 715.577 1057.14 715.215 1057.14 713.358C1057.14 711.5 1057.7 710.856 1058.12 710.183Z",
    fill: "#3A4682"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.22 716.637L1058.12 716.497M1058.12 716.497L1055.76 713.358L1058.12 710.183C1057.7 710.856 1057.14 711.5 1057.14 713.358C1057.14 715.215 1057.53 715.577 1058.12 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 708.517C1059.62 708.743 1058.7 709.392 1058.12 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 704.769L1060 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.19 703.416L1053.41 704.769L1054.98 704.769L1056.97 704.769L1055.19 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.12 703.104L1055.76 699.929L1058.12 696.789C1057.53 697.71 1057.14 698.071 1057.14 699.929C1057.14 701.786 1057.7 702.431 1058.12 703.104Z",
    fill: "#3A4682"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.22 696.649L1058.12 696.789M1058.12 696.789L1055.76 699.929L1058.12 703.104C1057.7 702.431 1057.14 701.786 1057.14 699.929C1057.14 698.071 1057.53 697.71 1058.12 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 704.769C1059.62 704.544 1058.7 703.895 1058.12 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.43 713.41C1058.43 712.473 1058.87 711.536 1060 710.911L1060 715.908C1058.87 715.284 1058.43 714.347 1058.43 713.41Z",
    fill: "#3A4682"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.23 644.599L1060 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.62 741.934L1060 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.39 718.355C1065.39 719.448 1064.18 720.541 1062.93 720.541C1062.61 720.541 1062.26 720.507 1061.93 720.417C1062.38 720.516 1062.75 720.417 1062.93 720.385C1063.82 720.229 1064.13 719.292 1064.13 718.355C1064.13 717.418 1065.39 717.262 1065.39 718.355Z",
    fill: "#3A4682"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.36 720.177C1062.04 720.609 1062.67 720.43 1062.93 720.385C1063.82 720.229 1064.13 719.292 1064.13 718.355C1064.13 717.418 1065.39 717.262 1065.39 718.355C1065.39 719.448 1064.18 720.541 1062.93 720.541C1061.96 720.541 1060.73 720.229 1060.73 719.031C1060.73 718.667 1060.63 718.199 1061.78 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.87 676.141L1060 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 744.953C1061.05 744.328 1060.75 743.703 1060 743.287L1060 746.618C1060.75 746.202 1061.05 745.577 1061.05 744.953Z",
    fill: "#3A4682"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 687.697C1061.05 687.072 1060.75 686.448 1060 686.031L1060 689.362C1060.75 688.946 1061.05 688.321 1061.05 687.697Z",
    fill: "#3A4682"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 678.744C1061.05 678.119 1060.75 677.495 1060 677.078L1060 680.41C1060.75 679.993 1061.05 679.369 1061.05 678.744Z",
    fill: "#3A4682"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 673.539C1061.05 672.914 1060.75 672.29 1060 671.873L1060 675.205C1060.75 674.788 1061.05 674.164 1061.05 673.539Z",
    fill: "#3A4682"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.51 647.826C1062.51 646.499 1061.8 645.171 1060 644.286L1060 651.365C1061.8 650.481 1062.51 649.153 1062.51 647.826Z",
    fill: "#3A4682"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.93 677.495L1064.71 676.141L1063.13 676.141L1061.15 676.141L1062.93 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.93 674.788L1064.71 676.141L1063.13 676.141L1061.15 676.141L1062.93 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.93 642.395L1065.23 644.599L1062.72 642.1L1064.93 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 662.608C1061.05 661.984 1060.75 661.359 1060 660.943L1060 664.274C1060.75 663.858 1061.05 663.233 1061.05 662.608Z",
    fill: "#3A4682"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 708.517L1060 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.81 709.87L1066.59 708.517L1065.02 708.517L1063.03 708.517L1064.81 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.88 710.183L1064.24 713.358L1061.88 716.497C1062.47 715.577 1062.86 715.215 1062.86 713.358C1062.86 711.5 1062.3 710.856 1061.88 710.183Z",
    fill: "#3A4682"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.78 716.637L1061.88 716.497M1061.88 716.497L1064.24 713.358L1061.88 710.183C1062.3 710.856 1062.86 711.5 1062.86 713.358C1062.86 715.215 1062.47 715.577 1061.88 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 708.517C1060.38 708.743 1061.3 709.392 1061.88 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 704.769L1060 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.81 703.416L1066.59 704.769L1065.02 704.769L1063.03 704.769L1064.81 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.88 703.104L1064.24 699.929L1061.88 696.789C1062.47 697.71 1062.86 698.071 1062.86 699.929C1062.86 701.786 1062.3 702.431 1061.88 703.104Z",
    fill: "#3A4682"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.78 696.649L1061.88 696.789M1061.88 696.789L1064.24 699.929L1061.88 703.104C1062.3 702.431 1062.86 701.786 1062.86 699.929C1062.86 698.071 1062.47 697.71 1061.88 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 704.769C1060.38 704.544 1061.3 703.895 1061.88 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.57 713.41C1061.57 712.473 1061.13 711.536 1060 710.911L1060 715.908C1061.13 715.284 1061.57 714.347 1061.57 713.41Z",
    fill: "#3A4682"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 647.878L1060 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 639.394L1060 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M964.77 644.599L970 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M967.385 741.934L970 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M964.613 718.355C964.613 719.448 965.816 720.541 967.071 720.541C967.393 720.541 967.743 720.507 968.067 720.417C967.625 720.516 967.254 720.417 967.071 720.385C966.182 720.229 965.868 719.292 965.868 718.355C965.868 717.418 964.613 717.262 964.613 718.355Z",
    fill: "#3A4682"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M968.64 720.177C967.96 720.609 967.328 720.43 967.071 720.385C966.182 720.229 965.868 719.292 965.868 718.355C965.868 717.418 964.613 717.262 964.613 718.355C964.613 719.448 965.816 720.541 967.071 720.541C968.042 720.541 969.268 720.229 969.268 719.031C969.268 718.667 969.372 718.199 968.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M966.13 676.141L970 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 744.953C968.954 744.328 969.249 743.703 970 743.287L970 746.618C969.249 746.202 968.954 745.577 968.954 744.953Z",
    fill: "#3A4682"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 687.697C968.954 687.072 969.249 686.448 970 686.031L970 689.362C969.249 688.946 968.954 688.321 968.954 687.697Z",
    fill: "#3A4682"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 678.744C968.954 678.119 969.249 677.495 970 677.078L970 680.41C969.249 679.993 968.954 679.369 968.954 678.744Z",
    fill: "#3A4682"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 673.539C968.954 672.914 969.249 672.29 970 671.873L970 675.205C969.249 674.788 968.954 674.164 968.954 673.539Z",
    fill: "#3A4682"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M967.49 647.826C967.49 646.499 968.198 645.171 970 644.286L970 651.365C968.198 650.481 967.49 649.153 967.49 647.826Z",
    fill: "#3A4682"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M967.071 677.495L965.293 676.141L966.866 676.141L968.849 676.141L967.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M967.071 674.788L965.293 676.141L966.866 676.141L968.849 676.141L967.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M965.066 642.395L964.77 644.599L967.28 642.1L965.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 662.608C968.954 661.984 969.249 661.359 970 660.943L970 664.274C969.249 663.858 968.954 663.233 968.954 662.608Z",
    fill: "#3A4682"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M963.41 708.517L970 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M965.188 709.87L963.41 708.517L964.983 708.517L966.966 708.517L965.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M968.117 710.183L965.764 713.358L968.117 716.497C967.528 715.577 967.141 715.215 967.141 713.358C967.141 711.5 967.7 710.856 968.117 710.183Z",
    fill: "#3A4682"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M968.222 716.637L968.117 716.497M968.117 716.497L965.764 713.358L968.117 710.183C967.7 710.856 967.141 711.5 967.141 713.358C967.141 715.215 967.528 715.577 968.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M970 708.517C969.616 708.743 968.703 709.392 968.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M963.41 704.769L970 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M965.188 703.416L963.41 704.769L964.983 704.769L966.966 704.769L965.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M968.117 703.104L965.764 699.929L968.117 696.789C967.528 697.71 967.141 698.071 967.141 699.929C967.141 701.786 967.7 702.431 968.117 703.104Z",
    fill: "#3A4682"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M968.222 696.649L968.117 696.789M968.117 696.789L965.764 699.929L968.117 703.104C967.7 702.431 967.141 701.786 967.141 699.929C967.141 698.071 967.528 697.71 968.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M970 704.769C969.616 704.544 968.703 703.895 968.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M968.431 713.41C968.431 712.473 968.874 711.536 970 710.911L970 715.908C968.874 715.284 968.431 714.347 968.431 713.41Z",
    fill: "#3A4682"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M975.23 644.599L970 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M972.615 741.934L970 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M975.387 718.355C975.387 719.448 974.184 720.541 972.929 720.541C972.607 720.541 972.257 720.507 971.933 720.417C972.375 720.516 972.746 720.417 972.929 720.385C973.818 720.229 974.132 719.292 974.132 718.355C974.132 717.418 975.387 717.262 975.387 718.355Z",
    fill: "#3A4682"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M971.36 720.177C972.04 720.609 972.672 720.43 972.929 720.385C973.818 720.229 974.132 719.292 974.132 718.355C974.132 717.418 975.387 717.262 975.387 718.355C975.387 719.448 974.184 720.541 972.929 720.541C971.958 720.541 970.732 720.229 970.732 719.031C970.732 718.667 970.628 718.199 971.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M973.87 676.141L970 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 744.953C971.046 744.328 970.751 743.703 970 743.287L970 746.618C970.751 746.202 971.046 745.577 971.046 744.953Z",
    fill: "#3A4682"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 687.697C971.046 687.072 970.751 686.448 970 686.031L970 689.362C970.751 688.946 971.046 688.321 971.046 687.697Z",
    fill: "#3A4682"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 678.744C971.046 678.119 970.751 677.495 970 677.078L970 680.41C970.751 679.993 971.046 679.369 971.046 678.744Z",
    fill: "#3A4682"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 673.539C971.046 672.914 970.751 672.29 970 671.873L970 675.205C970.751 674.788 971.046 674.164 971.046 673.539Z",
    fill: "#3A4682"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M972.51 647.826C972.51 646.499 971.802 645.171 970 644.286L970 651.365C971.802 650.481 972.51 649.153 972.51 647.826Z",
    fill: "#3A4682"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M972.929 677.495L974.707 676.141L973.134 676.141L971.151 676.141L972.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M972.929 674.788L974.707 676.141L973.134 676.141L971.151 676.141L972.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M974.934 642.395L975.23 644.599L972.72 642.1L974.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 662.608C971.046 661.984 970.751 661.359 970 660.943L970 664.274C970.751 663.858 971.046 663.233 971.046 662.608Z",
    fill: "#3A4682"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M976.59 708.517L970 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M974.812 709.87L976.59 708.517L975.017 708.517L973.034 708.517L974.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M971.883 710.183L974.236 713.358L971.883 716.497C972.472 715.577 972.859 715.215 972.859 713.358C972.859 711.5 972.3 710.856 971.883 710.183Z",
    fill: "#3A4682"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M971.778 716.637L971.883 716.497M971.883 716.497L974.236 713.358L971.883 710.183C972.3 710.856 972.859 711.5 972.859 713.358C972.859 715.215 972.472 715.577 971.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M970 708.517C970.384 708.743 971.297 709.392 971.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M976.59 704.769L970 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M974.812 703.416L976.59 704.769L975.017 704.769L973.034 704.769L974.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M971.883 703.104L974.236 699.929L971.883 696.789C972.472 697.71 972.859 698.071 972.859 699.929C972.859 701.786 972.3 702.431 971.883 703.104Z",
    fill: "#3A4682"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M971.778 696.649L971.883 696.789M971.883 696.789L974.236 699.929L971.883 703.104C972.3 702.431 972.859 701.786 972.859 699.929C972.859 698.071 972.472 697.71 971.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M970 704.769C970.384 704.544 971.297 703.895 971.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M971.569 713.41C971.569 712.473 971.126 711.536 970 710.911L970 715.908C971.126 715.284 971.569 714.347 971.569 713.41Z",
    fill: "#3A4682"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M970 647.878L970 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M970 639.394L970 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M874.77 644.599L880 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M877.385 741.934L880 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M874.613 718.355C874.613 719.448 875.816 720.541 877.071 720.541C877.393 720.541 877.743 720.507 878.067 720.417C877.625 720.516 877.254 720.417 877.071 720.385C876.182 720.229 875.868 719.292 875.868 718.355C875.868 717.418 874.613 717.262 874.613 718.355Z",
    fill: "#3A4682"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M878.64 720.177C877.96 720.609 877.328 720.43 877.071 720.385C876.182 720.229 875.868 719.292 875.868 718.355C875.868 717.418 874.613 717.262 874.613 718.355C874.613 719.448 875.816 720.541 877.071 720.541C878.042 720.541 879.268 720.229 879.268 719.031C879.268 718.667 879.372 718.199 878.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M876.13 676.141L880 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 744.953C878.954 744.328 879.249 743.703 880 743.287L880 746.618C879.249 746.202 878.954 745.577 878.954 744.953Z",
    fill: "#3A4682"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 687.697C878.954 687.072 879.249 686.448 880 686.031L880 689.362C879.249 688.946 878.954 688.321 878.954 687.697Z",
    fill: "#3A4682"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 678.744C878.954 678.119 879.249 677.495 880 677.078L880 680.41C879.249 679.993 878.954 679.369 878.954 678.744Z",
    fill: "#3A4682"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 673.539C878.954 672.914 879.249 672.29 880 671.873L880 675.205C879.249 674.788 878.954 674.164 878.954 673.539Z",
    fill: "#3A4682"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M877.49 647.826C877.49 646.499 878.198 645.171 880 644.286L880 651.365C878.198 650.481 877.49 649.153 877.49 647.826Z",
    fill: "#3A4682"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M877.071 677.495L875.293 676.141L876.866 676.141L878.849 676.141L877.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M877.071 674.788L875.293 676.141L876.866 676.141L878.849 676.141L877.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M875.066 642.395L874.77 644.599L877.28 642.1L875.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 662.608C878.954 661.984 879.249 661.359 880 660.943L880 664.274C879.249 663.858 878.954 663.233 878.954 662.608Z",
    fill: "#3A4682"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M873.41 708.517L880 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M875.188 709.87L873.41 708.517L874.983 708.517L876.966 708.517L875.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M878.117 710.183L875.764 713.358L878.117 716.497C877.528 715.577 877.141 715.215 877.141 713.358C877.141 711.5 877.7 710.856 878.117 710.183Z",
    fill: "#3A4682"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M878.222 716.637L878.117 716.497M878.117 716.497L875.764 713.358L878.117 710.183C877.7 710.856 877.141 711.5 877.141 713.358C877.141 715.215 877.528 715.577 878.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M880 708.517C879.616 708.743 878.703 709.392 878.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M873.41 704.769L880 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M875.188 703.416L873.41 704.769L874.983 704.769L876.966 704.769L875.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M878.117 703.104L875.764 699.929L878.117 696.789C877.528 697.71 877.141 698.071 877.141 699.929C877.141 701.786 877.7 702.431 878.117 703.104Z",
    fill: "#3A4682"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M878.222 696.649L878.117 696.789M878.117 696.789L875.764 699.929L878.117 703.104C877.7 702.431 877.141 701.786 877.141 699.929C877.141 698.071 877.528 697.71 878.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M880 704.769C879.616 704.544 878.703 703.895 878.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M878.431 713.41C878.431 712.473 878.874 711.536 880 710.911L880 715.908C878.874 715.284 878.431 714.347 878.431 713.41Z",
    fill: "#3A4682"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M885.23 644.599L880 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M882.615 741.934L880 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M885.387 718.355C885.387 719.448 884.184 720.541 882.929 720.541C882.607 720.541 882.257 720.507 881.933 720.417C882.375 720.516 882.746 720.417 882.929 720.385C883.818 720.229 884.132 719.292 884.132 718.355C884.132 717.418 885.387 717.262 885.387 718.355Z",
    fill: "#3A4682"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M881.36 720.177C882.04 720.609 882.672 720.43 882.929 720.385C883.818 720.229 884.132 719.292 884.132 718.355C884.132 717.418 885.387 717.262 885.387 718.355C885.387 719.448 884.184 720.541 882.929 720.541C881.958 720.541 880.732 720.229 880.732 719.031C880.732 718.667 880.628 718.199 881.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M883.87 676.141L880 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 744.953C881.046 744.328 880.751 743.703 880 743.287L880 746.618C880.751 746.202 881.046 745.577 881.046 744.953Z",
    fill: "#3A4682"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 687.697C881.046 687.072 880.751 686.448 880 686.031L880 689.362C880.751 688.946 881.046 688.321 881.046 687.697Z",
    fill: "#3A4682"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 678.744C881.046 678.119 880.751 677.495 880 677.078L880 680.41C880.751 679.993 881.046 679.369 881.046 678.744Z",
    fill: "#3A4682"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 673.539C881.046 672.914 880.751 672.29 880 671.873L880 675.205C880.751 674.788 881.046 674.164 881.046 673.539Z",
    fill: "#3A4682"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M882.51 647.826C882.51 646.499 881.802 645.171 880 644.286L880 651.365C881.802 650.481 882.51 649.153 882.51 647.826Z",
    fill: "#3A4682"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M882.929 677.495L884.707 676.141L883.134 676.141L881.151 676.141L882.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M882.929 674.788L884.707 676.141L883.134 676.141L881.151 676.141L882.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M884.934 642.395L885.23 644.599L882.72 642.1L884.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 662.608C881.046 661.984 880.751 661.359 880 660.943L880 664.274C880.751 663.858 881.046 663.233 881.046 662.608Z",
    fill: "#3A4682"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M886.59 708.517L880 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M884.812 709.87L886.59 708.517L885.017 708.517L883.034 708.517L884.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M881.883 710.183L884.236 713.358L881.883 716.497C882.472 715.577 882.859 715.215 882.859 713.358C882.859 711.5 882.3 710.856 881.883 710.183Z",
    fill: "#3A4682"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M881.778 716.637L881.883 716.497M881.883 716.497L884.236 713.358L881.883 710.183C882.3 710.856 882.859 711.5 882.859 713.358C882.859 715.215 882.472 715.577 881.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M880 708.517C880.384 708.743 881.297 709.392 881.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M886.59 704.769L880 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M884.812 703.416L886.59 704.769L885.017 704.769L883.034 704.769L884.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M881.883 703.104L884.236 699.929L881.883 696.789C882.472 697.71 882.859 698.071 882.859 699.929C882.859 701.786 882.3 702.431 881.883 703.104Z",
    fill: "#3A4682"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M881.778 696.649L881.883 696.789M881.883 696.789L884.236 699.929L881.883 703.104C882.3 702.431 882.859 701.786 882.859 699.929C882.859 698.071 882.472 697.71 881.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M880 704.769C880.384 704.544 881.297 703.895 881.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M881.569 713.41C881.569 712.473 881.126 711.536 880 710.911L880 715.908C881.126 715.284 881.569 714.347 881.569 713.41Z",
    fill: "#3A4682"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M880 647.878L880 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M880 639.394L880 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M784.77 644.599L790 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M787.385 741.934L790 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M784.613 718.355C784.613 719.448 785.816 720.541 787.071 720.541C787.393 720.541 787.743 720.507 788.067 720.417C787.625 720.516 787.254 720.417 787.071 720.385C786.182 720.229 785.868 719.292 785.868 718.355C785.868 717.418 784.613 717.262 784.613 718.355Z",
    fill: "#3A4682"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M788.64 720.177C787.96 720.609 787.328 720.43 787.071 720.385C786.182 720.229 785.868 719.292 785.868 718.355C785.868 717.418 784.613 717.262 784.613 718.355C784.613 719.448 785.816 720.541 787.071 720.541C788.042 720.541 789.268 720.229 789.268 719.031C789.268 718.667 789.372 718.199 788.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M786.13 676.141L790 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 744.953C788.954 744.328 789.249 743.703 790 743.287L790 746.618C789.249 746.202 788.954 745.577 788.954 744.953Z",
    fill: "#3A4682"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 687.697C788.954 687.072 789.249 686.448 790 686.031L790 689.362C789.249 688.946 788.954 688.321 788.954 687.697Z",
    fill: "#3A4682"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 678.744C788.954 678.119 789.249 677.495 790 677.078L790 680.41C789.249 679.993 788.954 679.369 788.954 678.744Z",
    fill: "#3A4682"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 673.539C788.954 672.914 789.249 672.29 790 671.873L790 675.205C789.249 674.788 788.954 674.164 788.954 673.539Z",
    fill: "#3A4682"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M787.49 647.826C787.49 646.499 788.198 645.171 790 644.286L790 651.365C788.198 650.481 787.49 649.153 787.49 647.826Z",
    fill: "#3A4682"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M787.071 677.495L785.293 676.141L786.866 676.141L788.849 676.141L787.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M787.071 674.788L785.293 676.141L786.866 676.141L788.849 676.141L787.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M785.066 642.395L784.77 644.599L787.28 642.1L785.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 662.608C788.954 661.984 789.249 661.359 790 660.943L790 664.274C789.249 663.858 788.954 663.233 788.954 662.608Z",
    fill: "#3A4682"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M783.41 708.517L790 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M785.188 709.87L783.41 708.517L784.983 708.517L786.966 708.517L785.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M788.117 710.183L785.764 713.358L788.117 716.497C787.528 715.577 787.141 715.215 787.141 713.358C787.141 711.5 787.7 710.856 788.117 710.183Z",
    fill: "#3A4682"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M788.222 716.637L788.117 716.497M788.117 716.497L785.764 713.358L788.117 710.183C787.7 710.856 787.141 711.5 787.141 713.358C787.141 715.215 787.528 715.577 788.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M790 708.517C789.616 708.743 788.703 709.392 788.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M783.41 704.769L790 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M785.188 703.416L783.41 704.769L784.983 704.769L786.966 704.769L785.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M788.117 703.104L785.764 699.929L788.117 696.789C787.528 697.71 787.141 698.071 787.141 699.929C787.141 701.786 787.7 702.431 788.117 703.104Z",
    fill: "#3A4682"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M788.222 696.649L788.117 696.789M788.117 696.789L785.764 699.929L788.117 703.104C787.7 702.431 787.141 701.786 787.141 699.929C787.141 698.071 787.528 697.71 788.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M790 704.769C789.616 704.544 788.703 703.895 788.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M788.431 713.41C788.431 712.473 788.874 711.536 790 710.911L790 715.908C788.874 715.284 788.431 714.347 788.431 713.41Z",
    fill: "#3A4682"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M795.23 644.599L790 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M792.615 741.934L790 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M795.387 718.355C795.387 719.448 794.184 720.541 792.929 720.541C792.607 720.541 792.257 720.507 791.933 720.417C792.375 720.516 792.746 720.417 792.929 720.385C793.818 720.229 794.132 719.292 794.132 718.355C794.132 717.418 795.387 717.262 795.387 718.355Z",
    fill: "#3A4682"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M791.36 720.177C792.04 720.609 792.672 720.43 792.929 720.385C793.818 720.229 794.132 719.292 794.132 718.355C794.132 717.418 795.387 717.262 795.387 718.355C795.387 719.448 794.184 720.541 792.929 720.541C791.958 720.541 790.732 720.229 790.732 719.031C790.732 718.667 790.628 718.199 791.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M793.87 676.141L790 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 744.953C791.046 744.328 790.751 743.703 790 743.287L790 746.618C790.751 746.202 791.046 745.577 791.046 744.953Z",
    fill: "#3A4682"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 687.697C791.046 687.072 790.751 686.448 790 686.031L790 689.362C790.751 688.946 791.046 688.321 791.046 687.697Z",
    fill: "#3A4682"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 678.744C791.046 678.119 790.751 677.495 790 677.078L790 680.41C790.751 679.993 791.046 679.369 791.046 678.744Z",
    fill: "#3A4682"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 673.539C791.046 672.914 790.751 672.29 790 671.873L790 675.205C790.751 674.788 791.046 674.164 791.046 673.539Z",
    fill: "#3A4682"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M792.51 647.826C792.51 646.499 791.802 645.171 790 644.286L790 651.365C791.802 650.481 792.51 649.153 792.51 647.826Z",
    fill: "#3A4682"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M792.929 677.495L794.707 676.141L793.134 676.141L791.151 676.141L792.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M792.929 674.788L794.707 676.141L793.134 676.141L791.151 676.141L792.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M794.934 642.395L795.23 644.599L792.72 642.1L794.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 662.608C791.046 661.984 790.751 661.359 790 660.943L790 664.274C790.751 663.858 791.046 663.233 791.046 662.608Z",
    fill: "#3A4682"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M796.59 708.517L790 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M794.812 709.87L796.59 708.517L795.017 708.517L793.034 708.517L794.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M791.883 710.183L794.236 713.358L791.883 716.497C792.472 715.577 792.859 715.215 792.859 713.358C792.859 711.5 792.3 710.856 791.883 710.183Z",
    fill: "#3A4682"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M791.778 716.637L791.883 716.497M791.883 716.497L794.236 713.358L791.883 710.183C792.3 710.856 792.859 711.5 792.859 713.358C792.859 715.215 792.472 715.577 791.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M790 708.517C790.384 708.743 791.297 709.392 791.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M796.59 704.769L790 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M794.812 703.416L796.59 704.769L795.017 704.769L793.034 704.769L794.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M791.883 703.104L794.236 699.929L791.883 696.789C792.472 697.71 792.859 698.071 792.859 699.929C792.859 701.786 792.3 702.431 791.883 703.104Z",
    fill: "#3A4682"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M791.778 696.649L791.883 696.789M791.883 696.789L794.236 699.929L791.883 703.104C792.3 702.431 792.859 701.786 792.859 699.929C792.859 698.071 792.472 697.71 791.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M790 704.769C790.384 704.544 791.297 703.895 791.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M791.569 713.41C791.569 712.473 791.126 711.536 790 710.911L790 715.908C791.126 715.284 791.569 714.347 791.569 713.41Z",
    fill: "#3A4682"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M790 647.878L790 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M790 639.394L790 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M694.77 644.599L700 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M697.385 741.934L700 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M694.613 718.355C694.613 719.448 695.816 720.541 697.071 720.541C697.393 720.541 697.743 720.507 698.067 720.417C697.625 720.516 697.254 720.417 697.071 720.385C696.182 720.229 695.868 719.292 695.868 718.355C695.868 717.418 694.613 717.262 694.613 718.355Z",
    fill: "#3A4682"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M698.64 720.177C697.96 720.609 697.328 720.43 697.071 720.385C696.182 720.229 695.868 719.292 695.868 718.355C695.868 717.418 694.613 717.262 694.613 718.355C694.613 719.448 695.816 720.541 697.071 720.541C698.042 720.541 699.268 720.229 699.268 719.031C699.268 718.667 699.372 718.199 698.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M696.13 676.141L700 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 744.953C698.954 744.328 699.249 743.703 700 743.287L700 746.618C699.249 746.202 698.954 745.577 698.954 744.953Z",
    fill: "#3A4682"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 687.697C698.954 687.072 699.249 686.448 700 686.031L700 689.362C699.249 688.946 698.954 688.321 698.954 687.697Z",
    fill: "#3A4682"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 678.744C698.954 678.119 699.249 677.495 700 677.078L700 680.41C699.249 679.993 698.954 679.369 698.954 678.744Z",
    fill: "#3A4682"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 673.539C698.954 672.914 699.249 672.29 700 671.873L700 675.205C699.249 674.788 698.954 674.164 698.954 673.539Z",
    fill: "#3A4682"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M697.49 647.826C697.49 646.499 698.198 645.171 700 644.286L700 651.365C698.198 650.481 697.49 649.153 697.49 647.826Z",
    fill: "#3A4682"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M697.071 677.495L695.293 676.141L696.866 676.141L698.849 676.141L697.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M697.071 674.788L695.293 676.141L696.866 676.141L698.849 676.141L697.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M695.066 642.395L694.77 644.599L697.28 642.1L695.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 662.608C698.954 661.984 699.249 661.359 700 660.943L700 664.274C699.249 663.858 698.954 663.233 698.954 662.608Z",
    fill: "#3A4682"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M693.41 708.517L700 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M695.188 709.87L693.41 708.517L694.983 708.517L696.966 708.517L695.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M698.117 710.183L695.764 713.358L698.117 716.497C697.528 715.577 697.141 715.215 697.141 713.358C697.141 711.5 697.7 710.856 698.117 710.183Z",
    fill: "#3A4682"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M698.222 716.637L698.117 716.497M698.117 716.497L695.764 713.358L698.117 710.183C697.7 710.856 697.141 711.5 697.141 713.358C697.141 715.215 697.528 715.577 698.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M700 708.517C699.616 708.743 698.703 709.392 698.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M693.41 704.769L700 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M695.188 703.416L693.41 704.769L694.983 704.769L696.966 704.769L695.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M698.117 703.104L695.764 699.929L698.117 696.789C697.528 697.71 697.141 698.071 697.141 699.929C697.141 701.786 697.7 702.431 698.117 703.104Z",
    fill: "#3A4682"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M698.222 696.649L698.117 696.789M698.117 696.789L695.764 699.929L698.117 703.104C697.7 702.431 697.141 701.786 697.141 699.929C697.141 698.071 697.528 697.71 698.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M700 704.769C699.616 704.544 698.703 703.895 698.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M698.431 713.41C698.431 712.473 698.874 711.536 700 710.911L700 715.908C698.874 715.284 698.431 714.347 698.431 713.41Z",
    fill: "#3A4682"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M705.23 644.599L700 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M702.615 741.934L700 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M705.387 718.355C705.387 719.448 704.184 720.541 702.929 720.541C702.607 720.541 702.257 720.507 701.933 720.417C702.375 720.516 702.746 720.417 702.929 720.385C703.818 720.229 704.132 719.292 704.132 718.355C704.132 717.418 705.387 717.262 705.387 718.355Z",
    fill: "#3A4682"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M701.36 720.177C702.04 720.609 702.672 720.43 702.929 720.385C703.818 720.229 704.132 719.292 704.132 718.355C704.132 717.418 705.387 717.262 705.387 718.355C705.387 719.448 704.184 720.541 702.929 720.541C701.958 720.541 700.732 720.229 700.732 719.031C700.732 718.667 700.628 718.199 701.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M703.87 676.141L700 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 744.953C701.046 744.328 700.751 743.703 700 743.287L700 746.618C700.751 746.202 701.046 745.577 701.046 744.953Z",
    fill: "#3A4682"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 687.697C701.046 687.072 700.751 686.448 700 686.031L700 689.362C700.751 688.946 701.046 688.321 701.046 687.697Z",
    fill: "#3A4682"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 678.744C701.046 678.119 700.751 677.495 700 677.078L700 680.41C700.751 679.993 701.046 679.369 701.046 678.744Z",
    fill: "#3A4682"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 673.539C701.046 672.914 700.751 672.29 700 671.873L700 675.205C700.751 674.788 701.046 674.164 701.046 673.539Z",
    fill: "#3A4682"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M702.51 647.826C702.51 646.499 701.802 645.171 700 644.286L700 651.365C701.802 650.481 702.51 649.153 702.51 647.826Z",
    fill: "#3A4682"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M702.929 677.495L704.707 676.141L703.134 676.141L701.151 676.141L702.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M702.929 674.788L704.707 676.141L703.134 676.141L701.151 676.141L702.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M704.934 642.395L705.23 644.599L702.72 642.1L704.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 662.608C701.046 661.984 700.751 661.359 700 660.943L700 664.274C700.751 663.858 701.046 663.233 701.046 662.608Z",
    fill: "#3A4682"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M706.59 708.517L700 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M704.812 709.87L706.59 708.517L705.017 708.517L703.034 708.517L704.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M701.883 710.183L704.236 713.358L701.883 716.497C702.472 715.577 702.859 715.215 702.859 713.358C702.859 711.5 702.3 710.856 701.883 710.183Z",
    fill: "#3A4682"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M701.778 716.637L701.883 716.497M701.883 716.497L704.236 713.358L701.883 710.183C702.3 710.856 702.859 711.5 702.859 713.358C702.859 715.215 702.472 715.577 701.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M700 708.517C700.384 708.743 701.297 709.392 701.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M706.59 704.769L700 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M704.812 703.416L706.59 704.769L705.017 704.769L703.034 704.769L704.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M701.883 703.104L704.236 699.929L701.883 696.789C702.472 697.71 702.859 698.071 702.859 699.929C702.859 701.786 702.3 702.431 701.883 703.104Z",
    fill: "#3A4682"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M701.778 696.649L701.883 696.789M701.883 696.789L704.236 699.929L701.883 703.104C702.3 702.431 702.859 701.786 702.859 699.929C702.859 698.071 702.472 697.71 701.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M700 704.769C700.384 704.544 701.297 703.895 701.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M701.569 713.41C701.569 712.473 701.126 711.536 700 710.911L700 715.908C701.126 715.284 701.569 714.347 701.569 713.41Z",
    fill: "#3A4682"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M700 647.878L700 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M700 639.394L700 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M604.77 644.599L610 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M607.385 741.934L610 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M604.613 718.355C604.613 719.448 605.816 720.541 607.071 720.541C607.393 720.541 607.743 720.507 608.067 720.417C607.625 720.516 607.254 720.417 607.071 720.385C606.182 720.229 605.868 719.292 605.868 718.355C605.868 717.418 604.613 717.262 604.613 718.355Z",
    fill: "#3A4682"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M608.64 720.177C607.96 720.609 607.328 720.43 607.071 720.385C606.182 720.229 605.868 719.292 605.868 718.355C605.868 717.418 604.613 717.262 604.613 718.355C604.613 719.448 605.816 720.541 607.071 720.541C608.042 720.541 609.268 720.229 609.268 719.031C609.268 718.667 609.372 718.199 608.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M606.13 676.141L610 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 744.953C608.954 744.328 609.249 743.703 610 743.287L610 746.618C609.249 746.202 608.954 745.577 608.954 744.953Z",
    fill: "#3A4682"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 687.697C608.954 687.072 609.249 686.448 610 686.031L610 689.362C609.249 688.946 608.954 688.321 608.954 687.697Z",
    fill: "#3A4682"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 678.744C608.954 678.119 609.249 677.495 610 677.078L610 680.41C609.249 679.993 608.954 679.369 608.954 678.744Z",
    fill: "#3A4682"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 673.539C608.954 672.914 609.249 672.29 610 671.873L610 675.205C609.249 674.788 608.954 674.164 608.954 673.539Z",
    fill: "#3A4682"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M607.49 647.826C607.49 646.499 608.198 645.171 610 644.286L610 651.365C608.198 650.481 607.49 649.153 607.49 647.826Z",
    fill: "#3A4682"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M607.071 677.495L605.293 676.141L606.866 676.141L608.849 676.141L607.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M607.071 674.788L605.293 676.141L606.866 676.141L608.849 676.141L607.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M605.066 642.395L604.77 644.599L607.28 642.1L605.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 662.608C608.954 661.984 609.249 661.359 610 660.943L610 664.274C609.249 663.858 608.954 663.233 608.954 662.608Z",
    fill: "#3A4682"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M603.41 708.517L610 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M605.188 709.87L603.41 708.517L604.983 708.517L606.966 708.517L605.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M608.117 710.183L605.764 713.358L608.117 716.497C607.528 715.577 607.141 715.215 607.141 713.358C607.141 711.5 607.7 710.856 608.117 710.183Z",
    fill: "#3A4682"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M608.222 716.637L608.117 716.497M608.117 716.497L605.764 713.358L608.117 710.183C607.7 710.856 607.141 711.5 607.141 713.358C607.141 715.215 607.528 715.577 608.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M610 708.517C609.616 708.743 608.703 709.392 608.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M603.41 704.769L610 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M605.188 703.416L603.41 704.769L604.983 704.769L606.966 704.769L605.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M608.117 703.104L605.764 699.929L608.117 696.789C607.528 697.71 607.141 698.071 607.141 699.929C607.141 701.786 607.7 702.431 608.117 703.104Z",
    fill: "#3A4682"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M608.222 696.649L608.117 696.789M608.117 696.789L605.764 699.929L608.117 703.104C607.7 702.431 607.141 701.786 607.141 699.929C607.141 698.071 607.528 697.71 608.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M610 704.769C609.616 704.544 608.703 703.895 608.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M608.431 713.41C608.431 712.473 608.874 711.536 610 710.911L610 715.908C608.874 715.284 608.431 714.347 608.431 713.41Z",
    fill: "#3A4682"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M615.23 644.599L610 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M612.615 741.934L610 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M615.387 718.355C615.387 719.448 614.184 720.541 612.929 720.541C612.607 720.541 612.257 720.507 611.933 720.417C612.375 720.516 612.746 720.417 612.929 720.385C613.818 720.229 614.132 719.292 614.132 718.355C614.132 717.418 615.387 717.262 615.387 718.355Z",
    fill: "#3A4682"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M611.36 720.177C612.04 720.609 612.672 720.43 612.929 720.385C613.818 720.229 614.132 719.292 614.132 718.355C614.132 717.418 615.387 717.262 615.387 718.355C615.387 719.448 614.184 720.541 612.929 720.541C611.958 720.541 610.732 720.229 610.732 719.031C610.732 718.667 610.628 718.199 611.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M613.87 676.141L610 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 744.953C611.046 744.328 610.751 743.703 610 743.287L610 746.618C610.751 746.202 611.046 745.577 611.046 744.953Z",
    fill: "#3A4682"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 687.697C611.046 687.072 610.751 686.448 610 686.031L610 689.362C610.751 688.946 611.046 688.321 611.046 687.697Z",
    fill: "#3A4682"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 678.744C611.046 678.119 610.751 677.495 610 677.078L610 680.41C610.751 679.993 611.046 679.369 611.046 678.744Z",
    fill: "#3A4682"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 673.539C611.046 672.914 610.751 672.29 610 671.873L610 675.205C610.751 674.788 611.046 674.164 611.046 673.539Z",
    fill: "#3A4682"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M612.51 647.826C612.51 646.499 611.802 645.171 610 644.286L610 651.365C611.802 650.481 612.51 649.153 612.51 647.826Z",
    fill: "#3A4682"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M612.929 677.495L614.707 676.141L613.134 676.141L611.151 676.141L612.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M612.929 674.788L614.707 676.141L613.134 676.141L611.151 676.141L612.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M614.934 642.395L615.23 644.599L612.72 642.1L614.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 662.608C611.046 661.984 610.751 661.359 610 660.943L610 664.274C610.751 663.858 611.046 663.233 611.046 662.608Z",
    fill: "#3A4682"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M616.59 708.517L610 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M614.812 709.87L616.59 708.517L615.017 708.517L613.034 708.517L614.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M611.883 710.183L614.236 713.358L611.883 716.497C612.472 715.577 612.859 715.215 612.859 713.358C612.859 711.5 612.3 710.856 611.883 710.183Z",
    fill: "#3A4682"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M611.778 716.637L611.883 716.497M611.883 716.497L614.236 713.358L611.883 710.183C612.3 710.856 612.859 711.5 612.859 713.358C612.859 715.215 612.472 715.577 611.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M610 708.517C610.384 708.743 611.297 709.392 611.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M616.59 704.769L610 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M614.812 703.416L616.59 704.769L615.017 704.769L613.034 704.769L614.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M611.883 703.104L614.236 699.929L611.883 696.789C612.472 697.71 612.859 698.071 612.859 699.929C612.859 701.786 612.3 702.431 611.883 703.104Z",
    fill: "#3A4682"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M611.778 696.649L611.883 696.789M611.883 696.789L614.236 699.929L611.883 703.104C612.3 702.431 612.859 701.786 612.859 699.929C612.859 698.071 612.472 697.71 611.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M610 704.769C610.384 704.544 611.297 703.895 611.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M611.569 713.41C611.569 712.473 611.126 711.536 610 710.911L610 715.908C611.126 715.284 611.569 714.347 611.569 713.41Z",
    fill: "#3A4682"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M610 647.878L610 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M610 639.394L610 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M514.77 644.599L520 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M517.385 741.934L520 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M514.613 718.355C514.613 719.448 515.816 720.541 517.071 720.541C517.393 720.541 517.743 720.507 518.067 720.417C517.625 720.516 517.254 720.417 517.071 720.385C516.182 720.229 515.868 719.292 515.868 718.355C515.868 717.418 514.613 717.262 514.613 718.355Z",
    fill: "#3A4682"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M518.64 720.177C517.96 720.609 517.328 720.43 517.071 720.385C516.182 720.229 515.868 719.292 515.868 718.355C515.868 717.418 514.613 717.262 514.613 718.355C514.613 719.448 515.816 720.541 517.071 720.541C518.042 720.541 519.268 720.229 519.268 719.031C519.268 718.667 519.372 718.199 518.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M516.13 676.141L520 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 744.953C518.954 744.328 519.249 743.703 520 743.287L520 746.618C519.249 746.202 518.954 745.577 518.954 744.953Z",
    fill: "#3A4682"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 687.697C518.954 687.072 519.249 686.448 520 686.031L520 689.362C519.249 688.946 518.954 688.321 518.954 687.697Z",
    fill: "#3A4682"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 678.744C518.954 678.119 519.249 677.495 520 677.078L520 680.41C519.249 679.993 518.954 679.369 518.954 678.744Z",
    fill: "#3A4682"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 673.539C518.954 672.914 519.249 672.29 520 671.873L520 675.205C519.249 674.788 518.954 674.164 518.954 673.539Z",
    fill: "#3A4682"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M517.49 647.826C517.49 646.499 518.198 645.171 520 644.286L520 651.365C518.198 650.481 517.49 649.153 517.49 647.826Z",
    fill: "#3A4682"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M517.071 677.495L515.293 676.141L516.866 676.141L518.849 676.141L517.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M517.071 674.788L515.293 676.141L516.866 676.141L518.849 676.141L517.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M515.066 642.395L514.77 644.599L517.28 642.1L515.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 662.608C518.954 661.984 519.249 661.359 520 660.943L520 664.274C519.249 663.858 518.954 663.233 518.954 662.608Z",
    fill: "#3A4682"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M513.41 708.517L520 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M515.188 709.87L513.41 708.517L514.983 708.517L516.966 708.517L515.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M518.117 710.183L515.764 713.358L518.117 716.497C517.528 715.577 517.141 715.215 517.141 713.358C517.141 711.5 517.7 710.856 518.117 710.183Z",
    fill: "#3A4682"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M518.222 716.637L518.117 716.497M518.117 716.497L515.764 713.358L518.117 710.183C517.7 710.856 517.141 711.5 517.141 713.358C517.141 715.215 517.528 715.577 518.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M520 708.517C519.616 708.743 518.703 709.392 518.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M513.41 704.769L520 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M515.188 703.416L513.41 704.769L514.983 704.769L516.966 704.769L515.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M518.117 703.104L515.764 699.929L518.117 696.789C517.528 697.71 517.141 698.071 517.141 699.929C517.141 701.786 517.7 702.431 518.117 703.104Z",
    fill: "#3A4682"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M518.222 696.649L518.117 696.789M518.117 696.789L515.764 699.929L518.117 703.104C517.7 702.431 517.141 701.786 517.141 699.929C517.141 698.071 517.528 697.71 518.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M520 704.769C519.616 704.544 518.703 703.895 518.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M518.431 713.41C518.431 712.473 518.874 711.536 520 710.911L520 715.908C518.874 715.284 518.431 714.347 518.431 713.41Z",
    fill: "#3A4682"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M525.23 644.599L520 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M522.615 741.934L520 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M525.387 718.355C525.387 719.448 524.184 720.541 522.929 720.541C522.607 720.541 522.257 720.507 521.933 720.417C522.375 720.516 522.746 720.417 522.929 720.385C523.818 720.229 524.132 719.292 524.132 718.355C524.132 717.418 525.387 717.262 525.387 718.355Z",
    fill: "#3A4682"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M521.36 720.177C522.04 720.609 522.672 720.43 522.929 720.385C523.818 720.229 524.132 719.292 524.132 718.355C524.132 717.418 525.387 717.262 525.387 718.355C525.387 719.448 524.184 720.541 522.929 720.541C521.958 720.541 520.732 720.229 520.732 719.031C520.732 718.667 520.628 718.199 521.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M523.87 676.141L520 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 744.953C521.046 744.328 520.751 743.703 520 743.287L520 746.618C520.751 746.202 521.046 745.577 521.046 744.953Z",
    fill: "#3A4682"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 687.697C521.046 687.072 520.751 686.448 520 686.031L520 689.362C520.751 688.946 521.046 688.321 521.046 687.697Z",
    fill: "#3A4682"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 678.744C521.046 678.119 520.751 677.495 520 677.078L520 680.41C520.751 679.993 521.046 679.369 521.046 678.744Z",
    fill: "#3A4682"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 673.539C521.046 672.914 520.751 672.29 520 671.873L520 675.205C520.751 674.788 521.046 674.164 521.046 673.539Z",
    fill: "#3A4682"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M522.51 647.826C522.51 646.499 521.802 645.171 520 644.286L520 651.365C521.802 650.481 522.51 649.153 522.51 647.826Z",
    fill: "#3A4682"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M522.929 677.495L524.707 676.141L523.134 676.141L521.151 676.141L522.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M522.929 674.788L524.707 676.141L523.134 676.141L521.151 676.141L522.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M524.934 642.395L525.23 644.599L522.72 642.1L524.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 662.608C521.046 661.984 520.751 661.359 520 660.943L520 664.274C520.751 663.858 521.046 663.233 521.046 662.608Z",
    fill: "#3A4682"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M526.59 708.517L520 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M524.812 709.87L526.59 708.517L525.017 708.517L523.034 708.517L524.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M521.883 710.183L524.236 713.358L521.883 716.497C522.472 715.577 522.859 715.215 522.859 713.358C522.859 711.5 522.3 710.856 521.883 710.183Z",
    fill: "#3A4682"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M521.778 716.637L521.883 716.497M521.883 716.497L524.236 713.358L521.883 710.183C522.3 710.856 522.859 711.5 522.859 713.358C522.859 715.215 522.472 715.577 521.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M520 708.517C520.384 708.743 521.297 709.392 521.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M526.59 704.769L520 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M524.812 703.416L526.59 704.769L525.017 704.769L523.034 704.769L524.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M521.883 703.104L524.236 699.929L521.883 696.789C522.472 697.71 522.859 698.071 522.859 699.929C522.859 701.786 522.3 702.431 521.883 703.104Z",
    fill: "#3A4682"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M521.778 696.649L521.883 696.789M521.883 696.789L524.236 699.929L521.883 703.104C522.3 702.431 522.859 701.786 522.859 699.929C522.859 698.071 522.472 697.71 521.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M520 704.769C520.384 704.544 521.297 703.895 521.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M521.569 713.41C521.569 712.473 521.126 711.536 520 710.911L520 715.908C521.126 715.284 521.569 714.347 521.569 713.41Z",
    fill: "#3A4682"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M520 647.878L520 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M520 639.394L520 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M424.77 644.599L430 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M427.385 741.934L430 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M424.613 718.355C424.613 719.448 425.816 720.541 427.071 720.541C427.393 720.541 427.743 720.507 428.067 720.417C427.625 720.516 427.254 720.417 427.071 720.385C426.182 720.229 425.868 719.292 425.868 718.355C425.868 717.418 424.613 717.262 424.613 718.355Z",
    fill: "#3A4682"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M428.64 720.177C427.96 720.609 427.328 720.43 427.071 720.385C426.182 720.229 425.868 719.292 425.868 718.355C425.868 717.418 424.613 717.262 424.613 718.355C424.613 719.448 425.816 720.541 427.071 720.541C428.042 720.541 429.268 720.229 429.268 719.031C429.268 718.667 429.372 718.199 428.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M426.13 676.141L430 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 744.953C428.954 744.328 429.249 743.703 430 743.287L430 746.618C429.249 746.202 428.954 745.577 428.954 744.953Z",
    fill: "#3A4682"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 687.697C428.954 687.072 429.249 686.448 430 686.031L430 689.362C429.249 688.946 428.954 688.321 428.954 687.697Z",
    fill: "#3A4682"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 678.744C428.954 678.119 429.249 677.495 430 677.078L430 680.41C429.249 679.993 428.954 679.369 428.954 678.744Z",
    fill: "#3A4682"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 673.539C428.954 672.914 429.249 672.29 430 671.873L430 675.205C429.249 674.788 428.954 674.164 428.954 673.539Z",
    fill: "#3A4682"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M427.49 647.826C427.49 646.499 428.198 645.171 430 644.286L430 651.365C428.198 650.481 427.49 649.153 427.49 647.826Z",
    fill: "#3A4682"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M427.071 677.495L425.293 676.141L426.866 676.141L428.849 676.141L427.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M427.071 674.788L425.293 676.141L426.866 676.141L428.849 676.141L427.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M425.066 642.395L424.77 644.599L427.28 642.1L425.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 662.608C428.954 661.984 429.249 661.359 430 660.943L430 664.274C429.249 663.858 428.954 663.233 428.954 662.608Z",
    fill: "#3A4682"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M423.41 708.517L430 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M425.188 709.87L423.41 708.517L424.983 708.517L426.966 708.517L425.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M428.117 710.183L425.764 713.358L428.117 716.497C427.528 715.577 427.141 715.215 427.141 713.358C427.141 711.5 427.7 710.856 428.117 710.183Z",
    fill: "#3A4682"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M428.222 716.637L428.117 716.497M428.117 716.497L425.764 713.358L428.117 710.183C427.7 710.856 427.141 711.5 427.141 713.358C427.141 715.215 427.528 715.577 428.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M430 708.517C429.616 708.743 428.703 709.392 428.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M423.41 704.769L430 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M425.188 703.416L423.41 704.769L424.983 704.769L426.966 704.769L425.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M428.117 703.104L425.764 699.929L428.117 696.789C427.528 697.71 427.141 698.071 427.141 699.929C427.141 701.786 427.7 702.431 428.117 703.104Z",
    fill: "#3A4682"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M428.222 696.649L428.117 696.789M428.117 696.789L425.764 699.929L428.117 703.104C427.7 702.431 427.141 701.786 427.141 699.929C427.141 698.071 427.528 697.71 428.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M430 704.769C429.616 704.544 428.703 703.895 428.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M428.431 713.41C428.431 712.473 428.874 711.536 430 710.911L430 715.908C428.874 715.284 428.431 714.347 428.431 713.41Z",
    fill: "#3A4682"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M435.23 644.599L430 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M432.615 741.934L430 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M435.387 718.355C435.387 719.448 434.184 720.541 432.929 720.541C432.607 720.541 432.257 720.507 431.933 720.417C432.375 720.516 432.746 720.417 432.929 720.385C433.818 720.229 434.132 719.292 434.132 718.355C434.132 717.418 435.387 717.262 435.387 718.355Z",
    fill: "#3A4682"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M431.36 720.177C432.04 720.609 432.672 720.43 432.929 720.385C433.818 720.229 434.132 719.292 434.132 718.355C434.132 717.418 435.387 717.262 435.387 718.355C435.387 719.448 434.184 720.541 432.929 720.541C431.958 720.541 430.732 720.229 430.732 719.031C430.732 718.667 430.628 718.199 431.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M433.87 676.141L430 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 744.953C431.046 744.328 430.751 743.703 430 743.287L430 746.618C430.751 746.202 431.046 745.577 431.046 744.953Z",
    fill: "#3A4682"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 687.697C431.046 687.072 430.751 686.448 430 686.031L430 689.362C430.751 688.946 431.046 688.321 431.046 687.697Z",
    fill: "#3A4682"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 678.744C431.046 678.119 430.751 677.495 430 677.078L430 680.41C430.751 679.993 431.046 679.369 431.046 678.744Z",
    fill: "#3A4682"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 673.539C431.046 672.914 430.751 672.29 430 671.873L430 675.205C430.751 674.788 431.046 674.164 431.046 673.539Z",
    fill: "#3A4682"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M432.51 647.826C432.51 646.499 431.802 645.171 430 644.286L430 651.365C431.802 650.481 432.51 649.153 432.51 647.826Z",
    fill: "#3A4682"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M432.929 677.495L434.707 676.141L433.134 676.141L431.151 676.141L432.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M432.929 674.788L434.707 676.141L433.134 676.141L431.151 676.141L432.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M434.934 642.395L435.23 644.599L432.72 642.1L434.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 662.608C431.046 661.984 430.751 661.359 430 660.943L430 664.274C430.751 663.858 431.046 663.233 431.046 662.608Z",
    fill: "#3A4682"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M436.59 708.517L430 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M434.812 709.87L436.59 708.517L435.017 708.517L433.034 708.517L434.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M431.883 710.183L434.236 713.358L431.883 716.497C432.472 715.577 432.859 715.215 432.859 713.358C432.859 711.5 432.3 710.856 431.883 710.183Z",
    fill: "#3A4682"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M431.778 716.637L431.883 716.497M431.883 716.497L434.236 713.358L431.883 710.183C432.3 710.856 432.859 711.5 432.859 713.358C432.859 715.215 432.472 715.577 431.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M430 708.517C430.384 708.743 431.297 709.392 431.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M436.59 704.769L430 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M434.812 703.416L436.59 704.769L435.017 704.769L433.034 704.769L434.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M431.883 703.104L434.236 699.929L431.883 696.789C432.472 697.71 432.859 698.071 432.859 699.929C432.859 701.786 432.3 702.431 431.883 703.104Z",
    fill: "#3A4682"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M431.778 696.649L431.883 696.789M431.883 696.789L434.236 699.929L431.883 703.104C432.3 702.431 432.859 701.786 432.859 699.929C432.859 698.071 432.472 697.71 431.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M430 704.769C430.384 704.544 431.297 703.895 431.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M431.569 713.41C431.569 712.473 431.126 711.536 430 710.911L430 715.908C431.126 715.284 431.569 714.347 431.569 713.41Z",
    fill: "#3A4682"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M430 647.878L430 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M430 639.394L430 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M334.77 644.599L340 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M337.385 741.934L340 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M334.613 718.355C334.613 719.448 335.816 720.541 337.071 720.541C337.393 720.541 337.743 720.507 338.067 720.417C337.625 720.516 337.254 720.417 337.071 720.385C336.182 720.229 335.868 719.292 335.868 718.355C335.868 717.418 334.613 717.262 334.613 718.355Z",
    fill: "#3A4682"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M338.64 720.177C337.96 720.609 337.328 720.43 337.071 720.385C336.182 720.229 335.868 719.292 335.868 718.355C335.868 717.418 334.613 717.262 334.613 718.355C334.613 719.448 335.816 720.541 337.071 720.541C338.042 720.541 339.268 720.229 339.268 719.031C339.268 718.667 339.372 718.199 338.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M336.13 676.141L340 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 744.953C338.954 744.328 339.249 743.703 340 743.287L340 746.618C339.249 746.202 338.954 745.577 338.954 744.953Z",
    fill: "#3A4682"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 687.697C338.954 687.072 339.249 686.448 340 686.031L340 689.362C339.249 688.946 338.954 688.321 338.954 687.697Z",
    fill: "#3A4682"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 678.744C338.954 678.119 339.249 677.495 340 677.078L340 680.41C339.249 679.993 338.954 679.369 338.954 678.744Z",
    fill: "#3A4682"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 673.539C338.954 672.914 339.249 672.29 340 671.873L340 675.205C339.249 674.788 338.954 674.164 338.954 673.539Z",
    fill: "#3A4682"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M337.49 647.826C337.49 646.499 338.198 645.171 340 644.286L340 651.365C338.198 650.481 337.49 649.153 337.49 647.826Z",
    fill: "#3A4682"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M337.071 677.495L335.293 676.141L336.866 676.141L338.849 676.141L337.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M337.071 674.788L335.293 676.141L336.866 676.141L338.849 676.141L337.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M335.066 642.395L334.77 644.599L337.28 642.1L335.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 662.608C338.954 661.984 339.249 661.359 340 660.943L340 664.274C339.249 663.858 338.954 663.233 338.954 662.608Z",
    fill: "#3A4682"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M333.41 708.517L340 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M335.188 709.87L333.41 708.517L334.983 708.517L336.966 708.517L335.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M338.117 710.183L335.764 713.358L338.117 716.497C337.528 715.577 337.141 715.215 337.141 713.358C337.141 711.5 337.7 710.856 338.117 710.183Z",
    fill: "#3A4682"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M338.222 716.637L338.117 716.497M338.117 716.497L335.764 713.358L338.117 710.183C337.7 710.856 337.141 711.5 337.141 713.358C337.141 715.215 337.528 715.577 338.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M340 708.517C339.616 708.743 338.703 709.392 338.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M333.41 704.769L340 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M335.188 703.416L333.41 704.769L334.983 704.769L336.966 704.769L335.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M338.117 703.104L335.764 699.929L338.117 696.789C337.528 697.71 337.141 698.071 337.141 699.929C337.141 701.786 337.7 702.431 338.117 703.104Z",
    fill: "#3A4682"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M338.222 696.649L338.117 696.789M338.117 696.789L335.764 699.929L338.117 703.104C337.7 702.431 337.141 701.786 337.141 699.929C337.141 698.071 337.528 697.71 338.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M340 704.769C339.616 704.544 338.703 703.895 338.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M338.431 713.41C338.431 712.473 338.874 711.536 340 710.911L340 715.908C338.874 715.284 338.431 714.347 338.431 713.41Z",
    fill: "#3A4682"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M345.23 644.599L340 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M342.615 741.934L340 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M345.387 718.355C345.387 719.448 344.184 720.541 342.929 720.541C342.607 720.541 342.257 720.507 341.933 720.417C342.375 720.516 342.746 720.417 342.929 720.385C343.818 720.229 344.132 719.292 344.132 718.355C344.132 717.418 345.387 717.262 345.387 718.355Z",
    fill: "#3A4682"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M341.36 720.177C342.04 720.609 342.672 720.43 342.929 720.385C343.818 720.229 344.132 719.292 344.132 718.355C344.132 717.418 345.387 717.262 345.387 718.355C345.387 719.448 344.184 720.541 342.929 720.541C341.958 720.541 340.732 720.229 340.732 719.031C340.732 718.667 340.628 718.199 341.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M343.87 676.141L340 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 744.953C341.046 744.328 340.751 743.703 340 743.287L340 746.618C340.751 746.202 341.046 745.577 341.046 744.953Z",
    fill: "#3A4682"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 687.697C341.046 687.072 340.751 686.448 340 686.031L340 689.362C340.751 688.946 341.046 688.321 341.046 687.697Z",
    fill: "#3A4682"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 678.744C341.046 678.119 340.751 677.495 340 677.078L340 680.41C340.751 679.993 341.046 679.369 341.046 678.744Z",
    fill: "#3A4682"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 673.539C341.046 672.914 340.751 672.29 340 671.873L340 675.205C340.751 674.788 341.046 674.164 341.046 673.539Z",
    fill: "#3A4682"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M342.51 647.826C342.51 646.499 341.802 645.171 340 644.286L340 651.365C341.802 650.481 342.51 649.153 342.51 647.826Z",
    fill: "#3A4682"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M342.929 677.495L344.707 676.141L343.134 676.141L341.151 676.141L342.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M342.929 674.788L344.707 676.141L343.134 676.141L341.151 676.141L342.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M344.934 642.395L345.23 644.599L342.72 642.1L344.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 662.608C341.046 661.984 340.751 661.359 340 660.943L340 664.274C340.751 663.858 341.046 663.233 341.046 662.608Z",
    fill: "#3A4682"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M346.59 708.517L340 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M344.812 709.87L346.59 708.517L345.017 708.517L343.034 708.517L344.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M341.883 710.183L344.236 713.358L341.883 716.497C342.472 715.577 342.859 715.215 342.859 713.358C342.859 711.5 342.3 710.856 341.883 710.183Z",
    fill: "#3A4682"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M341.778 716.637L341.883 716.497M341.883 716.497L344.236 713.358L341.883 710.183C342.3 710.856 342.859 711.5 342.859 713.358C342.859 715.215 342.472 715.577 341.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M340 708.517C340.384 708.743 341.297 709.392 341.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M346.59 704.769L340 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M344.812 703.416L346.59 704.769L345.017 704.769L343.034 704.769L344.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M341.883 703.104L344.236 699.929L341.883 696.789C342.472 697.71 342.859 698.071 342.859 699.929C342.859 701.786 342.3 702.431 341.883 703.104Z",
    fill: "#3A4682"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M341.778 696.649L341.883 696.789M341.883 696.789L344.236 699.929L341.883 703.104C342.3 702.431 342.859 701.786 342.859 699.929C342.859 698.071 342.472 697.71 341.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M340 704.769C340.384 704.544 341.297 703.895 341.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M341.569 713.41C341.569 712.473 341.126 711.536 340 710.911L340 715.908C341.126 715.284 341.569 714.347 341.569 713.41Z",
    fill: "#3A4682"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M340 647.878L340 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M340 639.394L340 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M244.77 644.599L250 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M247.385 741.934L250 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M244.613 718.355C244.613 719.448 245.816 720.541 247.071 720.541C247.393 720.541 247.743 720.507 248.067 720.417C247.625 720.516 247.254 720.417 247.071 720.385C246.182 720.229 245.868 719.292 245.868 718.355C245.868 717.418 244.613 717.262 244.613 718.355Z",
    fill: "#3A4682"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M248.64 720.177C247.96 720.609 247.328 720.43 247.071 720.385C246.182 720.229 245.868 719.292 245.868 718.355C245.868 717.418 244.613 717.262 244.613 718.355C244.613 719.448 245.816 720.541 247.071 720.541C248.042 720.541 249.268 720.229 249.268 719.031C249.268 718.667 249.372 718.199 248.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M246.13 676.141L250 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 744.953C248.954 744.328 249.249 743.703 250 743.287L250 746.618C249.249 746.202 248.954 745.577 248.954 744.953Z",
    fill: "#3A4682"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 687.697C248.954 687.072 249.249 686.448 250 686.031L250 689.362C249.249 688.946 248.954 688.321 248.954 687.697Z",
    fill: "#3A4682"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 678.744C248.954 678.119 249.249 677.495 250 677.078L250 680.41C249.249 679.993 248.954 679.369 248.954 678.744Z",
    fill: "#3A4682"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 673.539C248.954 672.914 249.249 672.29 250 671.873L250 675.205C249.249 674.788 248.954 674.164 248.954 673.539Z",
    fill: "#3A4682"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M247.49 647.826C247.49 646.499 248.198 645.171 250 644.286L250 651.365C248.198 650.481 247.49 649.153 247.49 647.826Z",
    fill: "#3A4682"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M247.071 677.495L245.293 676.141L246.866 676.141L248.849 676.141L247.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M247.071 674.788L245.293 676.141L246.866 676.141L248.849 676.141L247.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M245.066 642.395L244.77 644.599L247.28 642.1L245.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 662.608C248.954 661.984 249.249 661.359 250 660.943L250 664.274C249.249 663.858 248.954 663.233 248.954 662.608Z",
    fill: "#3A4682"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41 708.517L250 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M245.188 709.87L243.41 708.517L244.983 708.517L246.966 708.517L245.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M248.117 710.183L245.764 713.358L248.117 716.497C247.528 715.577 247.141 715.215 247.141 713.358C247.141 711.5 247.7 710.856 248.117 710.183Z",
    fill: "#3A4682"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M248.222 716.637L248.117 716.497M248.117 716.497L245.764 713.358L248.117 710.183C247.7 710.856 247.141 711.5 247.141 713.358C247.141 715.215 247.528 715.577 248.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M250 708.517C249.616 708.743 248.703 709.392 248.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41 704.769L250 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M245.188 703.416L243.41 704.769L244.983 704.769L246.966 704.769L245.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M248.117 703.104L245.764 699.929L248.117 696.789C247.528 697.71 247.141 698.071 247.141 699.929C247.141 701.786 247.7 702.431 248.117 703.104Z",
    fill: "#3A4682"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M248.222 696.649L248.117 696.789M248.117 696.789L245.764 699.929L248.117 703.104C247.7 702.431 247.141 701.786 247.141 699.929C247.141 698.071 247.528 697.71 248.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M250 704.769C249.616 704.544 248.703 703.895 248.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M248.431 713.41C248.431 712.473 248.874 711.536 250 710.911L250 715.908C248.874 715.284 248.431 714.347 248.431 713.41Z",
    fill: "#3A4682"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M255.23 644.599L250 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M252.615 741.934L250 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M255.387 718.355C255.387 719.448 254.184 720.541 252.929 720.541C252.607 720.541 252.257 720.507 251.933 720.417C252.375 720.516 252.746 720.417 252.929 720.385C253.818 720.229 254.132 719.292 254.132 718.355C254.132 717.418 255.387 717.262 255.387 718.355Z",
    fill: "#3A4682"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M251.36 720.177C252.04 720.609 252.672 720.43 252.929 720.385C253.818 720.229 254.132 719.292 254.132 718.355C254.132 717.418 255.387 717.262 255.387 718.355C255.387 719.448 254.184 720.541 252.929 720.541C251.958 720.541 250.732 720.229 250.732 719.031C250.732 718.667 250.628 718.199 251.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M253.87 676.141L250 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 744.953C251.046 744.328 250.751 743.703 250 743.287L250 746.618C250.751 746.202 251.046 745.577 251.046 744.953Z",
    fill: "#3A4682"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 687.697C251.046 687.072 250.751 686.448 250 686.031L250 689.362C250.751 688.946 251.046 688.321 251.046 687.697Z",
    fill: "#3A4682"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 678.744C251.046 678.119 250.751 677.495 250 677.078L250 680.41C250.751 679.993 251.046 679.369 251.046 678.744Z",
    fill: "#3A4682"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 673.539C251.046 672.914 250.751 672.29 250 671.873L250 675.205C250.751 674.788 251.046 674.164 251.046 673.539Z",
    fill: "#3A4682"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M252.51 647.826C252.51 646.499 251.802 645.171 250 644.286L250 651.365C251.802 650.481 252.51 649.153 252.51 647.826Z",
    fill: "#3A4682"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M252.929 677.495L254.707 676.141L253.134 676.141L251.151 676.141L252.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M252.929 674.788L254.707 676.141L253.134 676.141L251.151 676.141L252.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M254.934 642.395L255.23 644.599L252.72 642.1L254.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 662.608C251.046 661.984 250.751 661.359 250 660.943L250 664.274C250.751 663.858 251.046 663.233 251.046 662.608Z",
    fill: "#3A4682"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M256.59 708.517L250 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M254.812 709.87L256.59 708.517L255.017 708.517L253.034 708.517L254.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M251.883 710.183L254.236 713.358L251.883 716.497C252.472 715.577 252.859 715.215 252.859 713.358C252.859 711.5 252.3 710.856 251.883 710.183Z",
    fill: "#3A4682"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M251.778 716.637L251.883 716.497M251.883 716.497L254.236 713.358L251.883 710.183C252.3 710.856 252.859 711.5 252.859 713.358C252.859 715.215 252.472 715.577 251.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M250 708.517C250.384 708.743 251.297 709.392 251.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M256.59 704.769L250 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M254.812 703.416L256.59 704.769L255.017 704.769L253.034 704.769L254.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M251.883 703.104L254.236 699.929L251.883 696.789C252.472 697.71 252.859 698.071 252.859 699.929C252.859 701.786 252.3 702.431 251.883 703.104Z",
    fill: "#3A4682"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M251.778 696.649L251.883 696.789M251.883 696.789L254.236 699.929L251.883 703.104C252.3 702.431 252.859 701.786 252.859 699.929C252.859 698.071 252.472 697.71 251.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M250 704.769C250.384 704.544 251.297 703.895 251.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M251.569 713.41C251.569 712.473 251.126 711.536 250 710.911L250 715.908C251.126 715.284 251.569 714.347 251.569 713.41Z",
    fill: "#3A4682"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M250 647.878L250 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M250 639.394L250 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M154.77 644.599L160 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M157.385 741.934L160 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M154.613 718.355C154.613 719.448 155.816 720.541 157.071 720.541C157.393 720.541 157.743 720.507 158.067 720.417C157.625 720.516 157.254 720.417 157.071 720.385C156.182 720.229 155.868 719.292 155.868 718.355C155.868 717.418 154.613 717.262 154.613 718.355Z",
    fill: "#3A4682"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M158.64 720.177C157.96 720.609 157.328 720.43 157.071 720.385C156.182 720.229 155.868 719.292 155.868 718.355C155.868 717.418 154.613 717.262 154.613 718.355C154.613 719.448 155.816 720.541 157.071 720.541C158.042 720.541 159.268 720.229 159.268 719.031C159.268 718.667 159.372 718.199 158.222 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M156.13 676.141L160 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 744.953C158.954 744.328 159.249 743.703 160 743.287L160 746.618C159.249 746.202 158.954 745.577 158.954 744.953Z",
    fill: "#3A4682"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 687.697C158.954 687.072 159.249 686.448 160 686.031L160 689.362C159.249 688.946 158.954 688.321 158.954 687.697Z",
    fill: "#3A4682"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 678.744C158.954 678.119 159.249 677.495 160 677.078L160 680.41C159.249 679.993 158.954 679.369 158.954 678.744Z",
    fill: "#3A4682"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 673.539C158.954 672.914 159.249 672.29 160 671.873L160 675.205C159.249 674.788 158.954 674.164 158.954 673.539Z",
    fill: "#3A4682"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M157.49 647.826C157.49 646.499 158.198 645.171 160 644.286L160 651.365C158.198 650.481 157.49 649.153 157.49 647.826Z",
    fill: "#3A4682"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M157.071 677.495L155.293 676.141L156.866 676.141L158.849 676.141L157.071 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M157.071 674.788L155.293 676.141L156.866 676.141L158.849 676.141L157.071 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M155.066 642.395L154.77 644.599L157.28 642.1L155.066 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 662.608C158.954 661.984 159.249 661.359 160 660.943L160 664.274C159.249 663.858 158.954 663.233 158.954 662.608Z",
    fill: "#3A4682"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M153.41 708.517L160 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M155.188 709.87L153.41 708.517L154.983 708.517L156.966 708.517L155.188 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M158.117 710.183L155.764 713.358L158.117 716.497C157.528 715.577 157.141 715.215 157.141 713.358C157.141 711.5 157.7 710.856 158.117 710.183Z",
    fill: "#3A4682"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M158.222 716.637L158.117 716.497M158.117 716.497L155.764 713.358L158.117 710.183C157.7 710.856 157.141 711.5 157.141 713.358C157.141 715.215 157.528 715.577 158.117 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M160 708.517C159.616 708.743 158.703 709.392 158.117 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M153.41 704.769L160 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M155.188 703.416L153.41 704.769L154.983 704.769L156.966 704.769L155.188 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M158.117 703.104L155.764 699.929L158.117 696.789C157.528 697.71 157.141 698.071 157.141 699.929C157.141 701.786 157.7 702.431 158.117 703.104Z",
    fill: "#3A4682"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M158.222 696.649L158.117 696.789M158.117 696.789L155.764 699.929L158.117 703.104C157.7 702.431 157.141 701.786 157.141 699.929C157.141 698.071 157.528 697.71 158.117 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M160 704.769C159.616 704.544 158.703 703.895 158.117 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M158.431 713.41C158.431 712.473 158.874 711.536 160 710.911L160 715.908C158.874 715.284 158.431 714.347 158.431 713.41Z",
    fill: "#3A4682"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M165.23 644.599L160 639.394",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M162.615 741.934L160 739.956",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M165.387 718.355C165.387 719.448 164.184 720.541 162.929 720.541C162.607 720.541 162.257 720.507 161.933 720.417C162.375 720.516 162.746 720.417 162.929 720.385C163.818 720.229 164.132 719.292 164.132 718.355C164.132 717.418 165.387 717.262 165.387 718.355Z",
    fill: "#3A4682"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M161.36 720.177C162.04 720.609 162.672 720.43 162.929 720.385C163.818 720.229 164.132 719.292 164.132 718.355C164.132 717.418 165.387 717.262 165.387 718.355C165.387 719.448 164.184 720.541 162.929 720.541C161.958 720.541 160.732 720.229 160.732 719.031C160.732 718.667 160.628 718.199 161.778 716.637",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M163.87 676.141L160 676.141",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 744.953C161.046 744.328 160.751 743.703 160 743.287L160 746.618C160.751 746.202 161.046 745.577 161.046 744.953Z",
    fill: "#3A4682"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 687.697C161.046 687.072 160.751 686.448 160 686.031L160 689.362C160.751 688.946 161.046 688.321 161.046 687.697Z",
    fill: "#3A4682"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 678.744C161.046 678.119 160.751 677.495 160 677.078L160 680.41C160.751 679.993 161.046 679.369 161.046 678.744Z",
    fill: "#3A4682"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 673.539C161.046 672.914 160.751 672.29 160 671.873L160 675.205C160.751 674.788 161.046 674.164 161.046 673.539Z",
    fill: "#3A4682"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M162.51 647.826C162.51 646.499 161.802 645.171 160 644.286L160 651.365C161.802 650.481 162.51 649.153 162.51 647.826Z",
    fill: "#3A4682"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M162.929 677.495L164.707 676.141L163.134 676.141L161.151 676.141L162.929 677.495Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M162.929 674.788L164.707 676.141L163.134 676.141L161.151 676.141L162.929 674.788Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M164.934 642.395L165.23 644.599L162.72 642.1L164.934 642.395Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 662.608C161.046 661.984 160.751 661.359 160 660.943L160 664.274C160.751 663.858 161.046 663.233 161.046 662.608Z",
    fill: "#3A4682"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 708.517L160 708.517",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M164.812 709.87L166.59 708.517L165.017 708.517L163.034 708.517L164.812 709.87Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M161.883 710.183L164.236 713.358L161.883 716.497C162.472 715.577 162.859 715.215 162.859 713.358C162.859 711.5 162.3 710.856 161.883 710.183Z",
    fill: "#3A4682"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M161.778 716.637L161.883 716.497M161.883 716.497L164.236 713.358L161.883 710.183C162.3 710.856 162.859 711.5 162.859 713.358C162.859 715.215 162.472 715.577 161.883 716.497Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M160 708.517C160.384 708.743 161.297 709.392 161.883 710.183",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 704.769L160 704.769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M164.812 703.416L166.59 704.769L165.017 704.769L163.034 704.769L164.812 703.416Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M161.883 703.104L164.236 699.929L161.883 696.789C162.472 697.71 162.859 698.071 162.859 699.929C162.859 701.786 162.3 702.431 161.883 703.104Z",
    fill: "#3A4682"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M161.778 696.649L161.883 696.789M161.883 696.789L164.236 699.929L161.883 703.104C162.3 702.431 162.859 701.786 162.859 699.929C162.859 698.071 162.472 697.71 161.883 696.789Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M160 704.769C160.384 704.544 161.297 703.895 161.883 703.104",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M161.569 713.41C161.569 712.473 161.126 711.536 160 710.911L160 715.908C161.126 715.284 161.569 714.347 161.569 713.41Z",
    fill: "#3A4682"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M160 647.878L160 768.948",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M160 639.394L160 637.728",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M1080 630H1068L1060 638L1052 630H978L970 638L962 630H888L880 638L872 630H798L790 638L782 630H708L700 638L692 630H618L610 638L602 630H528L520 638L512 630H438L430 638L422 630H348L340 638L332 630H258L250 638L242 630H168L160 638L152 630H140",
    stroke: "#3A4682",
    strokeLinecap: "round"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M67 742L70 740",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M69 744.5C69 743.938 69.282 743.375 70 743L70 746C69.282 745.625 69 745.062 69 744.5Z",
    fill: "#3A4682"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M73 742L70 740",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M71 744.5C71 743.938 70.718 743.375 70 743L70 746C70.718 745.625 71 745.062 71 744.5Z",
    fill: "#3A4682"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M70 769V740",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8844 723.786C55.7914 724.879 53.4954 724.769 52.2402 723.514C51.9181 723.192 51.6023 722.807 51.3678 722.393C51.7114 722.935 52.1816 723.207 52.3964 723.358C53.4416 724.091 54.6923 723.467 55.6292 722.53C56.5661 721.593 57.9775 722.693 56.8844 723.786Z",
    fill: "#3A4682"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0356 721.58C51.2833 722.692 52.0936 723.145 52.3964 723.358C53.4416 724.091 54.6923 723.467 55.6292 722.53C56.5661 721.593 57.9775 722.693 56.8844 723.786C55.7914 724.879 53.4954 724.769 52.2402 723.514C51.2695 722.543 50.3559 721.005 51.5531 719.807C51.9174 719.443 52.2813 718.87 54.9933 718.459",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9253 715.151L61.3355 708.56",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7938 714.726L67.9253 715.151L66.3523 713.577L64.3689 711.594L64.7938 714.726Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5527 712.109L60.7312 717.638L55.2381 718.424C56.7478 718.092 57.4968 718.119 59.3543 716.261C61.2118 714.403 61.2966 713.199 61.5527 712.109Z",
    fill: "#3A4682"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M54.994 718.459L55.2381 718.424M55.2381 718.424L60.7312 717.638L61.5527 712.109C61.2966 713.199 61.2118 714.403 59.3543 716.261C57.4968 718.119 56.7478 718.092 55.2381 718.424Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3355 708.56C61.4934 709.169 61.7581 710.732 61.5527 712.109",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6724 711.402L65.0825 704.812",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2474 708.271L71.6724 711.402L70.0993 709.829L68.116 707.846L71.2474 708.271Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6309 705.029L74.1594 704.208L74.9455 698.714C74.6139 700.224 74.64 700.973 72.7825 702.831C70.925 704.688 69.7211 704.773 68.6309 705.029Z",
    fill: "#3A4682"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9804 698.47L74.9455 698.714M74.9455 698.714L74.1594 704.208L68.6309 705.029C69.7211 704.773 70.925 704.688 72.7825 702.831C74.64 700.973 74.6139 700.224 74.9455 698.714Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0825 704.812C65.6916 704.97 67.254 705.235 68.6309 705.029",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0109 715.022C58.9478 714.085 59.4422 712.706 58.9403 710.954L53.9435 715.952C55.6946 716.454 57.074 715.959 58.0109 715.022Z",
    fill: "#3A4682"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1119 713.011C45.0189 714.104 45.1288 716.4 46.384 717.656C46.7061 717.978 47.0907 718.294 47.5046 718.528C46.9624 718.185 46.6907 717.714 46.5401 717.5C45.8072 716.454 46.4303 715.203 47.3671 714.266C48.304 713.329 47.205 711.918 46.1119 713.011Z",
    fill: "#3A4682"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3173 718.861C47.2052 718.613 46.7524 717.802 46.5401 717.5C45.8072 716.454 46.4303 715.203 47.3671 714.266C48.304 713.329 47.205 711.918 46.1119 713.011C45.0189 714.104 45.1288 716.4 46.384 717.656C47.3547 718.627 48.8929 719.54 50.09 718.343C50.4544 717.979 51.0274 717.615 51.4383 714.902",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7456 701.97L61.3354 708.56",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1705 705.102L54.7456 701.97L56.3186 703.543L58.302 705.527L55.1705 705.102Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7871 708.343L52.2586 709.165L51.4725 714.658C51.8041 713.148 51.7779 712.399 53.6355 710.542C55.493 708.684 56.6968 708.599 57.7871 708.343Z",
    fill: "#3A4682"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4375 714.902L51.4725 714.658M51.4725 714.658L52.2586 709.165L57.7871 708.343C56.6968 708.599 55.493 708.684 53.6355 710.542C51.7779 712.399 51.8041 713.148 51.4725 714.658Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3354 708.56C60.7264 708.402 59.164 708.138 57.787 708.343",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4941 698.222L65.084 704.812",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6256 698.647L58.4941 698.222L60.0672 699.795L62.0505 701.779L61.6256 698.647Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8667 701.264L65.6882 695.734L71.1813 694.948C69.6716 695.28 68.9226 695.254 67.0651 697.111C65.2076 698.969 65.1229 700.173 64.8667 701.264Z",
    fill: "#3A4682"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4254 694.913L71.1813 694.948M71.1813 694.948L65.6882 695.734L64.8667 701.264C65.1229 700.173 65.2076 698.969 67.0651 697.111C68.9226 695.254 69.6716 695.28 71.1813 694.948Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M65.084 704.812C64.926 704.203 64.6614 702.641 64.8668 701.264",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8737 711.884C55.8106 710.947 57.19 710.453 58.9411 710.955L53.9443 715.952C53.4424 714.201 53.9368 712.821 54.8737 711.884Z",
    fill: "#3A4682"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4648 744.586L28.9703 741.026",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4053 740.533L28.9704 741.027",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7677 745.77C26.2298 745.308 26.4737 744.629 26.2261 743.767L23.7615 746.227C24.6252 746.475 25.3056 746.231 25.7677 745.77Z",
    fill: "#3A4682"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2198 744.225C24.682 743.763 25.3623 743.52 26.226 743.767L23.7614 746.227C23.5139 745.365 23.7577 744.686 24.2198 744.225Z",
    fill: "#3A4682"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7712 688.772C83.232 688.311 83.4751 687.633 83.2283 686.771L80.7706 689.229C81.6318 689.475 82.3103 689.232 82.7712 688.772Z",
    fill: "#3A4682"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2282 687.229C81.689 686.768 82.3675 686.525 83.2288 686.772L80.7711 689.229C80.5242 688.368 80.7674 687.689 81.2282 687.229Z",
    fill: "#3A4682"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M108.771 662.772C109.232 662.311 109.475 661.633 109.228 660.771L106.771 663.229C107.632 663.475 108.31 663.232 108.771 662.772Z",
    fill: "#3A4682"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M107.228 661.229C107.689 660.768 108.367 660.525 109.229 660.772L106.771 663.229C106.524 662.368 106.767 661.689 107.228 661.229Z",
    fill: "#3A4682"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M134.201 639.347C135.144 638.404 135.584 636.958 134.932 635.049L129.904 640.078C131.813 640.73 133.259 640.29 134.201 639.347Z",
    fill: "#3A4682"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M130.635 635.78C131.578 634.837 133.024 634.397 134.933 635.049L129.904 640.078C129.252 638.169 129.692 636.723 130.635 635.78Z",
    fill: "#3A4682"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2295 678.233L94.4922 675.5",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3913 678.076C93.8331 677.635 94.0662 676.986 93.8295 676.162L91.4734 678.514C92.2991 678.75 92.9495 678.517 93.3913 678.076Z",
    fill: "#3A4682"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0729 674.401C97.5147 673.96 97.7478 673.311 97.5112 672.487L95.1551 674.839C95.9807 675.075 96.6312 674.842 97.0729 674.401Z",
    fill: "#3A4682"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6064 678.523L97.8213 678.823L96.7087 677.713L95.3059 676.312L95.6064 678.523Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5208 676.612L97.8213 678.823L96.7087 677.713L95.3059 676.312L97.5208 676.612Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7549 672.768L94.4922 675.5",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9118 676.599C92.3536 676.158 93.004 675.925 93.8297 676.162L91.4736 678.514C91.2369 677.689 91.47 677.04 91.9118 676.599Z",
    fill: "#3A4682"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5934 672.924C96.0352 672.483 96.6856 672.25 97.5113 672.487L95.1552 674.839C94.9186 674.014 95.1517 673.365 95.5934 672.924Z",
    fill: "#3A4682"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4636 674.388L91.1631 672.177L92.2757 673.287L93.6785 674.688L91.4636 674.388Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3779 672.477L91.1631 672.177L92.2757 673.288L93.6785 674.688L93.3779 672.477Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M134 636L0.999943 769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M131 632L138 632",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M133 630.5L131 632H135L133 630.5Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M138 639L138 632",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 637L138 639L138 635L139.5 637Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M138 632L140 630",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1568 701.157C71.848 700.466 72.2127 699.449 71.8425 698.157L68.1561 701.843C69.448 702.213 70.4656 701.848 71.1568 701.157Z",
    fill: "#3A4682"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8424 698.843C69.5336 698.152 70.5512 697.787 71.8431 698.157L68.1567 701.843C67.7865 700.551 68.1512 699.534 68.8424 698.843Z",
    fill: "#3A4682"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M1147 28L1150 30",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M1149 25.5C1149 26.0625 1149.28 26.625 1150 27L1150 24C1149.28 24.375 1149 24.9375 1149 25.5Z",
    fill: "#3A4682"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M1153 28L1150 30",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M1151 25.5C1151 26.0625 1150.72 26.625 1150 27L1150 24C1150.72 24.375 1151 24.9375 1151 25.5Z",
    fill: "#3A4682"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M1150 1V30",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.77 125.401L1060 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.38 28.0663L1060 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M1054.61 51.6452C1054.61 50.5522 1055.82 49.4591 1057.07 49.4591C1057.39 49.4591 1057.74 49.4935 1058.07 49.5832C1057.62 49.4839 1057.25 49.5832 1057.07 49.6153C1056.18 49.7714 1055.87 50.7083 1055.87 51.6452C1055.87 52.5821 1054.61 52.7383 1054.61 51.6452Z",
    fill: "#3A4682"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.64 49.8235C1057.96 49.3913 1057.33 49.57 1057.07 49.6153C1056.18 49.7714 1055.87 50.7083 1055.87 51.6452C1055.87 52.5821 1054.61 52.7383 1054.61 51.6452C1054.61 50.5522 1055.82 49.4591 1057.07 49.4591C1058.04 49.4591 1059.27 49.7714 1059.27 50.9686C1059.27 51.3329 1059.37 51.8014 1058.22 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M1056.13 93.8585L1060 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 25.0474C1058.95 25.672 1059.25 26.2966 1060 26.713L1060 23.3818C1059.25 23.7982 1058.95 24.4228 1058.95 25.0474Z",
    fill: "#3A4682"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 82.3032C1058.95 82.9279 1059.25 83.5525 1060 83.9689L1060 80.6376C1059.25 81.054 1058.95 81.6786 1058.95 82.3032Z",
    fill: "#3A4682"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 91.256C1058.95 91.8806 1059.25 92.5052 1060 92.9216L1060 89.5904C1059.25 90.0068 1058.95 90.6314 1058.95 91.256Z",
    fill: "#3A4682"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 96.4611C1058.95 97.0857 1059.25 97.7103 1060 98.1267L1060 94.7955C1059.25 95.2119 1058.95 95.8365 1058.95 96.4611Z",
    fill: "#3A4682"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.49 122.174C1057.49 123.501 1058.2 124.829 1060 125.714L1060 118.635C1058.2 119.519 1057.49 120.847 1057.49 122.174Z",
    fill: "#3A4682"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.07 92.5052L1055.29 93.8585L1056.87 93.8585L1058.85 93.8585L1057.07 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.07 95.2118L1055.29 93.8585L1056.87 93.8585L1058.85 93.8585L1057.07 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.07 127.605L1054.77 125.401L1057.28 127.9L1055.07 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.95 107.392C1058.95 108.016 1059.25 108.641 1060 109.057L1060 105.726C1059.25 106.142 1058.95 106.767 1058.95 107.392Z",
    fill: "#3A4682"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 61.4829L1060 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.19 60.1296L1053.41 61.4829L1054.98 61.4829L1056.97 61.4829L1055.19 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.12 59.8173L1055.76 56.6422L1058.12 53.5025C1057.53 54.4232 1057.14 54.7846 1057.14 56.6422C1057.14 58.4997 1057.7 59.144 1058.12 59.8173Z",
    fill: "#3A4682"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.22 53.363L1058.12 53.5025M1058.12 53.5025L1055.76 56.6422L1058.12 59.8173C1057.7 59.144 1057.14 58.4997 1057.14 56.6422C1057.14 54.7846 1057.53 54.4232 1058.12 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 61.4829C1059.62 61.2574 1058.7 60.6085 1058.12 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 65.2306L1060 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M1055.19 66.5839L1053.41 65.2306L1054.98 65.2306L1056.97 65.2306L1055.19 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.12 66.8962L1055.76 70.0713L1058.12 73.211C1057.53 72.2903 1057.14 71.9289 1057.14 70.0713C1057.14 68.2138 1057.7 67.5695 1058.12 66.8962Z",
    fill: "#3A4682"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.22 73.3505L1058.12 73.211M1058.12 73.211L1055.76 70.0713L1058.12 66.8962C1057.7 67.5695 1057.14 68.2138 1057.14 70.0713C1057.14 71.9289 1057.53 72.2903 1058.12 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 65.2306C1059.62 65.4561 1058.7 66.105 1058.12 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M1058.43 56.5902C1058.43 57.5271 1058.87 58.464 1060 59.0886L1060 54.0918C1058.87 54.7164 1058.43 55.6533 1058.43 56.5902Z",
    fill: "#3A4682"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.23 125.401L1060 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.62 28.0663L1060 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M1065.39 51.6452C1065.39 50.5522 1064.18 49.4591 1062.93 49.4591C1062.61 49.4591 1062.26 49.4935 1061.93 49.5832C1062.38 49.4839 1062.75 49.5832 1062.93 49.6153C1063.82 49.7714 1064.13 50.7083 1064.13 51.6452C1064.13 52.5821 1065.39 52.7383 1065.39 51.6452Z",
    fill: "#3A4682"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.36 49.8235C1062.04 49.3913 1062.67 49.57 1062.93 49.6153C1063.82 49.7714 1064.13 50.7083 1064.13 51.6452C1064.13 52.5821 1065.39 52.7383 1065.39 51.6452C1065.39 50.5522 1064.18 49.4591 1062.93 49.4591C1061.96 49.4591 1060.73 49.7714 1060.73 50.9686C1060.73 51.3329 1060.63 51.8014 1061.78 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.87 93.8585L1060 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 25.0474C1061.05 25.672 1060.75 26.2966 1060 26.713L1060 23.3818C1060.75 23.7982 1061.05 24.4228 1061.05 25.0474Z",
    fill: "#3A4682"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 82.3032C1061.05 82.9279 1060.75 83.5525 1060 83.9689L1060 80.6376C1060.75 81.054 1061.05 81.6786 1061.05 82.3032Z",
    fill: "#3A4682"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 91.256C1061.05 91.8806 1060.75 92.5052 1060 92.9216L1060 89.5904C1060.75 90.0068 1061.05 90.6314 1061.05 91.256Z",
    fill: "#3A4682"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 96.461C1061.05 97.0856 1060.75 97.7102 1060 98.1266L1060 94.7953C1060.75 95.2117 1061.05 95.8364 1061.05 96.461Z",
    fill: "#3A4682"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.51 122.174C1062.51 123.501 1061.8 124.829 1060 125.714L1060 118.635C1061.8 119.519 1062.51 120.847 1062.51 122.174Z",
    fill: "#3A4682"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.93 92.5052L1064.71 93.8585L1063.13 93.8585L1061.15 93.8585L1062.93 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M1062.93 95.2118L1064.71 93.8585L1063.13 93.8585L1061.15 93.8585L1062.93 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.93 127.605L1065.23 125.401L1062.72 127.9L1064.93 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.05 107.392C1061.05 108.016 1060.75 108.641 1060 109.057L1060 105.726C1060.75 106.142 1061.05 106.767 1061.05 107.392Z",
    fill: "#3A4682"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 61.4829L1060 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.81 60.1296L1066.59 61.4829L1065.02 61.4829L1063.03 61.4829L1064.81 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.88 59.8173L1064.24 56.6422L1061.88 53.5025C1062.47 54.4232 1062.86 54.7846 1062.86 56.6422C1062.86 58.4997 1062.3 59.144 1061.88 59.8173Z",
    fill: "#3A4682"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.78 53.363L1061.88 53.5025M1061.88 53.5025L1064.24 56.6422L1061.88 59.8173C1062.3 59.144 1062.86 58.4997 1062.86 56.6422C1062.86 54.7846 1062.47 54.4232 1061.88 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 61.4829C1060.38 61.2574 1061.3 60.6085 1061.88 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M1066.59 65.2306L1060 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.81 66.5839L1066.59 65.2306L1065.02 65.2306L1063.03 65.2306L1064.81 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.88 66.8962L1064.24 70.0713L1061.88 73.211C1062.47 72.2903 1062.86 71.9289 1062.86 70.0713C1062.86 68.2138 1062.3 67.5695 1061.88 66.8962Z",
    fill: "#3A4682"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.78 73.3505L1061.88 73.211M1061.88 73.211L1064.24 70.0713L1061.88 66.8962C1062.3 67.5695 1062.86 68.2138 1062.86 70.0713C1062.86 71.9289 1062.47 72.2903 1061.88 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 65.2306C1060.38 65.4561 1061.3 66.105 1061.88 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.57 56.5902C1061.57 57.5271 1061.13 58.464 1060 59.0886L1060 54.0918C1061.13 54.7164 1061.57 55.6533 1061.57 56.5902Z",
    fill: "#3A4682"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 122.122L1060 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M1060 130.606L1060 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M964.77 125.401L970 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M967.385 28.0663L970 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M964.613 51.6452C964.613 50.5522 965.816 49.4591 967.071 49.4591C967.393 49.4591 967.743 49.4935 968.067 49.5832C967.625 49.4839 967.254 49.5832 967.071 49.6153C966.182 49.7714 965.868 50.7083 965.868 51.6452C965.868 52.5821 964.613 52.7383 964.613 51.6452Z",
    fill: "#3A4682"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M968.64 49.8235C967.96 49.3913 967.328 49.57 967.071 49.6153C966.182 49.7714 965.868 50.7083 965.868 51.6452C965.868 52.5821 964.613 52.7383 964.613 51.6452C964.613 50.5522 965.816 49.4591 967.071 49.4591C968.042 49.4591 969.268 49.7714 969.268 50.9686C969.268 51.3329 969.372 51.8014 968.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M966.13 93.8585L970 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 25.0474C968.954 25.672 969.249 26.2966 970 26.713L970 23.3818C969.249 23.7982 968.954 24.4228 968.954 25.0474Z",
    fill: "#3A4682"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 82.3032C968.954 82.9279 969.249 83.5525 970 83.9689L970 80.6376C969.249 81.054 968.954 81.6786 968.954 82.3032Z",
    fill: "#3A4682"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 91.256C968.954 91.8806 969.249 92.5052 970 92.9216L970 89.5904C969.249 90.0068 968.954 90.6314 968.954 91.256Z",
    fill: "#3A4682"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 96.4611C968.954 97.0857 969.249 97.7103 970 98.1267L970 94.7955C969.249 95.2119 968.954 95.8365 968.954 96.4611Z",
    fill: "#3A4682"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M967.49 122.174C967.49 123.501 968.198 124.829 970 125.714L970 118.635C968.198 119.519 967.49 120.847 967.49 122.174Z",
    fill: "#3A4682"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M967.071 92.5052L965.293 93.8585L966.866 93.8585L968.849 93.8585L967.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M967.071 95.2118L965.293 93.8585L966.866 93.8585L968.849 93.8585L967.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M965.066 127.605L964.77 125.401L967.28 127.9L965.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M968.954 107.392C968.954 108.016 969.249 108.641 970 109.057L970 105.726C969.249 106.142 968.954 106.767 968.954 107.392Z",
    fill: "#3A4682"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M963.41 61.4829L970 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M965.188 60.1296L963.41 61.4829L964.983 61.4829L966.966 61.4829L965.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M968.117 59.8173L965.764 56.6422L968.117 53.5025C967.528 54.4232 967.141 54.7846 967.141 56.6422C967.141 58.4997 967.7 59.144 968.117 59.8173Z",
    fill: "#3A4682"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M968.222 53.363L968.117 53.5025M968.117 53.5025L965.764 56.6422L968.117 59.8173C967.7 59.144 967.141 58.4997 967.141 56.6422C967.141 54.7846 967.528 54.4232 968.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M970 61.4829C969.616 61.2574 968.703 60.6085 968.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M963.41 65.2306L970 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M965.188 66.5839L963.41 65.2306L964.983 65.2306L966.966 65.2306L965.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M968.117 66.8962L965.764 70.0713L968.117 73.211C967.528 72.2903 967.141 71.9289 967.141 70.0713C967.141 68.2138 967.7 67.5695 968.117 66.8962Z",
    fill: "#3A4682"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M968.222 73.3505L968.117 73.211M968.117 73.211L965.764 70.0713L968.117 66.8962C967.7 67.5695 967.141 68.2138 967.141 70.0713C967.141 71.9289 967.528 72.2903 968.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M970 65.2306C969.616 65.4561 968.703 66.105 968.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M968.431 56.5902C968.431 57.5271 968.874 58.464 970 59.0886L970 54.0918C968.874 54.7164 968.431 55.6533 968.431 56.5902Z",
    fill: "#3A4682"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M975.23 125.401L970 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M972.615 28.0663L970 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M975.387 51.6452C975.387 50.5522 974.184 49.4591 972.929 49.4591C972.607 49.4591 972.257 49.4935 971.933 49.5832C972.375 49.4839 972.746 49.5832 972.929 49.6153C973.818 49.7714 974.132 50.7083 974.132 51.6452C974.132 52.5821 975.387 52.7383 975.387 51.6452Z",
    fill: "#3A4682"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M971.36 49.8235C972.04 49.3913 972.672 49.57 972.929 49.6153C973.818 49.7714 974.132 50.7083 974.132 51.6452C974.132 52.5821 975.387 52.7383 975.387 51.6452C975.387 50.5522 974.184 49.4591 972.929 49.4591C971.958 49.4591 970.732 49.7714 970.732 50.9686C970.732 51.3329 970.628 51.8014 971.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M973.87 93.8585L970 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 25.0474C971.046 25.672 970.751 26.2966 970 26.713L970 23.3818C970.751 23.7982 971.046 24.4228 971.046 25.0474Z",
    fill: "#3A4682"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 82.3032C971.046 82.9279 970.751 83.5525 970 83.9689L970 80.6376C970.751 81.054 971.046 81.6786 971.046 82.3032Z",
    fill: "#3A4682"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 91.256C971.046 91.8806 970.751 92.5052 970 92.9216L970 89.5904C970.751 90.0068 971.046 90.6314 971.046 91.256Z",
    fill: "#3A4682"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 96.461C971.046 97.0856 970.751 97.7102 970 98.1266L970 94.7953C970.751 95.2117 971.046 95.8364 971.046 96.461Z",
    fill: "#3A4682"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M972.51 122.174C972.51 123.501 971.802 124.829 970 125.714L970 118.635C971.802 119.519 972.51 120.847 972.51 122.174Z",
    fill: "#3A4682"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M972.929 92.5052L974.707 93.8585L973.134 93.8585L971.151 93.8585L972.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M972.929 95.2118L974.707 93.8585L973.134 93.8585L971.151 93.8585L972.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M974.934 127.605L975.23 125.401L972.72 127.9L974.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M971.046 107.392C971.046 108.016 970.751 108.641 970 109.057L970 105.726C970.751 106.142 971.046 106.767 971.046 107.392Z",
    fill: "#3A4682"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M976.59 61.4829L970 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M974.812 60.1296L976.59 61.4829L975.017 61.4829L973.034 61.4829L974.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M971.883 59.8173L974.236 56.6422L971.883 53.5025C972.472 54.4232 972.859 54.7846 972.859 56.6422C972.859 58.4997 972.3 59.144 971.883 59.8173Z",
    fill: "#3A4682"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M971.778 53.363L971.883 53.5025M971.883 53.5025L974.236 56.6422L971.883 59.8173C972.3 59.144 972.859 58.4997 972.859 56.6422C972.859 54.7846 972.472 54.4232 971.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M970 61.4829C970.384 61.2574 971.297 60.6085 971.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M976.59 65.2306L970 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M974.812 66.5839L976.59 65.2306L975.017 65.2306L973.034 65.2306L974.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M971.883 66.8962L974.236 70.0713L971.883 73.211C972.472 72.2903 972.859 71.9289 972.859 70.0713C972.859 68.2138 972.3 67.5695 971.883 66.8962Z",
    fill: "#3A4682"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M971.778 73.3505L971.883 73.211M971.883 73.211L974.236 70.0713L971.883 66.8962C972.3 67.5695 972.859 68.2138 972.859 70.0713C972.859 71.9289 972.472 72.2903 971.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M970 65.2306C970.384 65.4561 971.297 66.105 971.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M971.569 56.5902C971.569 57.5271 971.126 58.464 970 59.0886L970 54.0918C971.126 54.7164 971.569 55.6533 971.569 56.5902Z",
    fill: "#3A4682"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M970 122.122L970 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M970 130.606L970 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M874.77 125.401L880 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M877.385 28.0663L880 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M874.613 51.6452C874.613 50.5522 875.816 49.4591 877.071 49.4591C877.393 49.4591 877.743 49.4935 878.067 49.5832C877.625 49.4839 877.254 49.5832 877.071 49.6153C876.182 49.7714 875.868 50.7083 875.868 51.6452C875.868 52.5821 874.613 52.7383 874.613 51.6452Z",
    fill: "#3A4682"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M878.64 49.8235C877.96 49.3913 877.328 49.57 877.071 49.6153C876.182 49.7714 875.868 50.7083 875.868 51.6452C875.868 52.5821 874.613 52.7383 874.613 51.6452C874.613 50.5522 875.816 49.4591 877.071 49.4591C878.042 49.4591 879.268 49.7714 879.268 50.9686C879.268 51.3329 879.372 51.8014 878.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M876.13 93.8585L880 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 25.0474C878.954 25.672 879.249 26.2966 880 26.713L880 23.3818C879.249 23.7982 878.954 24.4228 878.954 25.0474Z",
    fill: "#3A4682"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 82.3032C878.954 82.9279 879.249 83.5525 880 83.9689L880 80.6376C879.249 81.054 878.954 81.6786 878.954 82.3032Z",
    fill: "#3A4682"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 91.256C878.954 91.8806 879.249 92.5052 880 92.9216L880 89.5904C879.249 90.0068 878.954 90.6314 878.954 91.256Z",
    fill: "#3A4682"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 96.4611C878.954 97.0857 879.249 97.7103 880 98.1267L880 94.7955C879.249 95.2119 878.954 95.8365 878.954 96.4611Z",
    fill: "#3A4682"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M877.49 122.174C877.49 123.501 878.198 124.829 880 125.714L880 118.635C878.198 119.519 877.49 120.847 877.49 122.174Z",
    fill: "#3A4682"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M877.071 92.5052L875.293 93.8585L876.866 93.8585L878.849 93.8585L877.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M877.071 95.2118L875.293 93.8585L876.866 93.8585L878.849 93.8585L877.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M875.066 127.605L874.77 125.401L877.28 127.9L875.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M878.954 107.392C878.954 108.016 879.249 108.641 880 109.057L880 105.726C879.249 106.142 878.954 106.767 878.954 107.392Z",
    fill: "#3A4682"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M873.41 61.4829L880 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M875.188 60.1296L873.41 61.4829L874.983 61.4829L876.966 61.4829L875.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M878.117 59.8173L875.764 56.6422L878.117 53.5025C877.528 54.4232 877.141 54.7846 877.141 56.6422C877.141 58.4997 877.7 59.144 878.117 59.8173Z",
    fill: "#3A4682"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M878.222 53.363L878.117 53.5025M878.117 53.5025L875.764 56.6422L878.117 59.8173C877.7 59.144 877.141 58.4997 877.141 56.6422C877.141 54.7846 877.528 54.4232 878.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M880 61.4829C879.616 61.2574 878.703 60.6085 878.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M873.41 65.2306L880 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M875.188 66.5839L873.41 65.2306L874.983 65.2306L876.966 65.2306L875.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M878.117 66.8962L875.764 70.0713L878.117 73.211C877.528 72.2903 877.141 71.9289 877.141 70.0713C877.141 68.2138 877.7 67.5695 878.117 66.8962Z",
    fill: "#3A4682"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M878.222 73.3505L878.117 73.211M878.117 73.211L875.764 70.0713L878.117 66.8962C877.7 67.5695 877.141 68.2138 877.141 70.0713C877.141 71.9289 877.528 72.2903 878.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M880 65.2306C879.616 65.4561 878.703 66.105 878.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M878.431 56.5902C878.431 57.5271 878.874 58.464 880 59.0886L880 54.0918C878.874 54.7164 878.431 55.6533 878.431 56.5902Z",
    fill: "#3A4682"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M885.23 125.401L880 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M882.615 28.0663L880 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M885.387 51.6452C885.387 50.5522 884.184 49.4591 882.929 49.4591C882.607 49.4591 882.257 49.4935 881.933 49.5832C882.375 49.4839 882.746 49.5832 882.929 49.6153C883.818 49.7714 884.132 50.7083 884.132 51.6452C884.132 52.5821 885.387 52.7383 885.387 51.6452Z",
    fill: "#3A4682"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M881.36 49.8235C882.04 49.3913 882.672 49.57 882.929 49.6153C883.818 49.7714 884.132 50.7083 884.132 51.6452C884.132 52.5821 885.387 52.7383 885.387 51.6452C885.387 50.5522 884.184 49.4591 882.929 49.4591C881.958 49.4591 880.732 49.7714 880.732 50.9686C880.732 51.3329 880.628 51.8014 881.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M883.87 93.8585L880 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 25.0474C881.046 25.672 880.751 26.2966 880 26.713L880 23.3818C880.751 23.7982 881.046 24.4228 881.046 25.0474Z",
    fill: "#3A4682"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 82.3032C881.046 82.9279 880.751 83.5525 880 83.9689L880 80.6376C880.751 81.054 881.046 81.6786 881.046 82.3032Z",
    fill: "#3A4682"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 91.256C881.046 91.8806 880.751 92.5052 880 92.9216L880 89.5904C880.751 90.0068 881.046 90.6314 881.046 91.256Z",
    fill: "#3A4682"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 96.461C881.046 97.0856 880.751 97.7102 880 98.1266L880 94.7953C880.751 95.2117 881.046 95.8364 881.046 96.461Z",
    fill: "#3A4682"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M882.51 122.174C882.51 123.501 881.802 124.829 880 125.714L880 118.635C881.802 119.519 882.51 120.847 882.51 122.174Z",
    fill: "#3A4682"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M882.929 92.5052L884.707 93.8585L883.134 93.8585L881.151 93.8585L882.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M882.929 95.2118L884.707 93.8585L883.134 93.8585L881.151 93.8585L882.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M884.934 127.605L885.23 125.401L882.72 127.9L884.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M881.046 107.392C881.046 108.016 880.751 108.641 880 109.057L880 105.726C880.751 106.142 881.046 106.767 881.046 107.392Z",
    fill: "#3A4682"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M886.59 61.4829L880 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M884.812 60.1296L886.59 61.4829L885.017 61.4829L883.034 61.4829L884.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M881.883 59.8173L884.236 56.6422L881.883 53.5025C882.472 54.4232 882.859 54.7846 882.859 56.6422C882.859 58.4997 882.3 59.144 881.883 59.8173Z",
    fill: "#3A4682"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M881.778 53.363L881.883 53.5025M881.883 53.5025L884.236 56.6422L881.883 59.8173C882.3 59.144 882.859 58.4997 882.859 56.6422C882.859 54.7846 882.472 54.4232 881.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M880 61.4829C880.384 61.2574 881.297 60.6085 881.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M886.59 65.2306L880 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M884.812 66.5839L886.59 65.2306L885.017 65.2306L883.034 65.2306L884.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M881.883 66.8962L884.236 70.0713L881.883 73.211C882.472 72.2903 882.859 71.9289 882.859 70.0713C882.859 68.2138 882.3 67.5695 881.883 66.8962Z",
    fill: "#3A4682"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M881.778 73.3505L881.883 73.211M881.883 73.211L884.236 70.0713L881.883 66.8962C882.3 67.5695 882.859 68.2138 882.859 70.0713C882.859 71.9289 882.472 72.2903 881.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M880 65.2306C880.384 65.4561 881.297 66.105 881.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M881.569 56.5902C881.569 57.5271 881.126 58.464 880 59.0886L880 54.0918C881.126 54.7164 881.569 55.6533 881.569 56.5902Z",
    fill: "#3A4682"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M880 122.122L880 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M880 130.606L880 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M784.77 125.401L790 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M787.385 28.0663L790 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M784.613 51.6452C784.613 50.5522 785.816 49.4591 787.071 49.4591C787.393 49.4591 787.743 49.4935 788.067 49.5832C787.625 49.4839 787.254 49.5832 787.071 49.6153C786.182 49.7714 785.868 50.7083 785.868 51.6452C785.868 52.5821 784.613 52.7383 784.613 51.6452Z",
    fill: "#3A4682"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M788.64 49.8235C787.96 49.3913 787.328 49.57 787.071 49.6153C786.182 49.7714 785.868 50.7083 785.868 51.6452C785.868 52.5821 784.613 52.7383 784.613 51.6452C784.613 50.5522 785.816 49.4591 787.071 49.4591C788.042 49.4591 789.268 49.7714 789.268 50.9686C789.268 51.3329 789.372 51.8014 788.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M786.13 93.8585L790 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 25.0474C788.954 25.672 789.249 26.2966 790 26.713L790 23.3818C789.249 23.7982 788.954 24.4228 788.954 25.0474Z",
    fill: "#3A4682"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 82.3032C788.954 82.9279 789.249 83.5525 790 83.9689L790 80.6376C789.249 81.054 788.954 81.6786 788.954 82.3032Z",
    fill: "#3A4682"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 91.256C788.954 91.8806 789.249 92.5052 790 92.9216L790 89.5904C789.249 90.0068 788.954 90.6314 788.954 91.256Z",
    fill: "#3A4682"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 96.4611C788.954 97.0857 789.249 97.7103 790 98.1267L790 94.7955C789.249 95.2119 788.954 95.8365 788.954 96.4611Z",
    fill: "#3A4682"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M787.49 122.174C787.49 123.501 788.198 124.829 790 125.714L790 118.635C788.198 119.519 787.49 120.847 787.49 122.174Z",
    fill: "#3A4682"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M787.071 92.5052L785.293 93.8585L786.866 93.8585L788.849 93.8585L787.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M787.071 95.2118L785.293 93.8585L786.866 93.8585L788.849 93.8585L787.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M785.066 127.605L784.77 125.401L787.28 127.9L785.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M788.954 107.392C788.954 108.016 789.249 108.641 790 109.057L790 105.726C789.249 106.142 788.954 106.767 788.954 107.392Z",
    fill: "#3A4682"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M783.41 61.4829L790 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M785.188 60.1296L783.41 61.4829L784.983 61.4829L786.966 61.4829L785.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M788.117 59.8173L785.764 56.6422L788.117 53.5025C787.528 54.4232 787.141 54.7846 787.141 56.6422C787.141 58.4997 787.7 59.144 788.117 59.8173Z",
    fill: "#3A4682"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M788.222 53.363L788.117 53.5025M788.117 53.5025L785.764 56.6422L788.117 59.8173C787.7 59.144 787.141 58.4997 787.141 56.6422C787.141 54.7846 787.528 54.4232 788.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M790 61.4829C789.616 61.2574 788.703 60.6085 788.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M783.41 65.2306L790 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M785.188 66.5839L783.41 65.2306L784.983 65.2306L786.966 65.2306L785.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M788.117 66.8962L785.764 70.0713L788.117 73.211C787.528 72.2903 787.141 71.9289 787.141 70.0713C787.141 68.2138 787.7 67.5695 788.117 66.8962Z",
    fill: "#3A4682"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M788.222 73.3505L788.117 73.211M788.117 73.211L785.764 70.0713L788.117 66.8962C787.7 67.5695 787.141 68.2138 787.141 70.0713C787.141 71.9289 787.528 72.2903 788.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M790 65.2306C789.616 65.4561 788.703 66.105 788.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M788.431 56.5902C788.431 57.5271 788.874 58.464 790 59.0886L790 54.0918C788.874 54.7164 788.431 55.6533 788.431 56.5902Z",
    fill: "#3A4682"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M795.23 125.401L790 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M792.615 28.0663L790 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M795.387 51.6452C795.387 50.5522 794.184 49.4591 792.929 49.4591C792.607 49.4591 792.257 49.4935 791.933 49.5832C792.375 49.4839 792.746 49.5832 792.929 49.6153C793.818 49.7714 794.132 50.7083 794.132 51.6452C794.132 52.5821 795.387 52.7383 795.387 51.6452Z",
    fill: "#3A4682"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M791.36 49.8235C792.04 49.3913 792.672 49.57 792.929 49.6153C793.818 49.7714 794.132 50.7083 794.132 51.6452C794.132 52.5821 795.387 52.7383 795.387 51.6452C795.387 50.5522 794.184 49.4591 792.929 49.4591C791.958 49.4591 790.732 49.7714 790.732 50.9686C790.732 51.3329 790.628 51.8014 791.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M793.87 93.8585L790 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 25.0474C791.046 25.672 790.751 26.2966 790 26.713L790 23.3818C790.751 23.7982 791.046 24.4228 791.046 25.0474Z",
    fill: "#3A4682"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 82.3032C791.046 82.9279 790.751 83.5525 790 83.9689L790 80.6376C790.751 81.054 791.046 81.6786 791.046 82.3032Z",
    fill: "#3A4682"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 91.256C791.046 91.8806 790.751 92.5052 790 92.9216L790 89.5904C790.751 90.0068 791.046 90.6314 791.046 91.256Z",
    fill: "#3A4682"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 96.461C791.046 97.0856 790.751 97.7102 790 98.1266L790 94.7953C790.751 95.2117 791.046 95.8364 791.046 96.461Z",
    fill: "#3A4682"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M792.51 122.174C792.51 123.501 791.802 124.829 790 125.714L790 118.635C791.802 119.519 792.51 120.847 792.51 122.174Z",
    fill: "#3A4682"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M792.929 92.5052L794.707 93.8585L793.134 93.8585L791.151 93.8585L792.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M792.929 95.2118L794.707 93.8585L793.134 93.8585L791.151 93.8585L792.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M794.934 127.605L795.23 125.401L792.72 127.9L794.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M791.046 107.392C791.046 108.016 790.751 108.641 790 109.057L790 105.726C790.751 106.142 791.046 106.767 791.046 107.392Z",
    fill: "#3A4682"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M796.59 61.4829L790 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M794.812 60.1296L796.59 61.4829L795.017 61.4829L793.034 61.4829L794.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M791.883 59.8173L794.236 56.6422L791.883 53.5025C792.472 54.4232 792.859 54.7846 792.859 56.6422C792.859 58.4997 792.3 59.144 791.883 59.8173Z",
    fill: "#3A4682"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M791.778 53.363L791.883 53.5025M791.883 53.5025L794.236 56.6422L791.883 59.8173C792.3 59.144 792.859 58.4997 792.859 56.6422C792.859 54.7846 792.472 54.4232 791.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M790 61.4829C790.384 61.2574 791.297 60.6085 791.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M796.59 65.2306L790 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M794.812 66.5839L796.59 65.2306L795.017 65.2306L793.034 65.2306L794.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M791.883 66.8962L794.236 70.0713L791.883 73.211C792.472 72.2903 792.859 71.9289 792.859 70.0713C792.859 68.2138 792.3 67.5695 791.883 66.8962Z",
    fill: "#3A4682"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M791.778 73.3505L791.883 73.211M791.883 73.211L794.236 70.0713L791.883 66.8962C792.3 67.5695 792.859 68.2138 792.859 70.0713C792.859 71.9289 792.472 72.2903 791.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M790 65.2306C790.384 65.4561 791.297 66.105 791.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M791.569 56.5902C791.569 57.5271 791.126 58.464 790 59.0886L790 54.0918C791.126 54.7164 791.569 55.6533 791.569 56.5902Z",
    fill: "#3A4682"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M790 122.122L790 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M790 130.606L790 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M694.77 125.401L700 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M697.385 28.0663L700 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M694.613 51.6452C694.613 50.5522 695.816 49.4591 697.071 49.4591C697.393 49.4591 697.743 49.4935 698.067 49.5832C697.625 49.4839 697.254 49.5832 697.071 49.6153C696.182 49.7714 695.868 50.7083 695.868 51.6452C695.868 52.5821 694.613 52.7383 694.613 51.6452Z",
    fill: "#3A4682"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M698.64 49.8235C697.96 49.3913 697.328 49.57 697.071 49.6153C696.182 49.7714 695.868 50.7083 695.868 51.6452C695.868 52.5821 694.613 52.7383 694.613 51.6452C694.613 50.5522 695.816 49.4591 697.071 49.4591C698.042 49.4591 699.268 49.7714 699.268 50.9686C699.268 51.3329 699.372 51.8014 698.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M696.13 93.8585L700 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 25.0474C698.954 25.672 699.249 26.2966 700 26.713L700 23.3818C699.249 23.7982 698.954 24.4228 698.954 25.0474Z",
    fill: "#3A4682"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 82.3032C698.954 82.9279 699.249 83.5525 700 83.9689L700 80.6376C699.249 81.054 698.954 81.6786 698.954 82.3032Z",
    fill: "#3A4682"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 91.256C698.954 91.8806 699.249 92.5052 700 92.9216L700 89.5904C699.249 90.0068 698.954 90.6314 698.954 91.256Z",
    fill: "#3A4682"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 96.4611C698.954 97.0857 699.249 97.7103 700 98.1267L700 94.7955C699.249 95.2119 698.954 95.8365 698.954 96.4611Z",
    fill: "#3A4682"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M697.49 122.174C697.49 123.501 698.198 124.829 700 125.714L700 118.635C698.198 119.519 697.49 120.847 697.49 122.174Z",
    fill: "#3A4682"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M697.071 92.5052L695.293 93.8585L696.866 93.8585L698.849 93.8585L697.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M697.071 95.2118L695.293 93.8585L696.866 93.8585L698.849 93.8585L697.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M695.066 127.605L694.77 125.401L697.28 127.9L695.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M698.954 107.392C698.954 108.016 699.249 108.641 700 109.057L700 105.726C699.249 106.142 698.954 106.767 698.954 107.392Z",
    fill: "#3A4682"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M693.41 61.4829L700 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M695.188 60.1296L693.41 61.4829L694.983 61.4829L696.966 61.4829L695.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M698.117 59.8173L695.764 56.6422L698.117 53.5025C697.528 54.4232 697.141 54.7846 697.141 56.6422C697.141 58.4997 697.7 59.144 698.117 59.8173Z",
    fill: "#3A4682"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M698.222 53.363L698.117 53.5025M698.117 53.5025L695.764 56.6422L698.117 59.8173C697.7 59.144 697.141 58.4997 697.141 56.6422C697.141 54.7846 697.528 54.4232 698.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M700 61.4829C699.616 61.2574 698.703 60.6085 698.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M693.41 65.2306L700 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M695.188 66.5839L693.41 65.2306L694.983 65.2306L696.966 65.2306L695.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M698.117 66.8962L695.764 70.0713L698.117 73.211C697.528 72.2903 697.141 71.9289 697.141 70.0713C697.141 68.2138 697.7 67.5695 698.117 66.8962Z",
    fill: "#3A4682"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M698.222 73.3505L698.117 73.211M698.117 73.211L695.764 70.0713L698.117 66.8962C697.7 67.5695 697.141 68.2138 697.141 70.0713C697.141 71.9289 697.528 72.2903 698.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M700 65.2306C699.616 65.4561 698.703 66.105 698.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M698.431 56.5902C698.431 57.5271 698.874 58.464 700 59.0886L700 54.0918C698.874 54.7164 698.431 55.6533 698.431 56.5902Z",
    fill: "#3A4682"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M705.23 125.401L700 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M702.615 28.0663L700 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M705.387 51.6452C705.387 50.5522 704.184 49.4591 702.929 49.4591C702.607 49.4591 702.257 49.4935 701.933 49.5832C702.375 49.4839 702.746 49.5832 702.929 49.6153C703.818 49.7714 704.132 50.7083 704.132 51.6452C704.132 52.5821 705.387 52.7383 705.387 51.6452Z",
    fill: "#3A4682"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M701.36 49.8235C702.04 49.3913 702.672 49.57 702.929 49.6153C703.818 49.7714 704.132 50.7083 704.132 51.6452C704.132 52.5821 705.387 52.7383 705.387 51.6452C705.387 50.5522 704.184 49.4591 702.929 49.4591C701.958 49.4591 700.732 49.7714 700.732 50.9686C700.732 51.3329 700.628 51.8014 701.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M703.87 93.8585L700 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 25.0474C701.046 25.672 700.751 26.2966 700 26.713L700 23.3818C700.751 23.7982 701.046 24.4228 701.046 25.0474Z",
    fill: "#3A4682"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 82.3032C701.046 82.9279 700.751 83.5525 700 83.9689L700 80.6376C700.751 81.054 701.046 81.6786 701.046 82.3032Z",
    fill: "#3A4682"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 91.256C701.046 91.8806 700.751 92.5052 700 92.9216L700 89.5904C700.751 90.0068 701.046 90.6314 701.046 91.256Z",
    fill: "#3A4682"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 96.461C701.046 97.0856 700.751 97.7102 700 98.1266L700 94.7953C700.751 95.2117 701.046 95.8364 701.046 96.461Z",
    fill: "#3A4682"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M702.51 122.174C702.51 123.501 701.802 124.829 700 125.714L700 118.635C701.802 119.519 702.51 120.847 702.51 122.174Z",
    fill: "#3A4682"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M702.929 92.5052L704.707 93.8585L703.134 93.8585L701.151 93.8585L702.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M702.929 95.2118L704.707 93.8585L703.134 93.8585L701.151 93.8585L702.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M704.934 127.605L705.23 125.401L702.72 127.9L704.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M701.046 107.392C701.046 108.016 700.751 108.641 700 109.057L700 105.726C700.751 106.142 701.046 106.767 701.046 107.392Z",
    fill: "#3A4682"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M706.59 61.4829L700 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M704.812 60.1296L706.59 61.4829L705.017 61.4829L703.034 61.4829L704.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M701.883 59.8173L704.236 56.6422L701.883 53.5025C702.472 54.4232 702.859 54.7846 702.859 56.6422C702.859 58.4997 702.3 59.144 701.883 59.8173Z",
    fill: "#3A4682"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M701.778 53.363L701.883 53.5025M701.883 53.5025L704.236 56.6422L701.883 59.8173C702.3 59.144 702.859 58.4997 702.859 56.6422C702.859 54.7846 702.472 54.4232 701.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M700 61.4829C700.384 61.2574 701.297 60.6085 701.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M706.59 65.2306L700 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M704.812 66.5839L706.59 65.2306L705.017 65.2306L703.034 65.2306L704.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M701.883 66.8962L704.236 70.0713L701.883 73.211C702.472 72.2903 702.859 71.9289 702.859 70.0713C702.859 68.2138 702.3 67.5695 701.883 66.8962Z",
    fill: "#3A4682"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M701.778 73.3505L701.883 73.211M701.883 73.211L704.236 70.0713L701.883 66.8962C702.3 67.5695 702.859 68.2138 702.859 70.0713C702.859 71.9289 702.472 72.2903 701.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M700 65.2306C700.384 65.4561 701.297 66.105 701.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M701.569 56.5902C701.569 57.5271 701.126 58.464 700 59.0886L700 54.0918C701.126 54.7164 701.569 55.6533 701.569 56.5902Z",
    fill: "#3A4682"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M700 122.122L700 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M700 130.606L700 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M604.77 125.401L610 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M607.385 28.0663L610 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M604.613 51.6452C604.613 50.5522 605.816 49.4591 607.071 49.4591C607.393 49.4591 607.743 49.4935 608.067 49.5832C607.625 49.4839 607.254 49.5832 607.071 49.6153C606.182 49.7714 605.868 50.7083 605.868 51.6452C605.868 52.5821 604.613 52.7383 604.613 51.6452Z",
    fill: "#3A4682"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M608.64 49.8235C607.96 49.3913 607.328 49.57 607.071 49.6153C606.182 49.7714 605.868 50.7083 605.868 51.6452C605.868 52.5821 604.613 52.7383 604.613 51.6452C604.613 50.5522 605.816 49.4591 607.071 49.4591C608.042 49.4591 609.268 49.7714 609.268 50.9686C609.268 51.3329 609.372 51.8014 608.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M606.13 93.8585L610 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 25.0474C608.954 25.672 609.249 26.2966 610 26.713L610 23.3818C609.249 23.7982 608.954 24.4228 608.954 25.0474Z",
    fill: "#3A4682"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 82.3032C608.954 82.9279 609.249 83.5525 610 83.9689L610 80.6376C609.249 81.054 608.954 81.6786 608.954 82.3032Z",
    fill: "#3A4682"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 91.256C608.954 91.8806 609.249 92.5052 610 92.9216L610 89.5904C609.249 90.0068 608.954 90.6314 608.954 91.256Z",
    fill: "#3A4682"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 96.4611C608.954 97.0857 609.249 97.7103 610 98.1267L610 94.7955C609.249 95.2119 608.954 95.8365 608.954 96.4611Z",
    fill: "#3A4682"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M607.49 122.174C607.49 123.501 608.198 124.829 610 125.714L610 118.635C608.198 119.519 607.49 120.847 607.49 122.174Z",
    fill: "#3A4682"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M607.071 92.5052L605.293 93.8585L606.866 93.8585L608.849 93.8585L607.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M607.071 95.2118L605.293 93.8585L606.866 93.8585L608.849 93.8585L607.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M605.066 127.605L604.77 125.401L607.28 127.9L605.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M608.954 107.392C608.954 108.016 609.249 108.641 610 109.057L610 105.726C609.249 106.142 608.954 106.767 608.954 107.392Z",
    fill: "#3A4682"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M603.41 61.4829L610 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M605.188 60.1296L603.41 61.4829L604.983 61.4829L606.966 61.4829L605.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M608.117 59.8173L605.764 56.6422L608.117 53.5025C607.528 54.4232 607.141 54.7846 607.141 56.6422C607.141 58.4997 607.7 59.144 608.117 59.8173Z",
    fill: "#3A4682"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M608.222 53.363L608.117 53.5025M608.117 53.5025L605.764 56.6422L608.117 59.8173C607.7 59.144 607.141 58.4997 607.141 56.6422C607.141 54.7846 607.528 54.4232 608.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M610 61.4829C609.616 61.2574 608.703 60.6085 608.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M603.41 65.2306L610 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M605.188 66.5839L603.41 65.2306L604.983 65.2306L606.966 65.2306L605.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M608.117 66.8962L605.764 70.0713L608.117 73.211C607.528 72.2903 607.141 71.9289 607.141 70.0713C607.141 68.2138 607.7 67.5695 608.117 66.8962Z",
    fill: "#3A4682"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M608.222 73.3505L608.117 73.211M608.117 73.211L605.764 70.0713L608.117 66.8962C607.7 67.5695 607.141 68.2138 607.141 70.0713C607.141 71.9289 607.528 72.2903 608.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M610 65.2306C609.616 65.4561 608.703 66.105 608.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M608.431 56.5902C608.431 57.5271 608.874 58.464 610 59.0886L610 54.0918C608.874 54.7164 608.431 55.6533 608.431 56.5902Z",
    fill: "#3A4682"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M615.23 125.401L610 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M612.615 28.0663L610 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M615.387 51.6452C615.387 50.5522 614.184 49.4591 612.929 49.4591C612.607 49.4591 612.257 49.4935 611.933 49.5832C612.375 49.4839 612.746 49.5832 612.929 49.6153C613.818 49.7714 614.132 50.7083 614.132 51.6452C614.132 52.5821 615.387 52.7383 615.387 51.6452Z",
    fill: "#3A4682"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M611.36 49.8235C612.04 49.3913 612.672 49.57 612.929 49.6153C613.818 49.7714 614.132 50.7083 614.132 51.6452C614.132 52.5821 615.387 52.7383 615.387 51.6452C615.387 50.5522 614.184 49.4591 612.929 49.4591C611.958 49.4591 610.732 49.7714 610.732 50.9686C610.732 51.3329 610.628 51.8014 611.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M613.87 93.8585L610 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 25.0474C611.046 25.672 610.751 26.2966 610 26.713L610 23.3818C610.751 23.7982 611.046 24.4228 611.046 25.0474Z",
    fill: "#3A4682"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 82.3032C611.046 82.9279 610.751 83.5525 610 83.9689L610 80.6376C610.751 81.054 611.046 81.6786 611.046 82.3032Z",
    fill: "#3A4682"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 91.256C611.046 91.8806 610.751 92.5052 610 92.9216L610 89.5904C610.751 90.0068 611.046 90.6314 611.046 91.256Z",
    fill: "#3A4682"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 96.461C611.046 97.0856 610.751 97.7102 610 98.1266L610 94.7953C610.751 95.2117 611.046 95.8364 611.046 96.461Z",
    fill: "#3A4682"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M612.51 122.174C612.51 123.501 611.802 124.829 610 125.714L610 118.635C611.802 119.519 612.51 120.847 612.51 122.174Z",
    fill: "#3A4682"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M612.929 92.5052L614.707 93.8585L613.134 93.8585L611.151 93.8585L612.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M612.929 95.2118L614.707 93.8585L613.134 93.8585L611.151 93.8585L612.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M614.934 127.605L615.23 125.401L612.72 127.9L614.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M611.046 107.392C611.046 108.016 610.751 108.641 610 109.057L610 105.726C610.751 106.142 611.046 106.767 611.046 107.392Z",
    fill: "#3A4682"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M616.59 61.4829L610 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M614.812 60.1296L616.59 61.4829L615.017 61.4829L613.034 61.4829L614.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M611.883 59.8173L614.236 56.6422L611.883 53.5025C612.472 54.4232 612.859 54.7846 612.859 56.6422C612.859 58.4997 612.3 59.144 611.883 59.8173Z",
    fill: "#3A4682"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M611.778 53.363L611.883 53.5025M611.883 53.5025L614.236 56.6422L611.883 59.8173C612.3 59.144 612.859 58.4997 612.859 56.6422C612.859 54.7846 612.472 54.4232 611.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M610 61.4829C610.384 61.2574 611.297 60.6085 611.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M616.59 65.2306L610 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M614.812 66.5839L616.59 65.2306L615.017 65.2306L613.034 65.2306L614.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M611.883 66.8962L614.236 70.0713L611.883 73.211C612.472 72.2903 612.859 71.9289 612.859 70.0713C612.859 68.2138 612.3 67.5695 611.883 66.8962Z",
    fill: "#3A4682"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M611.778 73.3505L611.883 73.211M611.883 73.211L614.236 70.0713L611.883 66.8962C612.3 67.5695 612.859 68.2138 612.859 70.0713C612.859 71.9289 612.472 72.2903 611.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M610 65.2306C610.384 65.4561 611.297 66.105 611.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M611.569 56.5902C611.569 57.5271 611.126 58.464 610 59.0886L610 54.0918C611.126 54.7164 611.569 55.6533 611.569 56.5902Z",
    fill: "#3A4682"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M610 122.122L610 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M610 130.606L610 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M514.77 125.401L520 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M517.385 28.0663L520 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M514.613 51.6452C514.613 50.5522 515.816 49.4591 517.071 49.4591C517.393 49.4591 517.743 49.4935 518.067 49.5832C517.625 49.4839 517.254 49.5832 517.071 49.6153C516.182 49.7714 515.868 50.7083 515.868 51.6452C515.868 52.5821 514.613 52.7383 514.613 51.6452Z",
    fill: "#3A4682"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M518.64 49.8235C517.96 49.3913 517.328 49.57 517.071 49.6153C516.182 49.7714 515.868 50.7083 515.868 51.6452C515.868 52.5821 514.613 52.7383 514.613 51.6452C514.613 50.5522 515.816 49.4591 517.071 49.4591C518.042 49.4591 519.268 49.7714 519.268 50.9686C519.268 51.3329 519.372 51.8014 518.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M516.13 93.8585L520 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 25.0474C518.954 25.672 519.249 26.2966 520 26.713L520 23.3818C519.249 23.7982 518.954 24.4228 518.954 25.0474Z",
    fill: "#3A4682"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 82.3032C518.954 82.9279 519.249 83.5525 520 83.9689L520 80.6376C519.249 81.054 518.954 81.6786 518.954 82.3032Z",
    fill: "#3A4682"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 91.256C518.954 91.8806 519.249 92.5052 520 92.9216L520 89.5904C519.249 90.0068 518.954 90.6314 518.954 91.256Z",
    fill: "#3A4682"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 96.4611C518.954 97.0857 519.249 97.7103 520 98.1267L520 94.7955C519.249 95.2119 518.954 95.8365 518.954 96.4611Z",
    fill: "#3A4682"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M517.49 122.174C517.49 123.501 518.198 124.829 520 125.714L520 118.635C518.198 119.519 517.49 120.847 517.49 122.174Z",
    fill: "#3A4682"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M517.071 92.5052L515.293 93.8585L516.866 93.8585L518.849 93.8585L517.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M517.071 95.2118L515.293 93.8585L516.866 93.8585L518.849 93.8585L517.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M515.066 127.605L514.77 125.401L517.28 127.9L515.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M518.954 107.392C518.954 108.016 519.249 108.641 520 109.057L520 105.726C519.249 106.142 518.954 106.767 518.954 107.392Z",
    fill: "#3A4682"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M513.41 61.4829L520 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M515.188 60.1296L513.41 61.4829L514.983 61.4829L516.966 61.4829L515.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M518.117 59.8173L515.764 56.6422L518.117 53.5025C517.528 54.4232 517.141 54.7846 517.141 56.6422C517.141 58.4997 517.7 59.144 518.117 59.8173Z",
    fill: "#3A4682"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M518.222 53.363L518.117 53.5025M518.117 53.5025L515.764 56.6422L518.117 59.8173C517.7 59.144 517.141 58.4997 517.141 56.6422C517.141 54.7846 517.528 54.4232 518.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M520 61.4829C519.616 61.2574 518.703 60.6085 518.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M513.41 65.2306L520 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M515.188 66.5839L513.41 65.2306L514.983 65.2306L516.966 65.2306L515.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M518.117 66.8962L515.764 70.0713L518.117 73.211C517.528 72.2903 517.141 71.9289 517.141 70.0713C517.141 68.2138 517.7 67.5695 518.117 66.8962Z",
    fill: "#3A4682"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M518.222 73.3505L518.117 73.211M518.117 73.211L515.764 70.0713L518.117 66.8962C517.7 67.5695 517.141 68.2138 517.141 70.0713C517.141 71.9289 517.528 72.2903 518.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M520 65.2306C519.616 65.4561 518.703 66.105 518.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M518.431 56.5902C518.431 57.5271 518.874 58.464 520 59.0886L520 54.0918C518.874 54.7164 518.431 55.6533 518.431 56.5902Z",
    fill: "#3A4682"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M525.23 125.401L520 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M522.615 28.0663L520 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M525.387 51.6452C525.387 50.5522 524.184 49.4591 522.929 49.4591C522.607 49.4591 522.257 49.4935 521.933 49.5832C522.375 49.4839 522.746 49.5832 522.929 49.6153C523.818 49.7714 524.132 50.7083 524.132 51.6452C524.132 52.5821 525.387 52.7383 525.387 51.6452Z",
    fill: "#3A4682"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M521.36 49.8235C522.04 49.3913 522.672 49.57 522.929 49.6153C523.818 49.7714 524.132 50.7083 524.132 51.6452C524.132 52.5821 525.387 52.7383 525.387 51.6452C525.387 50.5522 524.184 49.4591 522.929 49.4591C521.958 49.4591 520.732 49.7714 520.732 50.9686C520.732 51.3329 520.628 51.8014 521.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M523.87 93.8585L520 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 25.0474C521.046 25.672 520.751 26.2966 520 26.713L520 23.3818C520.751 23.7982 521.046 24.4228 521.046 25.0474Z",
    fill: "#3A4682"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 82.3032C521.046 82.9279 520.751 83.5525 520 83.9689L520 80.6376C520.751 81.054 521.046 81.6786 521.046 82.3032Z",
    fill: "#3A4682"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 91.256C521.046 91.8806 520.751 92.5052 520 92.9216L520 89.5904C520.751 90.0068 521.046 90.6314 521.046 91.256Z",
    fill: "#3A4682"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 96.461C521.046 97.0856 520.751 97.7102 520 98.1266L520 94.7953C520.751 95.2117 521.046 95.8364 521.046 96.461Z",
    fill: "#3A4682"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M522.51 122.174C522.51 123.501 521.802 124.829 520 125.714L520 118.635C521.802 119.519 522.51 120.847 522.51 122.174Z",
    fill: "#3A4682"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M522.929 92.5052L524.707 93.8585L523.134 93.8585L521.151 93.8585L522.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M522.929 95.2118L524.707 93.8585L523.134 93.8585L521.151 93.8585L522.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M524.934 127.605L525.23 125.401L522.72 127.9L524.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M521.046 107.392C521.046 108.016 520.751 108.641 520 109.057L520 105.726C520.751 106.142 521.046 106.767 521.046 107.392Z",
    fill: "#3A4682"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M526.59 61.4829L520 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M524.812 60.1296L526.59 61.4829L525.017 61.4829L523.034 61.4829L524.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M521.883 59.8173L524.236 56.6422L521.883 53.5025C522.472 54.4232 522.859 54.7846 522.859 56.6422C522.859 58.4997 522.3 59.144 521.883 59.8173Z",
    fill: "#3A4682"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M521.778 53.363L521.883 53.5025M521.883 53.5025L524.236 56.6422L521.883 59.8173C522.3 59.144 522.859 58.4997 522.859 56.6422C522.859 54.7846 522.472 54.4232 521.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M520 61.4829C520.384 61.2574 521.297 60.6085 521.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M526.59 65.2306L520 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M524.812 66.5839L526.59 65.2306L525.017 65.2306L523.034 65.2306L524.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M521.883 66.8962L524.236 70.0713L521.883 73.211C522.472 72.2903 522.859 71.9289 522.859 70.0713C522.859 68.2138 522.3 67.5695 521.883 66.8962Z",
    fill: "#3A4682"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M521.778 73.3505L521.883 73.211M521.883 73.211L524.236 70.0713L521.883 66.8962C522.3 67.5695 522.859 68.2138 522.859 70.0713C522.859 71.9289 522.472 72.2903 521.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M520 65.2306C520.384 65.4561 521.297 66.105 521.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M521.569 56.5902C521.569 57.5271 521.126 58.464 520 59.0886L520 54.0918C521.126 54.7164 521.569 55.6533 521.569 56.5902Z",
    fill: "#3A4682"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M520 122.122L520 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M520 130.606L520 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M424.77 125.401L430 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M427.385 28.0663L430 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M424.613 51.6452C424.613 50.5522 425.816 49.4591 427.071 49.4591C427.393 49.4591 427.743 49.4935 428.067 49.5832C427.625 49.4839 427.254 49.5832 427.071 49.6153C426.182 49.7714 425.868 50.7083 425.868 51.6452C425.868 52.5821 424.613 52.7383 424.613 51.6452Z",
    fill: "#3A4682"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M428.64 49.8235C427.96 49.3913 427.328 49.57 427.071 49.6153C426.182 49.7714 425.868 50.7083 425.868 51.6452C425.868 52.5821 424.613 52.7383 424.613 51.6452C424.613 50.5522 425.816 49.4591 427.071 49.4591C428.042 49.4591 429.268 49.7714 429.268 50.9686C429.268 51.3329 429.372 51.8014 428.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M426.13 93.8585L430 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 25.0474C428.954 25.672 429.249 26.2966 430 26.713L430 23.3818C429.249 23.7982 428.954 24.4228 428.954 25.0474Z",
    fill: "#3A4682"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 82.3032C428.954 82.9279 429.249 83.5525 430 83.9689L430 80.6376C429.249 81.054 428.954 81.6786 428.954 82.3032Z",
    fill: "#3A4682"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 91.256C428.954 91.8806 429.249 92.5052 430 92.9216L430 89.5904C429.249 90.0068 428.954 90.6314 428.954 91.256Z",
    fill: "#3A4682"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 96.4611C428.954 97.0857 429.249 97.7103 430 98.1267L430 94.7955C429.249 95.2119 428.954 95.8365 428.954 96.4611Z",
    fill: "#3A4682"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M427.49 122.174C427.49 123.501 428.198 124.829 430 125.714L430 118.635C428.198 119.519 427.49 120.847 427.49 122.174Z",
    fill: "#3A4682"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M427.071 92.5052L425.293 93.8585L426.866 93.8585L428.849 93.8585L427.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M427.071 95.2118L425.293 93.8585L426.866 93.8585L428.849 93.8585L427.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M425.066 127.605L424.77 125.401L427.28 127.9L425.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M428.954 107.392C428.954 108.016 429.249 108.641 430 109.057L430 105.726C429.249 106.142 428.954 106.767 428.954 107.392Z",
    fill: "#3A4682"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M423.41 61.4829L430 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M425.188 60.1296L423.41 61.4829L424.983 61.4829L426.966 61.4829L425.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M428.117 59.8173L425.764 56.6422L428.117 53.5025C427.528 54.4232 427.141 54.7846 427.141 56.6422C427.141 58.4997 427.7 59.144 428.117 59.8173Z",
    fill: "#3A4682"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M428.222 53.363L428.117 53.5025M428.117 53.5025L425.764 56.6422L428.117 59.8173C427.7 59.144 427.141 58.4997 427.141 56.6422C427.141 54.7846 427.528 54.4232 428.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M430 61.4829C429.616 61.2574 428.703 60.6085 428.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M423.41 65.2306L430 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M425.188 66.5839L423.41 65.2306L424.983 65.2306L426.966 65.2306L425.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M428.117 66.8962L425.764 70.0713L428.117 73.211C427.528 72.2903 427.141 71.9289 427.141 70.0713C427.141 68.2138 427.7 67.5695 428.117 66.8962Z",
    fill: "#3A4682"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M428.222 73.3505L428.117 73.211M428.117 73.211L425.764 70.0713L428.117 66.8962C427.7 67.5695 427.141 68.2138 427.141 70.0713C427.141 71.9289 427.528 72.2903 428.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M430 65.2306C429.616 65.4561 428.703 66.105 428.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M428.431 56.5902C428.431 57.5271 428.874 58.464 430 59.0886L430 54.0918C428.874 54.7164 428.431 55.6533 428.431 56.5902Z",
    fill: "#3A4682"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M435.23 125.401L430 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M432.615 28.0663L430 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M435.387 51.6452C435.387 50.5522 434.184 49.4591 432.929 49.4591C432.607 49.4591 432.257 49.4935 431.933 49.5832C432.375 49.4839 432.746 49.5832 432.929 49.6153C433.818 49.7714 434.132 50.7083 434.132 51.6452C434.132 52.5821 435.387 52.7383 435.387 51.6452Z",
    fill: "#3A4682"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M431.36 49.8235C432.04 49.3913 432.672 49.57 432.929 49.6153C433.818 49.7714 434.132 50.7083 434.132 51.6452C434.132 52.5821 435.387 52.7383 435.387 51.6452C435.387 50.5522 434.184 49.4591 432.929 49.4591C431.958 49.4591 430.732 49.7714 430.732 50.9686C430.732 51.3329 430.628 51.8014 431.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M433.87 93.8585L430 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 25.0474C431.046 25.672 430.751 26.2966 430 26.713L430 23.3818C430.751 23.7982 431.046 24.4228 431.046 25.0474Z",
    fill: "#3A4682"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 82.3032C431.046 82.9279 430.751 83.5525 430 83.9689L430 80.6376C430.751 81.054 431.046 81.6786 431.046 82.3032Z",
    fill: "#3A4682"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 91.256C431.046 91.8806 430.751 92.5052 430 92.9216L430 89.5904C430.751 90.0068 431.046 90.6314 431.046 91.256Z",
    fill: "#3A4682"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 96.461C431.046 97.0856 430.751 97.7102 430 98.1266L430 94.7953C430.751 95.2117 431.046 95.8364 431.046 96.461Z",
    fill: "#3A4682"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M432.51 122.174C432.51 123.501 431.802 124.829 430 125.714L430 118.635C431.802 119.519 432.51 120.847 432.51 122.174Z",
    fill: "#3A4682"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M432.929 92.5052L434.707 93.8585L433.134 93.8585L431.151 93.8585L432.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M432.929 95.2118L434.707 93.8585L433.134 93.8585L431.151 93.8585L432.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M434.934 127.605L435.23 125.401L432.72 127.9L434.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M431.046 107.392C431.046 108.016 430.751 108.641 430 109.057L430 105.726C430.751 106.142 431.046 106.767 431.046 107.392Z",
    fill: "#3A4682"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M436.59 61.4829L430 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M434.812 60.1296L436.59 61.4829L435.017 61.4829L433.034 61.4829L434.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M431.883 59.8173L434.236 56.6422L431.883 53.5025C432.472 54.4232 432.859 54.7846 432.859 56.6422C432.859 58.4997 432.3 59.144 431.883 59.8173Z",
    fill: "#3A4682"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M431.778 53.363L431.883 53.5025M431.883 53.5025L434.236 56.6422L431.883 59.8173C432.3 59.144 432.859 58.4997 432.859 56.6422C432.859 54.7846 432.472 54.4232 431.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M430 61.4829C430.384 61.2574 431.297 60.6085 431.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M436.59 65.2306L430 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M434.812 66.5839L436.59 65.2306L435.017 65.2306L433.034 65.2306L434.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M431.883 66.8962L434.236 70.0713L431.883 73.211C432.472 72.2903 432.859 71.9289 432.859 70.0713C432.859 68.2138 432.3 67.5695 431.883 66.8962Z",
    fill: "#3A4682"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M431.778 73.3505L431.883 73.211M431.883 73.211L434.236 70.0713L431.883 66.8962C432.3 67.5695 432.859 68.2138 432.859 70.0713C432.859 71.9289 432.472 72.2903 431.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M430 65.2306C430.384 65.4561 431.297 66.105 431.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M431.569 56.5902C431.569 57.5271 431.126 58.464 430 59.0886L430 54.0918C431.126 54.7164 431.569 55.6533 431.569 56.5902Z",
    fill: "#3A4682"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M430 122.122L430 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M430 130.606L430 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M334.77 125.401L340 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M337.385 28.0663L340 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M334.613 51.6452C334.613 50.5522 335.816 49.4591 337.071 49.4591C337.393 49.4591 337.743 49.4935 338.067 49.5832C337.625 49.4839 337.254 49.5832 337.071 49.6153C336.182 49.7714 335.868 50.7083 335.868 51.6452C335.868 52.5821 334.613 52.7383 334.613 51.6452Z",
    fill: "#3A4682"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M338.64 49.8235C337.96 49.3913 337.328 49.57 337.071 49.6153C336.182 49.7714 335.868 50.7083 335.868 51.6452C335.868 52.5821 334.613 52.7383 334.613 51.6452C334.613 50.5522 335.816 49.4591 337.071 49.4591C338.042 49.4591 339.268 49.7714 339.268 50.9686C339.268 51.3329 339.372 51.8014 338.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M336.13 93.8585L340 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 25.0474C338.954 25.672 339.249 26.2966 340 26.713L340 23.3818C339.249 23.7982 338.954 24.4228 338.954 25.0474Z",
    fill: "#3A4682"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 82.3032C338.954 82.9279 339.249 83.5525 340 83.9689L340 80.6376C339.249 81.054 338.954 81.6786 338.954 82.3032Z",
    fill: "#3A4682"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 91.256C338.954 91.8806 339.249 92.5052 340 92.9216L340 89.5904C339.249 90.0068 338.954 90.6314 338.954 91.256Z",
    fill: "#3A4682"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 96.4611C338.954 97.0857 339.249 97.7103 340 98.1267L340 94.7955C339.249 95.2119 338.954 95.8365 338.954 96.4611Z",
    fill: "#3A4682"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M337.49 122.174C337.49 123.501 338.198 124.829 340 125.714L340 118.635C338.198 119.519 337.49 120.847 337.49 122.174Z",
    fill: "#3A4682"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M337.071 92.5052L335.293 93.8585L336.866 93.8585L338.849 93.8585L337.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M337.071 95.2118L335.293 93.8585L336.866 93.8585L338.849 93.8585L337.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M335.066 127.605L334.77 125.401L337.28 127.9L335.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M338.954 107.392C338.954 108.016 339.249 108.641 340 109.057L340 105.726C339.249 106.142 338.954 106.767 338.954 107.392Z",
    fill: "#3A4682"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M333.41 61.4829L340 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M335.188 60.1296L333.41 61.4829L334.983 61.4829L336.966 61.4829L335.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M338.117 59.8173L335.764 56.6422L338.117 53.5025C337.528 54.4232 337.141 54.7846 337.141 56.6422C337.141 58.4997 337.7 59.144 338.117 59.8173Z",
    fill: "#3A4682"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M338.222 53.363L338.117 53.5025M338.117 53.5025L335.764 56.6422L338.117 59.8173C337.7 59.144 337.141 58.4997 337.141 56.6422C337.141 54.7846 337.528 54.4232 338.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M340 61.4829C339.616 61.2574 338.703 60.6085 338.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M333.41 65.2306L340 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M335.188 66.5839L333.41 65.2306L334.983 65.2306L336.966 65.2306L335.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M338.117 66.8962L335.764 70.0713L338.117 73.211C337.528 72.2903 337.141 71.9289 337.141 70.0713C337.141 68.2138 337.7 67.5695 338.117 66.8962Z",
    fill: "#3A4682"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M338.222 73.3505L338.117 73.211M338.117 73.211L335.764 70.0713L338.117 66.8962C337.7 67.5695 337.141 68.2138 337.141 70.0713C337.141 71.9289 337.528 72.2903 338.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M340 65.2306C339.616 65.4561 338.703 66.105 338.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M338.431 56.5902C338.431 57.5271 338.874 58.464 340 59.0886L340 54.0918C338.874 54.7164 338.431 55.6533 338.431 56.5902Z",
    fill: "#3A4682"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M345.23 125.401L340 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M342.615 28.0663L340 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M345.387 51.6452C345.387 50.5522 344.184 49.4591 342.929 49.4591C342.607 49.4591 342.257 49.4935 341.933 49.5832C342.375 49.4839 342.746 49.5832 342.929 49.6153C343.818 49.7714 344.132 50.7083 344.132 51.6452C344.132 52.5821 345.387 52.7383 345.387 51.6452Z",
    fill: "#3A4682"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M341.36 49.8235C342.04 49.3913 342.672 49.57 342.929 49.6153C343.818 49.7714 344.132 50.7083 344.132 51.6452C344.132 52.5821 345.387 52.7383 345.387 51.6452C345.387 50.5522 344.184 49.4591 342.929 49.4591C341.958 49.4591 340.732 49.7714 340.732 50.9686C340.732 51.3329 340.628 51.8014 341.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M343.87 93.8585L340 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 25.0474C341.046 25.672 340.751 26.2966 340 26.713L340 23.3818C340.751 23.7982 341.046 24.4228 341.046 25.0474Z",
    fill: "#3A4682"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 82.3032C341.046 82.9279 340.751 83.5525 340 83.9689L340 80.6376C340.751 81.054 341.046 81.6786 341.046 82.3032Z",
    fill: "#3A4682"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 91.256C341.046 91.8806 340.751 92.5052 340 92.9216L340 89.5904C340.751 90.0068 341.046 90.6314 341.046 91.256Z",
    fill: "#3A4682"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 96.461C341.046 97.0856 340.751 97.7102 340 98.1266L340 94.7953C340.751 95.2117 341.046 95.8364 341.046 96.461Z",
    fill: "#3A4682"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M342.51 122.174C342.51 123.501 341.802 124.829 340 125.714L340 118.635C341.802 119.519 342.51 120.847 342.51 122.174Z",
    fill: "#3A4682"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M342.929 92.5052L344.707 93.8585L343.134 93.8585L341.151 93.8585L342.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M342.929 95.2118L344.707 93.8585L343.134 93.8585L341.151 93.8585L342.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M344.934 127.605L345.23 125.401L342.72 127.9L344.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M341.046 107.392C341.046 108.016 340.751 108.641 340 109.057L340 105.726C340.751 106.142 341.046 106.767 341.046 107.392Z",
    fill: "#3A4682"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M346.59 61.4829L340 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M344.812 60.1296L346.59 61.4829L345.017 61.4829L343.034 61.4829L344.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M341.883 59.8173L344.236 56.6422L341.883 53.5025C342.472 54.4232 342.859 54.7846 342.859 56.6422C342.859 58.4997 342.3 59.144 341.883 59.8173Z",
    fill: "#3A4682"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M341.778 53.363L341.883 53.5025M341.883 53.5025L344.236 56.6422L341.883 59.8173C342.3 59.144 342.859 58.4997 342.859 56.6422C342.859 54.7846 342.472 54.4232 341.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M340 61.4829C340.384 61.2574 341.297 60.6085 341.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M346.59 65.2306L340 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M344.812 66.5839L346.59 65.2306L345.017 65.2306L343.034 65.2306L344.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M341.883 66.8962L344.236 70.0713L341.883 73.211C342.472 72.2903 342.859 71.9289 342.859 70.0713C342.859 68.2138 342.3 67.5695 341.883 66.8962Z",
    fill: "#3A4682"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M341.778 73.3505L341.883 73.211M341.883 73.211L344.236 70.0713L341.883 66.8962C342.3 67.5695 342.859 68.2138 342.859 70.0713C342.859 71.9289 342.472 72.2903 341.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M340 65.2306C340.384 65.4561 341.297 66.105 341.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M341.569 56.5902C341.569 57.5271 341.126 58.464 340 59.0886L340 54.0918C341.126 54.7164 341.569 55.6533 341.569 56.5902Z",
    fill: "#3A4682"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M340 122.122L340 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M340 130.606L340 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M244.77 125.401L250 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M247.385 28.0663L250 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M244.613 51.6452C244.613 50.5522 245.816 49.4591 247.071 49.4591C247.393 49.4591 247.743 49.4935 248.067 49.5832C247.625 49.4839 247.254 49.5832 247.071 49.6153C246.182 49.7714 245.868 50.7083 245.868 51.6452C245.868 52.5821 244.613 52.7383 244.613 51.6452Z",
    fill: "#3A4682"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M248.64 49.8235C247.96 49.3913 247.328 49.57 247.071 49.6153C246.182 49.7714 245.868 50.7083 245.868 51.6452C245.868 52.5821 244.613 52.7383 244.613 51.6452C244.613 50.5522 245.816 49.4591 247.071 49.4591C248.042 49.4591 249.268 49.7714 249.268 50.9686C249.268 51.3329 249.372 51.8014 248.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M246.13 93.8585L250 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 25.0474C248.954 25.672 249.249 26.2966 250 26.713L250 23.3818C249.249 23.7982 248.954 24.4228 248.954 25.0474Z",
    fill: "#3A4682"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 82.3032C248.954 82.9279 249.249 83.5525 250 83.9689L250 80.6376C249.249 81.054 248.954 81.6786 248.954 82.3032Z",
    fill: "#3A4682"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 91.256C248.954 91.8806 249.249 92.5052 250 92.9216L250 89.5904C249.249 90.0068 248.954 90.6314 248.954 91.256Z",
    fill: "#3A4682"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 96.4611C248.954 97.0857 249.249 97.7103 250 98.1267L250 94.7955C249.249 95.2119 248.954 95.8365 248.954 96.4611Z",
    fill: "#3A4682"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M247.49 122.174C247.49 123.501 248.198 124.829 250 125.714L250 118.635C248.198 119.519 247.49 120.847 247.49 122.174Z",
    fill: "#3A4682"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M247.071 92.5052L245.293 93.8585L246.866 93.8585L248.849 93.8585L247.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M247.071 95.2118L245.293 93.8585L246.866 93.8585L248.849 93.8585L247.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M245.066 127.605L244.77 125.401L247.28 127.9L245.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M248.954 107.392C248.954 108.016 249.249 108.641 250 109.057L250 105.726C249.249 106.142 248.954 106.767 248.954 107.392Z",
    fill: "#3A4682"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41 61.4829L250 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M245.188 60.1296L243.41 61.4829L244.983 61.4829L246.966 61.4829L245.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M248.117 59.8173L245.764 56.6422L248.117 53.5025C247.528 54.4232 247.141 54.7846 247.141 56.6422C247.141 58.4997 247.7 59.144 248.117 59.8173Z",
    fill: "#3A4682"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M248.222 53.363L248.117 53.5025M248.117 53.5025L245.764 56.6422L248.117 59.8173C247.7 59.144 247.141 58.4997 247.141 56.6422C247.141 54.7846 247.528 54.4232 248.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M250 61.4829C249.616 61.2574 248.703 60.6085 248.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41 65.2306L250 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M245.188 66.5839L243.41 65.2306L244.983 65.2306L246.966 65.2306L245.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M248.117 66.8962L245.764 70.0713L248.117 73.211C247.528 72.2903 247.141 71.9289 247.141 70.0713C247.141 68.2138 247.7 67.5695 248.117 66.8962Z",
    fill: "#3A4682"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M248.222 73.3505L248.117 73.211M248.117 73.211L245.764 70.0713L248.117 66.8962C247.7 67.5695 247.141 68.2138 247.141 70.0713C247.141 71.9289 247.528 72.2903 248.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M250 65.2306C249.616 65.4561 248.703 66.105 248.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M248.431 56.5902C248.431 57.5271 248.874 58.464 250 59.0886L250 54.0918C248.874 54.7164 248.431 55.6533 248.431 56.5902Z",
    fill: "#3A4682"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M255.23 125.401L250 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M252.615 28.0663L250 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M255.387 51.6452C255.387 50.5522 254.184 49.4591 252.929 49.4591C252.607 49.4591 252.257 49.4935 251.933 49.5832C252.375 49.4839 252.746 49.5832 252.929 49.6153C253.818 49.7714 254.132 50.7083 254.132 51.6452C254.132 52.5821 255.387 52.7383 255.387 51.6452Z",
    fill: "#3A4682"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M251.36 49.8235C252.04 49.3913 252.672 49.57 252.929 49.6153C253.818 49.7714 254.132 50.7083 254.132 51.6452C254.132 52.5821 255.387 52.7383 255.387 51.6452C255.387 50.5522 254.184 49.4591 252.929 49.4591C251.958 49.4591 250.732 49.7714 250.732 50.9686C250.732 51.3329 250.628 51.8014 251.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M253.87 93.8585L250 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 25.0474C251.046 25.672 250.751 26.2966 250 26.713L250 23.3818C250.751 23.7982 251.046 24.4228 251.046 25.0474Z",
    fill: "#3A4682"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 82.3032C251.046 82.9279 250.751 83.5525 250 83.9689L250 80.6376C250.751 81.054 251.046 81.6786 251.046 82.3032Z",
    fill: "#3A4682"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 91.256C251.046 91.8806 250.751 92.5052 250 92.9216L250 89.5904C250.751 90.0068 251.046 90.6314 251.046 91.256Z",
    fill: "#3A4682"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 96.461C251.046 97.0856 250.751 97.7102 250 98.1266L250 94.7953C250.751 95.2117 251.046 95.8364 251.046 96.461Z",
    fill: "#3A4682"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M252.51 122.174C252.51 123.501 251.802 124.829 250 125.714L250 118.635C251.802 119.519 252.51 120.847 252.51 122.174Z",
    fill: "#3A4682"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M252.929 92.5052L254.707 93.8585L253.134 93.8585L251.151 93.8585L252.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M252.929 95.2118L254.707 93.8585L253.134 93.8585L251.151 93.8585L252.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M254.934 127.605L255.23 125.401L252.72 127.9L254.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M251.046 107.392C251.046 108.016 250.751 108.641 250 109.057L250 105.726C250.751 106.142 251.046 106.767 251.046 107.392Z",
    fill: "#3A4682"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M256.59 61.4829L250 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M254.812 60.1296L256.59 61.4829L255.017 61.4829L253.034 61.4829L254.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M251.883 59.8173L254.236 56.6422L251.883 53.5025C252.472 54.4232 252.859 54.7846 252.859 56.6422C252.859 58.4997 252.3 59.144 251.883 59.8173Z",
    fill: "#3A4682"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M251.778 53.363L251.883 53.5025M251.883 53.5025L254.236 56.6422L251.883 59.8173C252.3 59.144 252.859 58.4997 252.859 56.6422C252.859 54.7846 252.472 54.4232 251.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M250 61.4829C250.384 61.2574 251.297 60.6085 251.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M256.59 65.2306L250 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M254.812 66.5839L256.59 65.2306L255.017 65.2306L253.034 65.2306L254.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M251.883 66.8962L254.236 70.0713L251.883 73.211C252.472 72.2903 252.859 71.9289 252.859 70.0713C252.859 68.2138 252.3 67.5695 251.883 66.8962Z",
    fill: "#3A4682"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M251.778 73.3505L251.883 73.211M251.883 73.211L254.236 70.0713L251.883 66.8962C252.3 67.5695 252.859 68.2138 252.859 70.0713C252.859 71.9289 252.472 72.2903 251.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M250 65.2306C250.384 65.4561 251.297 66.105 251.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M251.569 56.5902C251.569 57.5271 251.126 58.464 250 59.0886L250 54.0918C251.126 54.7164 251.569 55.6533 251.569 56.5902Z",
    fill: "#3A4682"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M250 122.122L250 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M250 130.606L250 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M154.77 125.401L160 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M157.385 28.0663L160 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M154.613 51.6452C154.613 50.5522 155.816 49.4591 157.071 49.4591C157.393 49.4591 157.743 49.4935 158.067 49.5832C157.625 49.4839 157.254 49.5832 157.071 49.6153C156.182 49.7714 155.868 50.7083 155.868 51.6452C155.868 52.5821 154.613 52.7383 154.613 51.6452Z",
    fill: "#3A4682"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M158.64 49.8235C157.96 49.3913 157.328 49.57 157.071 49.6153C156.182 49.7714 155.868 50.7083 155.868 51.6452C155.868 52.5821 154.613 52.7383 154.613 51.6452C154.613 50.5522 155.816 49.4591 157.071 49.4591C158.042 49.4591 159.268 49.7714 159.268 50.9686C159.268 51.3329 159.372 51.8014 158.222 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M156.13 93.8585L160 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 25.0474C158.954 25.672 159.249 26.2966 160 26.713L160 23.3818C159.249 23.7982 158.954 24.4228 158.954 25.0474Z",
    fill: "#3A4682"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 82.3032C158.954 82.9279 159.249 83.5525 160 83.9689L160 80.6376C159.249 81.054 158.954 81.6786 158.954 82.3032Z",
    fill: "#3A4682"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 91.256C158.954 91.8806 159.249 92.5052 160 92.9216L160 89.5904C159.249 90.0068 158.954 90.6314 158.954 91.256Z",
    fill: "#3A4682"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 96.4611C158.954 97.0857 159.249 97.7103 160 98.1267L160 94.7955C159.249 95.2119 158.954 95.8365 158.954 96.4611Z",
    fill: "#3A4682"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M157.49 122.174C157.49 123.501 158.198 124.829 160 125.714L160 118.635C158.198 119.519 157.49 120.847 157.49 122.174Z",
    fill: "#3A4682"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M157.071 92.5052L155.293 93.8585L156.866 93.8585L158.849 93.8585L157.071 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M157.071 95.2118L155.293 93.8585L156.866 93.8585L158.849 93.8585L157.071 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M155.066 127.605L154.77 125.401L157.28 127.9L155.066 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M158.954 107.392C158.954 108.016 159.249 108.641 160 109.057L160 105.726C159.249 106.142 158.954 106.767 158.954 107.392Z",
    fill: "#3A4682"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M153.41 61.4829L160 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M155.188 60.1296L153.41 61.4829L154.983 61.4829L156.966 61.4829L155.188 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M158.117 59.8173L155.764 56.6422L158.117 53.5025C157.528 54.4232 157.141 54.7846 157.141 56.6422C157.141 58.4997 157.7 59.144 158.117 59.8173Z",
    fill: "#3A4682"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M158.222 53.363L158.117 53.5025M158.117 53.5025L155.764 56.6422L158.117 59.8173C157.7 59.144 157.141 58.4997 157.141 56.6422C157.141 54.7846 157.528 54.4232 158.117 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M160 61.4829C159.616 61.2574 158.703 60.6085 158.117 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M153.41 65.2306L160 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M155.188 66.5839L153.41 65.2306L154.983 65.2306L156.966 65.2306L155.188 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M158.117 66.8962L155.764 70.0713L158.117 73.211C157.528 72.2903 157.141 71.9289 157.141 70.0713C157.141 68.2138 157.7 67.5695 158.117 66.8962Z",
    fill: "#3A4682"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M158.222 73.3505L158.117 73.211M158.117 73.211L155.764 70.0713L158.117 66.8962C157.7 67.5695 157.141 68.2138 157.141 70.0713C157.141 71.9289 157.528 72.2903 158.117 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M160 65.2306C159.616 65.4561 158.703 66.105 158.117 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M158.431 56.5902C158.431 57.5271 158.874 58.464 160 59.0886L160 54.0918C158.874 54.7164 158.431 55.6533 158.431 56.5902Z",
    fill: "#3A4682"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M165.23 125.401L160 130.606",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M162.615 28.0663L160 30.0442",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M165.387 51.6452C165.387 50.5522 164.184 49.4591 162.929 49.4591C162.607 49.4591 162.257 49.4935 161.933 49.5832C162.375 49.4839 162.746 49.5832 162.929 49.6153C163.818 49.7714 164.132 50.7083 164.132 51.6452C164.132 52.5821 165.387 52.7383 165.387 51.6452Z",
    fill: "#3A4682"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M161.36 49.8235C162.04 49.3913 162.672 49.57 162.929 49.6153C163.818 49.7714 164.132 50.7083 164.132 51.6452C164.132 52.5821 165.387 52.7383 165.387 51.6452C165.387 50.5522 164.184 49.4591 162.929 49.4591C161.958 49.4591 160.732 49.7714 160.732 50.9686C160.732 51.3329 160.628 51.8014 161.778 53.3629",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M163.87 93.8585L160 93.8585",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 25.0474C161.046 25.672 160.751 26.2966 160 26.713L160 23.3818C160.751 23.7982 161.046 24.4228 161.046 25.0474Z",
    fill: "#3A4682"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 82.3032C161.046 82.9279 160.751 83.5525 160 83.9689L160 80.6376C160.751 81.054 161.046 81.6786 161.046 82.3032Z",
    fill: "#3A4682"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 91.256C161.046 91.8806 160.751 92.5052 160 92.9216L160 89.5904C160.751 90.0068 161.046 90.6314 161.046 91.256Z",
    fill: "#3A4682"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 96.461C161.046 97.0856 160.751 97.7102 160 98.1266L160 94.7953C160.751 95.2117 161.046 95.8364 161.046 96.461Z",
    fill: "#3A4682"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M162.51 122.174C162.51 123.501 161.802 124.829 160 125.714L160 118.635C161.802 119.519 162.51 120.847 162.51 122.174Z",
    fill: "#3A4682"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M162.929 92.5052L164.707 93.8585L163.134 93.8585L161.151 93.8585L162.929 92.5052Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M162.929 95.2118L164.707 93.8585L163.134 93.8585L161.151 93.8585L162.929 95.2118Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M164.934 127.605L165.23 125.401L162.72 127.9L164.934 127.605Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M161.046 107.392C161.046 108.016 160.751 108.641 160 109.057L160 105.726C160.751 106.142 161.046 106.767 161.046 107.392Z",
    fill: "#3A4682"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 61.4829L160 61.4829",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M164.812 60.1296L166.59 61.4829L165.017 61.4829L163.034 61.4829L164.812 60.1296Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M161.883 59.8173L164.236 56.6422L161.883 53.5025C162.472 54.4232 162.859 54.7846 162.859 56.6422C162.859 58.4997 162.3 59.144 161.883 59.8173Z",
    fill: "#3A4682"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M161.778 53.363L161.883 53.5025M161.883 53.5025L164.236 56.6422L161.883 59.8173C162.3 59.144 162.859 58.4997 162.859 56.6422C162.859 54.7846 162.472 54.4232 161.883 53.5025Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M160 61.4829C160.384 61.2574 161.297 60.6085 161.883 59.8173",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M166.59 65.2306L160 65.2306",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M164.812 66.5839L166.59 65.2306L165.017 65.2306L163.034 65.2306L164.812 66.5839Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M161.883 66.8962L164.236 70.0713L161.883 73.211C162.472 72.2903 162.859 71.9289 162.859 70.0713C162.859 68.2138 162.3 67.5695 161.883 66.8962Z",
    fill: "#3A4682"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M161.778 73.3505L161.883 73.211M161.883 73.211L164.236 70.0713L161.883 66.8962C162.3 67.5695 162.859 68.2138 162.859 70.0713C162.859 71.9289 162.472 72.2903 161.883 73.211Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M160 65.2306C160.384 65.4561 161.297 66.105 161.883 66.8962",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M161.569 56.5902C161.569 57.5271 161.126 58.464 160 59.0886L160 54.0918C161.126 54.7164 161.569 55.6533 161.569 56.5902Z",
    fill: "#3A4682"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M160 122.122L160 1.052",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M160 130.606L160 132.272",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "square"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M1080 140H1068L1060 132L1052 140H978L970 132L962 140H888L880 132L872 140H798L790 132L782 140H708L700 132L692 140H618L610 132L602 140H528L520 132L512 140H438L430 132L422 140H348L340 132L332 140H258L250 132L242 140H168L160 132L152 140H140",
    stroke: "#3A4682",
    strokeLinecap: "round"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8844 46.2208C55.7914 45.1276 53.4954 45.2375 52.2402 46.4928C51.9181 46.815 51.6023 47.1996 51.3678 47.6135C51.7114 47.0713 52.1816 46.7996 52.3964 46.649C53.4416 45.916 54.6923 46.5391 55.6292 47.4761C56.5661 48.4131 57.9775 47.3139 56.8844 46.2208Z",
    fill: "#3A4682"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0356 48.4264C51.2833 47.3142 52.0936 46.8613 52.3964 46.649C53.4416 45.916 54.6923 46.5391 55.6292 47.4761C56.5661 48.4131 57.9775 47.3139 56.8844 46.2208C55.7914 45.1276 53.4954 45.2375 52.2402 46.4928C51.2695 47.4637 50.3559 49.002 51.5531 50.1992C51.9174 50.5636 52.2813 51.1367 54.9933 51.5476",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9253 54.8561L61.3355 61.4465",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7938 55.281L67.9253 54.8561L66.3523 56.4293L64.3689 58.4128L64.7938 55.281Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5527 57.8978L60.7312 52.3687L55.2381 51.5826C56.7478 51.9142 57.4968 51.8881 59.3543 53.7458C61.2118 55.6034 61.2966 56.8074 61.5527 57.8978Z",
    fill: "#3A4682"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M54.994 51.5476L55.2381 51.5826M55.2381 51.5826L60.7312 52.3687L61.5527 57.8978C61.2966 56.8074 61.2118 55.6034 59.3543 53.7458C57.4968 51.8881 56.7478 51.9142 55.2381 51.5826Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3355 61.4466C61.4934 60.8374 61.7581 59.2749 61.5527 57.8979",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6724 58.6041L65.0825 65.1946",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2474 61.7359L71.6724 58.6041L70.0993 60.1773L68.116 62.1609L71.2474 61.7359Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6309 64.9773L74.1594 65.7989L74.9455 71.2925C74.6139 69.7827 74.64 69.0336 72.7825 67.1759C70.925 65.3182 69.7211 65.2335 68.6309 64.9773Z",
    fill: "#3A4682"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9804 71.5366L74.9455 71.2925M74.9455 71.2925L74.1594 65.7989L68.6309 64.9773C69.7211 65.2335 70.925 65.3182 72.7825 67.1759C74.64 69.0336 74.6139 69.7827 74.9455 71.2925Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0825 65.1945C65.6916 65.0365 67.254 64.7719 68.6309 64.9773",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0109 54.9844C58.9478 55.9214 59.4422 57.3009 58.9403 59.0522L53.9435 54.0549C55.6946 53.553 57.074 54.0474 58.0109 54.9844Z",
    fill: "#3A4682"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1119 56.9955C45.0189 55.9023 45.1288 53.6061 46.384 52.3508C46.7061 52.0287 47.0907 51.7128 47.5046 51.4783C46.9624 51.8219 46.6907 52.2922 46.5401 52.507C45.8072 53.5523 46.4303 54.8032 47.3671 55.7401C48.304 56.6771 47.205 58.0886 46.1119 56.9955Z",
    fill: "#3A4682"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3173 51.1461C47.2052 51.3938 46.7524 52.2042 46.5401 52.507C45.8072 53.5523 46.4303 54.8032 47.3671 55.7401C48.304 56.6771 47.205 58.0886 46.1119 56.9955C45.0189 55.9023 45.1288 53.6061 46.384 52.3508C47.3547 51.38 48.8929 50.4663 50.09 51.6636C50.4544 52.028 51.0274 52.3919 51.4383 55.1042",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7456 68.0367L61.3354 61.4463",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1705 64.905L54.7456 68.0367L56.3186 66.4636L58.302 64.48L55.1705 64.905Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7871 61.6636L52.2586 60.842L51.4725 55.3484C51.8041 56.8582 51.7779 57.6073 53.6355 59.465C55.493 61.3227 56.6968 61.4074 57.7871 61.6636Z",
    fill: "#3A4682"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4375 55.1042L51.4725 55.3484M51.4725 55.3484L52.2586 60.842L57.7871 61.6636C56.6968 61.4074 55.493 61.3227 53.6355 59.465C51.7779 57.6073 51.8041 56.8582 51.4725 55.3484Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3354 61.4464C60.7264 61.6044 59.164 61.869 57.787 61.6636",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4941 71.7848L65.084 65.1944",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6256 71.3598L58.4941 71.7848L60.0672 70.2116L62.0505 68.228L61.6256 71.3598Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8667 68.7431L65.6882 74.2721L71.1813 75.0583C69.6716 74.7266 68.9226 74.7528 67.0651 72.8951C65.2076 71.0374 65.1229 69.8335 64.8667 68.7431Z",
    fill: "#3A4682"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4254 75.0932L71.1813 75.0583M71.1813 75.0583L65.6882 74.2721L64.8667 68.7431C65.1229 69.8335 65.2076 71.0374 67.0651 72.8951C68.9226 74.7528 69.6716 74.7266 71.1813 75.0583Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M65.084 65.1943C64.926 65.8034 64.6614 67.366 64.8668 68.743",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8737 58.1224C55.8106 59.0593 57.19 59.5538 58.9411 59.0518L53.9443 54.0546C53.4424 55.8058 53.9368 57.1854 54.8737 58.1224Z",
    fill: "#3A4682"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4648 25.421L28.9703 28.9803",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4053 29.4738L28.9704 28.98",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7677 24.2368C26.2298 24.6981 26.4737 25.3774 26.2261 26.2397L23.7615 23.7791C24.6252 23.532 25.3056 23.7754 25.7677 24.2368Z",
    fill: "#3A4682"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2198 25.7821C24.682 26.2434 25.3623 26.4869 26.226 26.2397L23.7614 23.7792C23.5139 24.6414 23.7577 25.3207 24.2198 25.7821Z",
    fill: "#3A4682"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7712 81.235C83.232 81.6958 83.4751 82.3741 83.2283 83.2352L80.7706 80.778C81.6318 80.5312 82.3103 80.7743 82.7712 81.235Z",
    fill: "#3A4682"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2282 82.7779C81.689 83.2386 82.3675 83.4817 83.2288 83.2349L80.7711 80.7778C80.5242 81.6388 80.7674 82.3172 81.2282 82.7779Z",
    fill: "#3A4682"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M108.771 107.235C109.232 107.696 109.475 108.374 109.228 109.235L106.771 106.778C107.632 106.531 108.31 106.774 108.771 107.235Z",
    fill: "#3A4682"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M107.228 108.778C107.689 109.239 108.367 109.482 109.229 109.235L106.771 106.778C106.524 107.639 106.767 108.317 107.228 108.778Z",
    fill: "#3A4682"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M134.201 130.66C135.144 131.603 135.584 133.049 134.932 134.958L129.904 129.929C131.813 129.277 133.259 129.717 134.201 130.66Z",
    fill: "#3A4682"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M130.635 134.227C131.578 135.17 133.024 135.61 134.933 134.958L129.904 129.929C129.252 131.838 129.692 133.284 130.635 134.227Z",
    fill: "#3A4682"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2295 91.774L94.4922 94.5066",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3913 91.9304C93.8331 92.3714 94.0662 93.0207 93.8295 93.845L91.4734 91.493C92.2991 91.2567 92.9495 91.4894 93.3913 91.9304Z",
    fill: "#3A4682"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0729 95.6055C97.5147 96.0465 97.7478 96.6958 97.5112 97.52L95.1551 95.168C95.9807 94.9318 96.6312 95.1645 97.0729 95.6055Z",
    fill: "#3A4682"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6064 91.4832L97.8213 91.1832L96.7087 92.2939L95.3059 93.6943L95.6064 91.4832Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5208 93.3941L97.8213 91.1831L96.7087 92.2938L95.3059 93.6941L97.5208 93.3941Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7549 97.2389L94.4922 94.5063",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9118 93.4075C92.3536 93.8485 93.004 94.0812 93.8297 93.845L91.4736 91.493C91.2369 92.3172 91.47 92.9665 91.9118 93.4075Z",
    fill: "#3A4682"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5934 97.0824C96.0352 97.5234 96.6856 97.7561 97.5113 97.5199L95.1552 95.1679C94.9186 95.9921 95.1517 96.6414 95.5934 97.0824Z",
    fill: "#3A4682"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4636 95.6188L91.1631 97.8298L92.2757 96.7192L93.6785 95.3188L91.4636 95.6188Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3779 97.5297L91.1631 97.8297L92.2757 96.7191L93.6785 95.3187L93.3779 97.5297Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M134 134.007L0.999943 1.00648",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M131 138.006L138 138.006",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M133 139.506L131 138.006H135L133 139.506Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M138 131.007L138 138.007",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 133.007L138 131.007L138 135.007L139.5 133.007Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M138 138.007L140 140.007",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1568 68.8495C71.848 69.5405 72.2127 70.558 71.8425 71.8495L68.1561 68.164C69.448 67.7938 70.4656 68.1585 71.1568 68.8495Z",
    fill: "#3A4682"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8424 71.1637C69.5336 71.8547 70.5512 72.2194 71.8431 71.8492L68.1567 68.1637C67.7865 69.4552 68.1512 70.4727 68.8424 71.1637Z",
    fill: "#3A4682"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28L70 30",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M69 25.5C69 26.0625 69.282 26.625 70 27L70 24C69.282 24.375 69 24.9375 69 25.5Z",
    fill: "#3A4682"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M73 28L70 30",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M71 25.5C71 26.0625 70.718 26.625 70 27L70 24C70.718 24.375 71 24.9375 71 25.5Z",
    fill: "#3A4682"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1V30",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.12 723.786C1164.21 724.879 1166.5 724.769 1167.76 723.514C1168.08 723.192 1168.4 722.807 1168.63 722.393C1168.29 722.935 1167.82 723.207 1167.6 723.358C1166.56 724.091 1165.31 723.467 1164.37 722.53C1163.43 721.593 1162.02 722.693 1163.12 723.786Z",
    fill: "#3A4682"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.96 721.58C1168.72 722.692 1167.91 723.145 1167.6 723.358C1166.56 724.091 1165.31 723.467 1164.37 722.53C1163.43 721.593 1162.02 722.693 1163.12 723.786C1164.21 724.879 1166.5 724.769 1167.76 723.514C1168.73 722.543 1169.64 721.005 1168.45 719.807C1168.08 719.443 1167.72 718.87 1165.01 718.459",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M1152.07 715.151L1158.66 708.56",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.21 714.726L1152.07 715.151L1153.65 713.577L1155.63 711.594L1155.21 714.726Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.45 712.109L1159.27 717.638L1164.76 718.424C1163.25 718.092 1162.5 718.119 1160.65 716.261C1158.79 714.403 1158.7 713.199 1158.45 712.109Z",
    fill: "#3A4682"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.01 718.459L1164.76 718.424M1164.76 718.424L1159.27 717.638L1158.45 712.109C1158.7 713.199 1158.79 714.403 1160.65 716.261C1162.5 718.119 1163.25 718.092 1164.76 718.424Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.66 708.56C1158.51 709.169 1158.24 710.732 1158.45 712.109",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.33 711.402L1154.92 704.812",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.75 708.271L1148.33 711.402L1149.9 709.829L1151.88 707.846L1148.75 708.271Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.37 705.029L1145.84 704.208L1145.05 698.714C1145.39 700.224 1145.36 700.973 1147.22 702.831C1149.08 704.688 1150.28 704.773 1151.37 705.029Z",
    fill: "#3A4682"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M1145.02 698.47L1145.05 698.714M1145.05 698.714L1145.84 704.208L1151.37 705.029C1150.28 704.773 1149.08 704.688 1147.22 702.831C1145.36 700.973 1145.39 700.224 1145.05 698.714Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.92 704.812C1154.31 704.97 1152.75 705.235 1151.37 705.029",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.99 715.022C1161.05 714.085 1160.56 712.706 1161.06 710.954L1166.06 715.952C1164.31 716.454 1162.93 715.959 1161.99 715.022Z",
    fill: "#3A4682"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M1173.89 713.011C1174.98 714.104 1174.87 716.4 1173.62 717.656C1173.29 717.978 1172.91 718.294 1172.5 718.528C1173.04 718.185 1173.31 717.714 1173.46 717.5C1174.19 716.454 1173.57 715.203 1172.63 714.266C1171.7 713.329 1172.8 711.918 1173.89 713.011Z",
    fill: "#3A4682"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.68 718.861C1172.79 718.613 1173.25 717.802 1173.46 717.5C1174.19 716.454 1173.57 715.203 1172.63 714.266C1171.7 713.329 1172.8 711.918 1173.89 713.011C1174.98 714.104 1174.87 716.4 1173.62 717.656C1172.65 718.627 1171.11 719.54 1169.91 718.343C1169.55 717.979 1168.97 717.615 1168.56 714.902",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.25 701.97L1158.66 708.56",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.83 705.102L1165.25 701.97L1163.68 703.543L1161.7 705.527L1164.83 705.102Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.21 708.343L1167.74 709.165L1168.53 714.658C1168.2 713.148 1168.22 712.399 1166.36 710.542C1164.51 708.684 1163.3 708.599 1162.21 708.343Z",
    fill: "#3A4682"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.56 714.902L1168.53 714.658M1168.53 714.658L1167.74 709.165L1162.21 708.343C1163.3 708.599 1164.51 708.684 1166.36 710.542C1168.22 712.399 1168.2 713.148 1168.53 714.658Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.66 708.56C1159.27 708.402 1160.84 708.138 1162.21 708.343",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.51 698.222L1154.92 704.812",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.37 698.647L1161.51 698.222L1159.93 699.795L1157.95 701.779L1158.37 698.647Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.13 701.264L1154.31 695.734L1148.82 694.948C1150.33 695.28 1151.08 695.254 1152.93 697.111C1154.79 698.969 1154.88 700.173 1155.13 701.264Z",
    fill: "#3A4682"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.57 694.913L1148.82 694.948M1148.82 694.948L1154.31 695.734L1155.13 701.264C1154.88 700.173 1154.79 698.969 1152.93 697.111C1151.08 695.254 1150.33 695.28 1148.82 694.948Z",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M1154.92 704.812C1155.07 704.203 1155.34 702.641 1155.13 701.264",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M1165.13 711.884C1164.19 710.947 1162.81 710.453 1161.06 710.955L1166.06 715.952C1166.56 714.201 1166.06 712.821 1165.13 711.884Z",
    fill: "#3A4682"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M1190.54 744.586L1191.03 741.026",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.59 740.533L1191.03 741.027",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M1194.23 745.77C1193.77 745.308 1193.53 744.629 1193.77 743.767L1196.24 746.227C1195.37 746.475 1194.69 746.231 1194.23 745.77Z",
    fill: "#3A4682"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.78 744.225C1195.32 743.763 1194.64 743.52 1193.77 743.767L1196.24 746.227C1196.49 745.365 1196.24 744.686 1195.78 744.225Z",
    fill: "#3A4682"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.23 688.772C1136.77 688.311 1136.52 687.633 1136.77 686.771L1139.23 689.229C1138.37 689.475 1137.69 689.232 1137.23 688.772Z",
    fill: "#3A4682"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.77 687.229C1138.31 686.768 1137.63 686.525 1136.77 686.772L1139.23 689.229C1139.48 688.368 1139.23 687.689 1138.77 687.229Z",
    fill: "#3A4682"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.23 662.772C1110.77 662.311 1110.52 661.633 1110.77 660.771L1113.23 663.229C1112.37 663.475 1111.69 663.232 1111.23 662.772Z",
    fill: "#3A4682"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.77 661.229C1112.31 660.768 1111.63 660.525 1110.77 660.772L1113.23 663.229C1113.48 662.368 1113.23 661.689 1112.77 661.229Z",
    fill: "#3A4682"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M1085.8 639.347C1084.86 638.404 1084.42 636.958 1085.07 635.049L1090.1 640.078C1088.19 640.73 1086.74 640.29 1085.8 639.347Z",
    fill: "#3A4682"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M1089.36 635.78C1088.42 634.837 1086.98 634.397 1085.07 635.049L1090.1 640.078C1090.75 638.169 1090.31 636.723 1089.36 635.78Z",
    fill: "#3A4682"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.77 678.233L1125.51 675.5",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.61 678.076C1126.17 677.635 1125.93 676.986 1126.17 676.162L1128.53 678.514C1127.7 678.75 1127.05 678.517 1126.61 678.076Z",
    fill: "#3A4682"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.93 674.401C1122.49 673.96 1122.25 673.311 1122.49 672.487L1124.84 674.839C1124.02 675.075 1123.37 674.842 1122.93 674.401Z",
    fill: "#3A4682"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.39 678.523L1122.18 678.823L1123.29 677.713L1124.69 676.312L1124.39 678.523Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.48 676.612L1122.18 678.823L1123.29 677.713L1124.69 676.312L1122.48 676.612Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.25 672.768L1125.51 675.5",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.09 676.599C1127.65 676.158 1127 675.925 1126.17 676.162L1128.53 678.514C1128.76 677.689 1128.53 677.04 1128.09 676.599Z",
    fill: "#3A4682"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M1124.41 672.924C1123.96 672.483 1123.31 672.25 1122.49 672.487L1124.84 674.839C1125.08 674.014 1124.85 673.365 1124.41 672.924Z",
    fill: "#3A4682"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.54 674.388L1128.84 672.177L1127.72 673.287L1126.32 674.688L1128.54 674.388Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.62 672.477L1128.84 672.177L1127.72 673.288L1126.32 674.688L1126.62 672.477Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M1086 636L1219 769",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M1089 632L1082 632",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M1087 630.5L1089 632H1085L1087 630.5Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M1082 639L1082 632",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.5 637L1082 639L1082 635L1080.5 637Z",
    fill: "#3A4682",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M1082 632L1080 630",
    stroke: "#3A4682",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M1148.84 701.157C1148.15 700.466 1147.79 699.449 1148.16 698.157L1151.84 701.843C1150.55 702.213 1149.53 701.848 1148.84 701.157Z",
    fill: "#3A4682"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M1151.16 698.843C1150.47 698.152 1149.45 697.787 1148.16 698.157L1151.84 701.843C1152.21 700.551 1151.85 699.534 1151.16 698.843Z",
    fill: "#3A4682"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_307_174109",
    x: 121.293,
    y: 121.293,
    width: 977.414,
    height: 527.414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_307_174109"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_307_174109",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestContributionsBorder);
export default __webpack_public_path__ + "static/media/latest-contributions-border.c3cf43bdc2d75d53877faebd3a661191.svg";
export { ForwardRef as ReactComponent };